export const provinces = [
  { label: "Buenos Aires - Acassuso (+11)", value: "11" },
  { label: "Buenos Aires - Adrogué (+11)", value: "11" },
  { label: "Buenos Aires - Aeropuerto Internacional Ezeiza (+11)", value: "11" },
  { label: "Buenos Aires - Albertina (+11)", value: "11" },
  { label: "Buenos Aires - Aldo Bonzi (+11)", value: "11" },
  { label: "Buenos Aires - Área de Promoción El Triángulo (+11)", value: "11" },
  { label: "Buenos Aires - Avellaneda (+11)", value: "11" },
  { label: "Buenos Aires - Banfield (+11)", value: "11" },
  { label: "Buenos Aires - Beccar (+11)", value: "11" },
  { label: "Buenos Aires - Bella Vista (+11)", value: "11" },
  { label: "Buenos Aires - Berazategui (+11)", value: "11" },
  { label: "Buenos Aires - Bernal (+11)", value: "11" },
  { label: "Buenos Aires - Billinghurst (+11)", value: "11" },
  { label: "Buenos Aires - Bosques (+11)", value: "11" },
  { label: "Buenos Aires - Boulogne Sur Mer (+11)", value: "11" },
  { label: "Buenos Aires - Buenos Aires (+11)", value: "11" },
  { label: "Buenos Aires - Burzaco (+11)", value: "11" },
  { label: "Buenos Aires - Campo de Mayo (+11)", value: "11" },
  { label: "Buenos Aires - Canning (+11)", value: "11" },
  { label: "Buenos Aires - Caseros (+11)", value: "11" },
  { label: "Buenos Aires - Castelar (+11)", value: "11" },
  { label: "Buenos Aires - Churruca (+11)", value: "11" },
  { label: "Buenos Aires - Ciudad Evita (+11)", value: "11" },
  { label: "Buenos Aires - Ciudad Jardín Lomas del Palomar (+11)", value: "11" },
  { label: "Buenos Aires - Ciudadela (+11)", value: "11" },
  { label: "Buenos Aires - Claypole (+11)", value: "11" },
  { label: "Buenos Aires - Crucecita (+11)", value: "11" },
  { label: "Buenos Aires - Dock Sud (+11)", value: "11" },
  { label: "Buenos Aires - Don Bosco (+11)", value: "11" },
  { label: "Buenos Aires - Don Orione (+11)", value: "11" },
  { label: "Buenos Aires - Don Torcuato (+11)", value: "11" },
  { label: "Buenos Aires - El Jagüel (+11)", value: "11" },
  { label: "Buenos Aires - El Libertador (+11)", value: "11" },
  { label: "Buenos Aires - El Palomar (+11)", value: "11" },
  { label: "Buenos Aires - El Talar (+11)", value: "11" },
  { label: "Buenos Aires - Estanislao Zeballos (+11)", value: "11" },
  { label: "Buenos Aires - Ezeiza (+11)", value: "11" },
  { label: "Buenos Aires - Ezpeleta (+11)", value: "11" },
  { label: "Buenos Aires - Florencio Varela (+11)", value: "11" },
  { label: "Buenos Aires - General Pacheco (+11)", value: "11" },
  { label: "Buenos Aires - Gerli (+11)", value: "11" },
  { label: "Buenos Aires - Gobernador Julio A. Costa (+11)", value: "11" },
  { label: "Buenos Aires - Gregorio de Laferrère (+11)", value: "11" },
  { label: "Buenos Aires - Haedo (+11)", value: "11" },
  { label: "Buenos Aires - Hudson (+11)", value: "11" },
  { label: "Buenos Aires - Hurlingham (+11)", value: "11" },
  { label: "Buenos Aires - Ingeniero Adolfo Sourdeaux (+11)", value: "11" },
  { label: "Buenos Aires - Ingeniero Budge (+11)", value: "11" },
  { label: "Buenos Aires - Ingeniero Pablo Nogués (+11)", value: "11" },
  { label: "Buenos Aires - Isidro Casanova (+11)", value: "11" },
  { label: "Buenos Aires - Ituzaingó (+11)", value: "11" },
  { label: "Buenos Aires - José Ingenieros (+11)", value: "11" },
  { label: "Buenos Aires - José León Suárez (+11)", value: "11" },
  { label: "Buenos Aires - José Mármol (+11)", value: "11" },
  { label: "Buenos Aires - La Tablada (+11)", value: "11" },
  { label: "Buenos Aires - La Unión (+11)", value: "11" },
  { label: "Buenos Aires - Lanús (+11)", value: "11" },
  { label: "Buenos Aires - Llavallol (+11)", value: "11" },
  { label: "Buenos Aires - Loma Hermosa (+11)", value: "11" },
  { label: "Buenos Aires - Lomas de Zamora (+11)", value: "11" },
  { label: "Buenos Aires - Lomas del Mirador (+11)", value: "11" },
  { label: "Buenos Aires - Longchamps (+11)", value: "11" },
  { label: "Buenos Aires - Los Polvorines (+11)", value: "11" },
  { label: "Buenos Aires - Luis Guillón (+11)", value: "11" },
  { label: "Buenos Aires - Malvinas Argentinas (Almirante Brown) (+11)", value: "11" },
  { label: "Buenos Aires - Martín Coronado (+11)", value: "11" },
  { label: "Buenos Aires - Martínez (+11)", value: "11" },
  { label: "Buenos Aires - Ministro Rivadavia (+11)", value: "11" },
  { label: "Buenos Aires - Monte Chingolo (+11)", value: "11" },
  { label: "Buenos Aires - Monte Grande (+11)", value: "11" },
  { label: "Buenos Aires - Morón (+11)", value: "11" },
  { label: "Buenos Aires - Munro (+11)", value: "11" },
  { label: "Buenos Aires - Muñiz (+11)", value: "11" },
  { label: "Buenos Aires - Nordelta (+11)", value: "11" },
  { label: "Buenos Aires - Nueve de Abril (+11)", value: "11" },
  { label: "Buenos Aires - Olivos (+11)", value: "11" },
  { label: "Buenos Aires - Once de Septiembre (+11)", value: "11" },
  { label: "Buenos Aires - Pablo Podestá (+11)", value: "11" },
  { label: "Buenos Aires - Piñeyro (+11)", value: "11" },
  { label: "Buenos Aires - Plátanos (+11)", value: "11" },
  { label: "Buenos Aires - Quilmes (+11)", value: "11" },
  { label: "Buenos Aires - Rafael Calzada (+11)", value: "11" },
  { label: "Buenos Aires - Rafael Castillo (+11)", value: "11" },
  { label: "Buenos Aires - San Isidro (+11)", value: "11" },
  { label: "Buenos Aires - San José (+11)", value: "11" },
  { label: "Buenos Aires - San Justo (+11)", value: "11" },
  { label: "Buenos Aires - San Martín (+11)", value: "11" },
  { label: "Buenos Aires - San Miguel (+11)", value: "11" },
  { label: "Buenos Aires - Santa María (+11)", value: "11" },
  { label: "Buenos Aires - Santos Lugares (+11)", value: "11" },
  { label: "Buenos Aires - Sarandí (+11)", value: "11" },
  { label: "Buenos Aires - Solano (+11)", value: "11" },
  { label: "Buenos Aires - Sourigues (+11)", value: "11" },
  { label: "Buenos Aires - Tapiales (+11)", value: "11" },
  { label: "Buenos Aires - Villa Ballester (+11)", value: "11" },
  { label: "Buenos Aires - Villa Bosch (+11)", value: "11" },
  { label: "Buenos Aires - Villa Brown (+11)", value: "11" },
  { label: "Buenos Aires - Villa Centenario (+11)", value: "11" },
  { label: "Buenos Aires - Villa de Mayo (+11)", value: "11" },
  { label: "Buenos Aires - Villa Domínico (+11)", value: "11" },
  { label: "Buenos Aires - Villa España (+11)", value: "11" },
  { label: "Buenos Aires - Villa Fiorito (+11)", value: "11" },
  { label: "Buenos Aires - Villa La Florida (+11)", value: "11" },
  { label: "Buenos Aires - Villa Luzuriaga (+11)", value: "11" },
  { label: "Buenos Aires - Villa Lynch (+11)", value: "11" },
  { label: "Buenos Aires - Villa Madero (+11)", value: "11" },
  { label: "Buenos Aires - Villa Maipú (+11)", value: "11" },
  { label: "Buenos Aires - Villa Raffo (+11)", value: "11" },
  { label: "Buenos Aires - Villa San Luis (+11)", value: "11" },
  { label: "Buenos Aires - Villa Sarmiento (+11)", value: "11" },
  { label: "Buenos Aires - Villa Tesei (+11)", value: "11" },
  { label: "Buenos Aires - Villa Vatteone (+11)", value: "11" },
  { label: "Buenos Aires - Virreyes (+11)", value: "11" },
  { label: "Buenos Aires - Wilde (+11)", value: "11" },
  { label: "Buenos Aires - William C. Morris (+11)", value: "11" },
  { label: "Buenos Aires - General Hornos (+220)", value: "220" },
  { label: "Buenos Aires - General Las Heras (+220)", value: "220" },
  { label: "Buenos Aires - La Choza (+220)", value: "220" },
  { label: "Buenos Aires - Libertad (+220)", value: "220" },
  { label: "Buenos Aires - Marcos Paz (+220)", value: "220" },
  { label: "Buenos Aires - Mariano Acosta (+220)", value: "220" },
  { label: "Buenos Aires - Merlo (+220)", value: "220" },
  { label: "Buenos Aires - Parque San Martín (+220)", value: "220" },
  { label: "Buenos Aires - Plomer (+220)", value: "220" },
  { label: "Buenos Aires - Pontevedra (+220)", value: "220" },
  { label: "Buenos Aires - San Antonio de Padua (+220)", value: "220" },
  { label: "Buenos Aires - Veinte de Junio (+220)", value: "220" },
  { label: "Buenos Aires - Villars (+220)", value: "220" },
  { label: "Buenos Aires - Abasto (+221)", value: "221" },
  { label: "Buenos Aires - Ángel Etcheverry (+221)", value: "221" },
  { label: "Buenos Aires - Arturo Seguí (+221)", value: "221" },
  { label: "Buenos Aires - Barrio Banco Provincia (+221)", value: "221" },
  { label: "Buenos Aires - Barrio El Carmen Este (+221)", value: "221" },
  { label: "Buenos Aires - Barrio Universitario (+221)", value: "221" },
  { label: "Buenos Aires - Berisso (+221)", value: "221" },
  { label: "Buenos Aires - City Bell (+221)", value: "221" },
  { label: "Buenos Aires - Dique N° 1 (+221)", value: "221" },
  { label: "Buenos Aires - Ensenada (+221)", value: "221" },
  { label: "Buenos Aires - General Mansilla (Estación Bartolomé Bavio) (+221)", value: "221" },
  { label: "Buenos Aires - Ignacio Correas (+221)", value: "221" },
  { label: "Buenos Aires - Isla Santiago Oeste (+221)", value: "221" },
  { label: "Buenos Aires - Joaquín Gorina (+221)", value: "221" },
  { label: "Buenos Aires - José Hernández (+221)", value: "221" },
  { label: "Buenos Aires - José Melchor Romero (+221)", value: "221" },
  { label: "Buenos Aires - La Plata (+221)", value: "221" },
  { label: "Buenos Aires - Las Golondrinas (+221)", value: "221" },
  { label: "Buenos Aires - Lisandro Olmos (+221)", value: "221" },
  { label: "Buenos Aires - Lomas de Copello (+221)", value: "221" },
  { label: "Buenos Aires - Los Hornos (+221)", value: "221" },
  { label: "Buenos Aires - Los Naranjos (+221)", value: "221" },
  { label: "Buenos Aires - Los Talas (+221)", value: "221" },
  { label: "Buenos Aires - Manuel B. Gonnet (+221)", value: "221" },
  { label: "Buenos Aires - Punta Lara (+221)", value: "221" },
  { label: "Buenos Aires - Ringuelet (+221)", value: "221" },
  { label: "Buenos Aires - Tolosa (+221)", value: "221" },
  { label: "Buenos Aires - Villa Argüello (+221)", value: "221" },
  { label: "Buenos Aires - Villa Catella (+221)", value: "221" },
  { label: "Buenos Aires - Villa Dolores (+221)", value: "221" },
  { label: "Buenos Aires - Villa Elisa (+221)", value: "221" },
  { label: "Buenos Aires - Villa Elvira (+221)", value: "221" },
  { label: "Buenos Aires - Villa Garibaldi (+221)", value: "221" },
  { label: "Buenos Aires - Villa Independencia (+221)", value: "221" },
  { label: "Buenos Aires - Villa Nueva (+221)", value: "221" },
  { label: "Buenos Aires - Villa Porteña (+221)", value: "221" },
  { label: "Buenos Aires - Villa Porteña (+221)", value: "221" },
  { label: "Buenos Aires - Batán (+223)", value: "223" },
  { label: "Buenos Aires - Camet (+223)", value: "223" },
  { label: "Buenos Aires - Chapadmalal (+223)", value: "223" },
  { label: "Buenos Aires - Estación Chapadmalal (+223)", value: "223" },
  { label: "Buenos Aires - La Gloria de la Peregrina (+223)", value: "223" },
  { label: "Buenos Aires - Mar del Plata (+223)", value: "223" },
  { label: "Buenos Aires - Santa Clara del Mar (+223)", value: "223" },
  { label: "Buenos Aires - Sierra de los Padres (+223)", value: "223" },
  { label: "Buenos Aires - Arroyo de la Cruz (+230)", value: "230" },
  { label: "Buenos Aires - Del Viso (+230)", value: "230" },
  { label: "Buenos Aires - Diego Gaynor (+230)", value: "230" },
  { label: "Buenos Aires - Etchegoyen (+230)", value: "230" },
  { label: "Buenos Aires - Fátima (+230)", value: "230" },
  { label: "Buenos Aires - La Lonja (+230)", value: "230" },
  { label: "Buenos Aires - Los Cardales (+230)", value: "230" },
  { label: "Buenos Aires - Manuel Alberti (+230)", value: "230" },
  { label: "Buenos Aires - Manzanares (+230)", value: "230" },
  { label: "Buenos Aires - Parada Orlando (+230)", value: "230" },
  { label: "Buenos Aires - Pilar (+230)", value: "230" },
  { label: "Buenos Aires - Presidente Derqui (+230)", value: "230" },
  { label: "Buenos Aires - Villa Astolfi (+230)", value: "230" },
  { label: "Buenos Aires - Villa Rosa (+230)", value: "230" },
  { label: "Buenos Aires - Zelaya (+230)", value: "230" },
  { label: "Buenos Aires - Agustín Roca (+236)", value: "236" },
  { label: "Buenos Aires - Agustina (+236)", value: "236" },
  { label: "Buenos Aires - Baigorrita (+236)", value: "236" },
  { label: "Buenos Aires - Balneario Laguna de Gómez (+236)", value: "236" },
  { label: "Buenos Aires - Fortín Tiburcio (+236)", value: "236" },
  { label: "Buenos Aires - Junín (+236)", value: "236" },
  { label: "Buenos Aires - Laplacette (+236)", value: "236" },
  { label: "Buenos Aires - Leandro N. Alem (+236)", value: "236" },
  { label: "Buenos Aires - Morse (+236)", value: "236" },
  { label: "Buenos Aires - Saforcada (+236)", value: "236" },
  { label: "Buenos Aires - Cuartel V (+237)", value: "237" },
  { label: "Buenos Aires - Francisco Álvarez (+237)", value: "237" },
  { label: "Buenos Aires - General Rodríguez (+237)", value: "237" },
  { label: "Buenos Aires - La Reja (+237)", value: "237" },
  { label: "Buenos Aires - Moreno (+237)", value: "237" },
  { label: "Buenos Aires - Paso del Rey (+237)", value: "237" },
  { label: "Buenos Aires - Trujui (+237)", value: "237" },
  { label: "Buenos Aires - De la Canal (+249)", value: "249" },
  { label: "Buenos Aires - Desvío Aguirre (+249)", value: "249" },
  { label: "Buenos Aires - Fulton (+249)", value: "249" },
  { label: "Buenos Aires - Gardey (+249)", value: "249" },
  { label: "Buenos Aires - María Ignacia (Estación Vela) (+249)", value: "249" },
  { label: "Buenos Aires - Tandil (+249)", value: "249" },
  { label: "Buenos Aires - Bahía Blanca (+291)", value: "291" },
  { label: "Buenos Aires - Balneario La Chiquita (+291)", value: "291" },
  { label: "Buenos Aires - Cabildo (+291)", value: "291" },
  { label: "Buenos Aires - Chasicó (+291)", value: "291" },
  { label: "Buenos Aires - Colonia Monte La Plata (+291)", value: "291" },
  { label: "Buenos Aires - Colonia San Adolfo (+291)", value: "291" },
  { label: "Buenos Aires - General Daniel Cerri (+291)", value: "291" },
  { label: "Buenos Aires - Grünbein (+291)", value: "291" },
  { label: "Buenos Aires - Ingeniero White (+291)", value: "291" },
  { label: "Buenos Aires - Juan Cousté (+291)", value: "291" },
  { label: "Buenos Aires - Mayor Buratovich (+291)", value: "291" },
  { label: "Buenos Aires - Saldungaray (+291)", value: "291" },
  { label: "Buenos Aires - Sierra de la Ventana (+291)", value: "291" },
  { label: "Buenos Aires - Teniente Origone (+291)", value: "291" },
  { label: "Buenos Aires - Tornquist (+291)", value: "291" },
  { label: "Buenos Aires - Tres Picos (+291)", value: "291" },
  { label: "Buenos Aires - Villa Arcadia (+291)", value: "291" },
  { label: "Buenos Aires - Villa Bordeu (+291)", value: "291" },
  { label: "Buenos Aires - Villa Espora (+291)", value: "291" },
  { label: "Buenos Aires - Villa Serrana La Gruta (+291)", value: "291" },
  { label: "Buenos Aires - Villa Ventana (+291)", value: "291" },
  { label: "Buenos Aires - Belén de Escobar (+348)", value: "348" },
  { label: "Buenos Aires - Dique Luján (+348)", value: "348" },
  { label: "Buenos Aires - Garín (+348)", value: "348" },
  { label: "Buenos Aires - Ingeniero Maschwitz (+348)", value: "348" },
  { label: "Buenos Aires - Loma Verde (+348)", value: "348" },
  { label: "Buenos Aires - Maquinista F. Savio (+348)", value: "348" },
  { label: "Buenos Aires - Matheu (+348)", value: "348" },
  { label: "Buenos Aires - Puerto Paraná (+348)", value: "348" },
  { label: "Buenos Aires - González Catán (+2202)", value: "2202" },
  { label: "Buenos Aires - Virrey del Pino (+2202)", value: "2202" },
  { label: "Buenos Aires - Altamirano (+2223)", value: "2223" },
  { label: "Buenos Aires - Brandsen (+2223)", value: "2223" },
  { label: "Buenos Aires - Gómez (+2223)", value: "2223" },
  { label: "Buenos Aires - Jeppener (+2223)", value: "2223" },
  { label: "Buenos Aires - Las Acacias (+2223)", value: "2223" },
  { label: "Buenos Aires - Loma Verde (+2223)", value: "2223" },
  { label: "Buenos Aires - Glew (+2224)", value: "2224" },
  { label: "Buenos Aires - Guernica (+2224)", value: "2224" },
  { label: "Buenos Aires - Alejandro Korn (+2225)", value: "2225" },
  { label: "Buenos Aires - Domselaar (+2225)", value: "2225" },
  { label: "Buenos Aires - La Capilla (+2225)", value: "2225" },
  { label: "Buenos Aires - San Vicente (+2225)", value: "2225" },
  { label: "Buenos Aires - Alejandro Petión (+2226)", value: "2226" },
  { label: "Buenos Aires - Cañuelas (+2226)", value: "2226" },
  { label: "Buenos Aires - El Taladro (+2226)", value: "2226" },
  { label: "Buenos Aires - Gobernador Udaondo (+2226)", value: "2226" },
  { label: "Buenos Aires - Santa Rosa (+2226)", value: "2226" },
  { label: "Buenos Aires - Uribelarrea (+2226)", value: "2226" },
  { label: "Buenos Aires - Vicente Casares (+2226)", value: "2226" },
  { label: "Buenos Aires - Antonio Carboni (+2227)", value: "2227" },
  { label: "Buenos Aires - Carlos Beguerie (+2227)", value: "2227" },
  { label: "Buenos Aires - Elvira (+2227)", value: "2227" },
  { label: "Buenos Aires - Empalme Lobos (+2227)", value: "2227" },
  { label: "Buenos Aires - Lobos (+2227)", value: "2227" },
  { label: "Buenos Aires - Roque Pérez (+2227)", value: "2227" },
  { label: "Buenos Aires - Salvador María (+2227)", value: "2227" },
  { label: "Buenos Aires - Zapiola (+2227)", value: "2227" },
  { label: "Buenos Aires - El Pato (+2229)", value: "2229" },
  { label: "Buenos Aires - Ingeniero Juan Allan (+2229)", value: "2229" },
  { label: "Buenos Aires - Juan María Gutiérrez (+2229)", value: "2229" },
  { label: "Buenos Aires - Pereyra (+2229)", value: "2229" },
  { label: "Buenos Aires - Alegre (+2241)", value: "2241" },
  { label: "Buenos Aires - Chascomús (+2241)", value: "2241" },
  { label: "Buenos Aires - Ranchos (+2241)", value: "2241" },
  { label: "Buenos Aires - Samborombón (+2241)", value: "2241" },
  { label: "Buenos Aires - Casalins (+2242)", value: "2242" },
  { label: "Buenos Aires - Lezama (+2242)", value: "2242" },
  { label: "Buenos Aires - Pila (+2242)", value: "2242" },
  { label: "Buenos Aires - Barrio Río Salado (+2243)", value: "2243" },
  { label: "Buenos Aires - General Belgrano (+2243)", value: "2243" },
  { label: "Buenos Aires - Villanueva (+2243)", value: "2243" },
  { label: "Buenos Aires - Coronel Boerr (+2244)", value: "2244" },
  { label: "Buenos Aires - El Trigo (+2244)", value: "2244" },
  { label: "Buenos Aires - Las Flores (+2244)", value: "2244" },
  { label: "Buenos Aires - Pardo (+2244)", value: "2244" },
  { label: "Buenos Aires - Castelli (+2245)", value: "2245" },
  { label: "Buenos Aires - Centro Guerrero (+2245)", value: "2245" },
  { label: "Buenos Aires - Cerro de la Gloria (+2245)", value: "2245" },
  { label: "Buenos Aires - Dolores (+2245)", value: "2245" },
  { label: "Buenos Aires - General Conesa (+2245)", value: "2245" },
  { label: "Buenos Aires - Sevigne (+2245)", value: "2245" },
  { label: "Buenos Aires - Villa Roch (+2245)", value: "2245" },
  { label: "Buenos Aires - Costa Chica (+2246)", value: "2246" },
  { label: "Buenos Aires - Costa del Este (+2246)", value: "2246" },
  { label: "Buenos Aires - Las Toninas (+2246)", value: "2246" },
  { label: "Buenos Aires - Mar del Tuyú (+2246)", value: "2246" },
  { label: "Buenos Aires - Santa Teresita (+2246)", value: "2246" },
  { label: "Buenos Aires - Chacras de San Clemente (+2252)", value: "2252" },
  { label: "Buenos Aires - General Lavalle (+2252)", value: "2252" },
  { label: "Buenos Aires - San Clemente del Tuyú (+2252)", value: "2252" },
  { label: "Buenos Aires - Cariló (+2254)", value: "2254" },
  { label: "Buenos Aires - Ostende (+2254)", value: "2254" },
  { label: "Buenos Aires - Pinamar (+2254)", value: "2254" },
  { label: "Buenos Aires - Valeria del Mar (+2254)", value: "2254" },
  { label: "Buenos Aires - Las Gaviotas (+2255)", value: "2255" },
  { label: "Buenos Aires - Mar Azul (+2255)", value: "2255" },
  { label: "Buenos Aires - Mar de las Pampas (+2255)", value: "2255" },
  { label: "Buenos Aires - Villa Gesell (+2255)", value: "2255" },
  { label: "Buenos Aires - Aguas Verdes (+2257)", value: "2257" },
  { label: "Buenos Aires - Costa Azul (+2257)", value: "2257" },
  { label: "Buenos Aires - Costa Esmeralda (+2257)", value: "2257" },
  { label: "Buenos Aires - La Lucila del Mar (+2257)", value: "2257" },
  { label: "Buenos Aires - Mar de Ajó (+2257)", value: "2257" },
  { label: "Buenos Aires - Nueva Atlantis (+2257)", value: "2257" },
  { label: "Buenos Aires - Pavón (+2257)", value: "2257" },
  { label: "Buenos Aires - San Bernardo del Tuyú (+2257)", value: "2257" },
  { label: "Buenos Aires - Arenas Verdes (+2261)", value: "2261" },
  { label: "Buenos Aires - Licenciado Matienzo (+2261)", value: "2261" },
  { label: "Buenos Aires - Lobería (+2261)", value: "2261" },
  { label: "Buenos Aires - Pieres (+2261)", value: "2261" },
  { label: "Buenos Aires - San Manuel (+2261)", value: "2261" },
  { label: "Buenos Aires - Tamangueyú (+2261)", value: "2261" },
  { label: "Buenos Aires - Balneario Costa Bonita (+2262)", value: "2262" },
  { label: "Buenos Aires - Balneario Los Ángeles (+2262)", value: "2262" },
  { label: "Buenos Aires - Energía (+2262)", value: "2262" },
  { label: "Buenos Aires - Necochea (+2262)", value: "2262" },
  { label: "Buenos Aires - Quequén (+2262)", value: "2262" },
  { label: "Buenos Aires - Claraz (+2264)", value: "2264" },
  { label: "Buenos Aires - Juan Fernández (+2264)", value: "2264" },
  { label: "Buenos Aires - Nicanor Olivera (Est. La Dulce) (+2264)", value: "2264" },
  { label: "Buenos Aires - Ramón Santamarina (+2264)", value: "2264" },
  { label: "Buenos Aires - Coronel Vidal (+2265)", value: "2265" },
  { label: "Buenos Aires - General Pirán (+2265)", value: "2265" },
  { label: "Buenos Aires - La Armonía (+2265)", value: "2265" },
  { label: "Buenos Aires - Mar Chiquita (+2265)", value: "2265" },
  { label: "Buenos Aires - Mar de Cobo (+2265)", value: "2265" },
  { label: "Buenos Aires - Vivoratá (+2265)", value: "2265" },
  { label: "Buenos Aires - Balcarce (+2266)", value: "2266" },
  { label: "Buenos Aires - Los Pinos (+2266)", value: "2266" },
  { label: "Buenos Aires - Mechongué (+2266)", value: "2266" },
  { label: "Buenos Aires - Napaleofú (+2266)", value: "2266" },
  { label: "Buenos Aires - Ramos Otero (+2266)", value: "2266" },
  { label: "Buenos Aires - San Agustín (+2266)", value: "2266" },
  { label: "Buenos Aires - Villa Laguna La Brava (+2266)", value: "2266" },
  { label: "Buenos Aires - General Juan Madariaga (+2267)", value: "2267" },
  { label: "Buenos Aires - General Guido (+2268)", value: "2268" },
  { label: "Buenos Aires - Labardén (+2268)", value: "2268" },
  { label: "Buenos Aires - Las Armas (+2268)", value: "2268" },
  { label: "Buenos Aires - Maipú (+2268)", value: "2268" },
  { label: "Buenos Aires - Santo Domingo (+2268)", value: "2268" },
  { label: "Buenos Aires - Abbott (+2271)", value: "2271" },
  { label: "Buenos Aires - Gorchs (+2271)", value: "2271" },
  { label: "Buenos Aires - San Miguel del Monte (+2271)", value: "2271" },
  { label: "Buenos Aires - Zenón Videla Dorna (+2271)", value: "2271" },
  { label: "Buenos Aires - José Juan Almeyra (+2272)", value: "2272" },
  { label: "Buenos Aires - Las Marianas (+2272)", value: "2272" },
  { label: "Buenos Aires - Navarro (+2272)", value: "2272" },
  { label: "Buenos Aires - Villa Moll (+2272)", value: "2272" },
  { label: "Buenos Aires - Carmen de Areco (+2273)", value: "2273" },
  { label: "Buenos Aires - Pueblo Gouin (+2273)", value: "2273" },
  { label: "Buenos Aires - Tres Sargentos (+2273)", value: "2273" },
  { label: "Buenos Aires - Carlos Spegazzini (+2274)", value: "2274" },
  { label: "Buenos Aires - Máximo Paz (+2274)", value: "2274" },
  { label: "Buenos Aires - Ariel (+2281)", value: "2281" },
  { label: "Buenos Aires - Azul (+2281)", value: "2281" },
  { label: "Buenos Aires - Cacharí (+2281)", value: "2281" },
  { label: "Buenos Aires - Chillar (+2281)", value: "2281" },
  { label: "Buenos Aires - Dieciséis de Julio (+2281)", value: "2281" },
  { label: "Buenos Aires - Crotto (+2283)", value: "2283" },
  { label: "Buenos Aires - Tapalqué (+2283)", value: "2283" },
  { label: "Buenos Aires - Velloso (+2283)", value: "2283" },
  { label: "Buenos Aires - Blanca Grande (+2284)", value: "2284" },
  { label: "Buenos Aires - Colonia Hinojo (+2284)", value: "2284" },
  { label: "Buenos Aires - Colonia Nievas (+2284)", value: "2284" },
  { label: "Buenos Aires - Colonia San Miguel (+2284)", value: "2284" },
  { label: "Buenos Aires - Espigas (+2284)", value: "2284" },
  { label: "Buenos Aires - Hinojo (+2284)", value: "2284" },
  { label: "Buenos Aires - Loma Negra (+2284)", value: "2284" },
  { label: "Buenos Aires - Olavarría (+2284)", value: "2284" },
  { label: "Buenos Aires - Recalde (+2284)", value: "2284" },
  { label: "Buenos Aires - Santa Luisa (+2284)", value: "2284" },
  { label: "Buenos Aires - Sierra Chica (+2284)", value: "2284" },
  { label: "Buenos Aires - Sierras Bayas (+2284)", value: "2284" },
  { label: "Buenos Aires - Villa La Serranía (+2284)", value: "2284" },
  { label: "Buenos Aires - Laprida (+2285)", value: "2285" },
  { label: "Buenos Aires - Pueblo Nuevo (+2285)", value: "2285" },
  { label: "Buenos Aires - Pueblo San Jorge (+2285)", value: "2285" },
  { label: "Buenos Aires - General La Madrid (+2286)", value: "2286" },
  { label: "Buenos Aires - La Colina (+2286)", value: "2286" },
  { label: "Buenos Aires - Las Martinetas (+2286)", value: "2286" },
  { label: "Buenos Aires - Líbano (+2286)", value: "2286" },
  { label: "Buenos Aires - Centinela del Mar (+2291)", value: "2291" },
  { label: "Buenos Aires - Comandante Nicanor Otamendi (+2291)", value: "2291" },
  { label: "Buenos Aires - Mar del Sud (+2291)", value: "2291" },
  { label: "Buenos Aires - Miramar (+2291)", value: "2291" },
  { label: "Buenos Aires - Barker (+2292)", value: "2292" },
  { label: "Buenos Aires - Benito Juárez (+2292)", value: "2292" },
  { label: "Buenos Aires - Estación López (+2292)", value: "2292" },
  { label: "Buenos Aires - Tedín Uriburu (+2292)", value: "2292" },
  { label: "Buenos Aires - Villa Cacique (+2292)", value: "2292" },
  { label: "Buenos Aires - Ayacucho (+2296)", value: "2296" },
  { label: "Buenos Aires - La Constancia (+2296)", value: "2296" },
  { label: "Buenos Aires - Solanet (+2296)", value: "2296" },
  { label: "Buenos Aires - Udaquiola (+2296)", value: "2296" },
  { label: "Buenos Aires - Egaña (+2297)", value: "2297" },
  { label: "Buenos Aires - Martín Colman (+2297)", value: "2297" },
  { label: "Buenos Aires - Miranda (+2297)", value: "2297" },
  { label: "Buenos Aires - Rauch (+2297)", value: "2297" },
  { label: "Buenos Aires - González Moreno (+2302)", value: "2302" },
  { label: "Buenos Aires - Coraceros (+2314)", value: "2314" },
  { label: "Buenos Aires - Hale (+2314)", value: "2314" },
  { label: "Buenos Aires - Henderson (+2314)", value: "2314" },
  { label: "Buenos Aires - Herrera Vegas (+2314)", value: "2314" },
  { label: "Buenos Aires - Juan F. Ibarra (+2314)", value: "2314" },
  { label: "Buenos Aires - María Lucila (+2314)", value: "2314" },
  { label: "Buenos Aires - Mariano Unzué (+2314)", value: "2314" },
  { label: "Buenos Aires - Paula (+2314)", value: "2314" },
  { label: "Buenos Aires - Pirovano (+2314)", value: "2314" },
  { label: "Buenos Aires - San Carlos de Bolívar (+2314)", value: "2314" },
  { label: "Buenos Aires - Urdampilleta (+2314)", value: "2314" },
  { label: "Buenos Aires - Villa Lynch Pueyrredón (+2314)", value: "2314" },
  { label: "Buenos Aires - Andant (+2316)", value: "2316" },
  { label: "Buenos Aires - Arboledas (+2316)", value: "2316" },
  { label: "Buenos Aires - Daireaux (+2316)", value: "2316" },
  { label: "Buenos Aires - La Larga (+2316)", value: "2316" },
  { label: "Buenos Aires - Alfredo Demarchi (+2317)", value: "2317" },
  { label: "Buenos Aires - Carlos María Naón (+2317)", value: "2317" },
  { label: "Buenos Aires - Doce de Octubre (+2317)", value: "2317" },
  { label: "Buenos Aires - Dudignac (+2317)", value: "2317" },
  { label: "Buenos Aires - La Aurora (+2317)", value: "2317" },
  { label: "Buenos Aires - Manuel B. Gonnet (+2317)", value: "2317" },
  { label: "Buenos Aires - Marcelino Ugarte (+2317)", value: "2317" },
  { label: "Buenos Aires - Morea (+2317)", value: "2317" },
  { label: "Buenos Aires - Norumbega (+2317)", value: "2317" },
  { label: "Buenos Aires - Nueve de Julio (+2317)", value: "2317" },
  { label: "Buenos Aires - Patricios (+2317)", value: "2317" },
  { label: "Buenos Aires - Santos Unzué (+2317)", value: "2317" },
  { label: "Buenos Aires - Villa General Fournier (+2317)", value: "2317" },
  { label: "Buenos Aires - Grand Bourg (+2320)", value: "2320" },
  { label: "Buenos Aires - José C. Paz (+2320)", value: "2320" },
  { label: "Buenos Aires - Malvinas Argentinas (+2320)", value: "2320" },
  { label: "Buenos Aires - Tortuguitas (+2320)", value: "2320" },
  { label: "Buenos Aires - Capilla del Señor (+2323)", value: "2323" },
  { label: "Buenos Aires - Carlos Keen (+2323)", value: "2323" },
  { label: "Buenos Aires - Cortines (+2323)", value: "2323" },
  { label: "Buenos Aires - El Remanso (+2323)", value: "2323" },
  { label: "Buenos Aires - José María Jáuregui (+2323)", value: "2323" },
  { label: "Buenos Aires - Lezica y Torrezuri (+2323)", value: "2323" },
  { label: "Buenos Aires - Luján (+2323)", value: "2323" },
  { label: "Buenos Aires - Olivera (+2323)", value: "2323" },
  { label: "Buenos Aires - Open Door (+2323)", value: "2323" },
  { label: "Buenos Aires - Parada Robles (+2323)", value: "2323" },
  { label: "Buenos Aires - Pavón (+2323)", value: "2323" },
  { label: "Buenos Aires - Torres (+2323)", value: "2323" },
  { label: "Buenos Aires - Villa Ruiz (+2323)", value: "2323" },
  { label: "Buenos Aires - Agote (+2324)", value: "2324" },
  { label: "Buenos Aires - General Rivas (+2324)", value: "2324" },
  { label: "Buenos Aires - Goldney (+2324)", value: "2324" },
  { label: "Buenos Aires - Gowland (+2324)", value: "2324" },
  { label: "Buenos Aires - Mercedes (+2324)", value: "2324" },
  { label: "Buenos Aires - Suipacha (+2324)", value: "2324" },
  { label: "Buenos Aires - Tomás Jofré (+2324)", value: "2324" },
  { label: "Buenos Aires - Azcuénaga (+2325)", value: "2325" },
  { label: "Buenos Aires - Cucullú (+2325)", value: "2325" },
  { label: "Buenos Aires - Franklin (+2325)", value: "2325" },
  { label: "Buenos Aires - San Andrés de Giles (+2325)", value: "2325" },
  { label: "Buenos Aires - Villa Espil (+2325)", value: "2325" },
  { label: "Buenos Aires - Duggan (+2326)", value: "2326" },
  { label: "Buenos Aires - San Antonio de Areco (+2326)", value: "2326" },
  { label: "Buenos Aires - Solís (+2326)", value: "2326" },
  { label: "Buenos Aires - Vagués (+2326)", value: "2326" },
  { label: "Buenos Aires - Villa Lía (+2326)", value: "2326" },
  { label: "Buenos Aires - América (+2337)", value: "2337" },
  { label: "Buenos Aires - Fortín Olavarría (+2337)", value: "2337" },
  { label: "Buenos Aires - Mira Pampa (+2337)", value: "2337" },
  { label: "Buenos Aires - Roosevelt (+2337)", value: "2337" },
  { label: "Buenos Aires - San Mauricio (+2337)", value: "2337" },
  { label: "Buenos Aires - Sansinena (+2337)", value: "2337" },
  { label: "Buenos Aires - Sundblad (+2337)", value: "2337" },
  { label: "Buenos Aires - Asamblea (+2342)", value: "2342" },
  { label: "Buenos Aires - Bragado (+2342)", value: "2342" },
  { label: "Buenos Aires - Comodoro Py (+2342)", value: "2342" },
  { label: "Buenos Aires - Eduardo O'Brien (+2342)", value: "2342" },
  { label: "Buenos Aires - La Limpia (+2342)", value: "2342" },
  { label: "Buenos Aires - Máximo Fernández (+2342)", value: "2342" },
  { label: "Buenos Aires - Mechita (+2342)", value: "2342" },
  { label: "Buenos Aires - Warnes (+2342)", value: "2342" },
  { label: "Buenos Aires - Norberto de La Riestra (+2343)", value: "2343" },
  { label: "Buenos Aires - Pedernales (+2343)", value: "2343" },
  { label: "Buenos Aires - Álvarez de Toledo (+2344)", value: "2344" },
  { label: "Buenos Aires - Cazón (+2344)", value: "2344" },
  { label: "Buenos Aires - Del Carril (+2344)", value: "2344" },
  { label: "Buenos Aires - General Alvear (+2344)", value: "2344" },
  { label: "Buenos Aires - Juan José Blaquier (+2344)", value: "2344" },
  { label: "Buenos Aires - Polvaredas (+2344)", value: "2344" },
  { label: "Buenos Aires - Saladillo (+2344)", value: "2344" },
  { label: "Buenos Aires - Agustín Mosconi (+2345)", value: "2345" },
  { label: "Buenos Aires - Del Valle (+2345)", value: "2345" },
  { label: "Buenos Aires - Lucas Monteverde (+2345)", value: "2345" },
  { label: "Buenos Aires - San Enrique (+2345)", value: "2345" },
  { label: "Buenos Aires - Valdés (+2345)", value: "2345" },
  { label: "Buenos Aires - Veinticinco de Mayo (+2345)", value: "2345" },
  { label: "Buenos Aires - Alberti (+2346)", value: "2346" },
  { label: "Buenos Aires - Benítez (+2346)", value: "2346" },
  { label: "Buenos Aires - Chivilcoy (+2346)", value: "2346" },
  { label: "Buenos Aires - Coronel Seguí (+2346)", value: "2346" },
  { label: "Buenos Aires - Emilio Ayarza (+2346)", value: "2346" },
  { label: "Buenos Aires - Gobernador Ugarte (+2346)", value: "2346" },
  { label: "Buenos Aires - Gorostiaga (+2346)", value: "2346" },
  { label: "Buenos Aires - Henry Bell (+2346)", value: "2346" },
  { label: "Buenos Aires - Indacochea (+2346)", value: "2346" },
  { label: "Buenos Aires - La Rica (+2346)", value: "2346" },
  { label: "Buenos Aires - Moquehuá (+2346)", value: "2346" },
  { label: "Buenos Aires - Palemon Huergo (+2346)", value: "2346" },
  { label: "Buenos Aires - Plá (+2346)", value: "2346" },
  { label: "Buenos Aires - Ramón Biaus (+2346)", value: "2346" },
  { label: "Buenos Aires - San Sebastián (+2346)", value: "2346" },
  { label: "Buenos Aires - Villa Grisolía (+2346)", value: "2346" },
  { label: "Buenos Aires - Villa María (+2346)", value: "2346" },
  { label: "Buenos Aires - Villa Ortiz (+2346)", value: "2346" },
  { label: "Buenos Aires - Castilla (+2352)", value: "2352" },
  { label: "Buenos Aires - Chacabuco (+2352)", value: "2352" },
  { label: "Buenos Aires - Irala (+2352)", value: "2352" },
  { label: "Buenos Aires - Los Ángeles (+2352)", value: "2352" },
  { label: "Buenos Aires - O'Higgins (+2352)", value: "2352" },
  { label: "Buenos Aires - Olascoaga (+2352)", value: "2352" },
  { label: "Buenos Aires - Rawson (+2352)", value: "2352" },
  { label: "Buenos Aires - Arribeños (+2353)", value: "2353" },
  { label: "Buenos Aires - Ascensión (+2353)", value: "2353" },
  { label: "Buenos Aires - Estación Arenales (+2353)", value: "2353" },
  { label: "Buenos Aires - Ferré (+2353)", value: "2353" },
  { label: "Buenos Aires - General Arenales (+2353)", value: "2353" },
  { label: "Buenos Aires - La Angelita (+2353)", value: "2353" },
  { label: "Buenos Aires - La Trinidad (+2353)", value: "2353" },
  { label: "Buenos Aires - Alberdi Viejo (+2354)", value: "2354" },
  { label: "Buenos Aires - Colonia San Ricardo (+2354)", value: "2354" },
  { label: "Buenos Aires - El Dorado (+2354)", value: "2354" },
  { label: "Buenos Aires - Fortín Acha (+2354)", value: "2354" },
  { label: "Buenos Aires - Juan Bautista Alberdi (+2354)", value: "2354" },
  { label: "Buenos Aires - Vedia (+2354)", value: "2354" },
  { label: "Buenos Aires - Villa Roth (+2354)", value: "2354" },
  { label: "Buenos Aires - Arenaza (+2355)", value: "2355" },
  { label: "Buenos Aires - Bayauca (+2355)", value: "2355" },
  { label: "Buenos Aires - Bermúdez (+2355)", value: "2355" },
  { label: "Buenos Aires - Coronel Martínez de Hoz (+2355)", value: "2355" },
  { label: "Buenos Aires - El Triunfo (+2355)", value: "2355" },
  { label: "Buenos Aires - Las Toscas (+2355)", value: "2355" },
  { label: "Buenos Aires - Lincoln (+2355)", value: "2355" },
  { label: "Buenos Aires - Pasteur (+2355)", value: "2355" },
  { label: "Buenos Aires - Roberts (+2355)", value: "2355" },
  { label: "Buenos Aires - General Pinto (+2356)", value: "2356" },
  { label: "Buenos Aires - Germania (+2356)", value: "2356" },
  { label: "Buenos Aires - Villa Francia (+2356)", value: "2356" },
  { label: "Buenos Aires - Carlos Salas (+2357)", value: "2357" },
  { label: "Buenos Aires - Carlos Tejedor (+2357)", value: "2357" },
  { label: "Buenos Aires - Colonia Seré (+2357)", value: "2357" },
  { label: "Buenos Aires - Curarú (+2357)", value: "2357" },
  { label: "Buenos Aires - La Delfina (+2358)", value: "2358" },
  { label: "Buenos Aires - Los Toldos (+2358)", value: "2358" },
  { label: "Buenos Aires - San Emilio (+2358)", value: "2358" },
  { label: "Buenos Aires - Zavalía (+2358)", value: "2358" },
  { label: "Buenos Aires - Beruti (+2392)", value: "2392" },
  { label: "Buenos Aires - Bocayuva (+2392)", value: "2392" },
  { label: "Buenos Aires - De Bary (+2392)", value: "2392" },
  { label: "Buenos Aires - Girodias (+2392)", value: "2392" },
  { label: "Buenos Aires - La Carreta (+2392)", value: "2392" },
  { label: "Buenos Aires - Pellegrini (+2392)", value: "2392" },
  { label: "Buenos Aires - Trenque Lauquen (+2392)", value: "2392" },
  { label: "Buenos Aires - Treinta de Agosto (+2392)", value: "2392" },
  { label: "Buenos Aires - Salazar (+2393)", value: "2393" },
  { label: "Buenos Aires - Ingeniero Thompson (+2394)", value: "2394" },
  { label: "Buenos Aires - Quenumá (+2394)", value: "2394" },
  { label: "Buenos Aires - Salliqueló (+2394)", value: "2394" },
  { label: "Buenos Aires - Tres Lomas (+2394)", value: "2394" },
  { label: "Buenos Aires - Bellocq (+2395)", value: "2395" },
  { label: "Buenos Aires - Cadret (+2395)", value: "2395" },
  { label: "Buenos Aires - Carlos Casares (+2395)", value: "2395" },
  { label: "Buenos Aires - Colonia Mauricio (+2395)", value: "2395" },
  { label: "Buenos Aires - Gobernador Arias (+2395)", value: "2395" },
  { label: "Buenos Aires - Hortensia (+2395)", value: "2395" },
  { label: "Buenos Aires - La Dorita (+2395)", value: "2395" },
  { label: "Buenos Aires - La Sofía (+2395)", value: "2395" },
  { label: "Buenos Aires - Mauricio Hirsch (+2395)", value: "2395" },
  { label: "Buenos Aires - Moctezuma (+2395)", value: "2395" },
  { label: "Buenos Aires - Ordoqui (+2395)", value: "2395" },
  { label: "Buenos Aires - Smith (+2395)", value: "2395" },
  { label: "Buenos Aires - Abel (+2396)", value: "2396" },
  { label: "Buenos Aires - Capitán Castro (+2396)", value: "2396" },
  { label: "Buenos Aires - Chiclana (+2396)", value: "2396" },
  { label: "Buenos Aires - Francisco Madero (+2396)", value: "2396" },
  { label: "Buenos Aires - Juan José Paso (+2396)", value: "2396" },
  { label: "Buenos Aires - Magdala (+2396)", value: "2396" },
  { label: "Buenos Aires - Mones Cazón (+2396)", value: "2396" },
  { label: "Buenos Aires - Nueva Plata (+2396)", value: "2396" },
  { label: "Buenos Aires - Pehuajó (+2396)", value: "2396" },
  { label: "Buenos Aires - San Bernardo de Pehuajó (+2396)", value: "2396" },
  { label: "Buenos Aires - El Arbolito (+2473)", value: "2473" },
  { label: "Buenos Aires - Sarasa (+2473)", value: "2473" },
  { label: "Buenos Aires - Berdier (+2474)", value: "2474" },
  { label: "Buenos Aires - Gahan (+2474)", value: "2474" },
  { label: "Buenos Aires - Inés Indart (+2474)", value: "2474" },
  { label: "Buenos Aires - La Invencible (+2474)", value: "2474" },
  { label: "Buenos Aires - Salto (+2474)", value: "2474" },
  { label: "Buenos Aires - La Beba (+2475)", value: "2475" },
  { label: "Buenos Aires - Las Carabelas (+2475)", value: "2475" },
  { label: "Buenos Aires - Los Indios (+2475)", value: "2475" },
  { label: "Buenos Aires - Rafael Obligado (+2475)", value: "2475" },
  { label: "Buenos Aires - Roberto Cano (+2475)", value: "2475" },
  { label: "Buenos Aires - Rojas (+2475)", value: "2475" },
  { label: "Buenos Aires - Sol de Mayo (+2475)", value: "2475" },
  { label: "Buenos Aires - Villa Manuel Pomar (+2475)", value: "2475" },
  { label: "Buenos Aires - Villa Parque Cecir (+2475)", value: "2475" },
  { label: "Buenos Aires - Acevedo (+2477)", value: "2477" },
  { label: "Buenos Aires - Arroyo Dulce (+2477)", value: "2477" },
  { label: "Buenos Aires - Fontezuela (+2477)", value: "2477" },
  { label: "Buenos Aires - Guerrico (+2477)", value: "2477" },
  { label: "Buenos Aires - J. A. de la Peña (+2477)", value: "2477" },
  { label: "Buenos Aires - Juan Anchorena (+2477)", value: "2477" },
  { label: "Buenos Aires - Manuel Ocampo (+2477)", value: "2477" },
  { label: "Buenos Aires - Mariano Benítez (+2477)", value: "2477" },
  { label: "Buenos Aires - Mariano H. Alfonzo (+2477)", value: "2477" },
  { label: "Buenos Aires - Pearson (+2477)", value: "2477" },
  { label: "Buenos Aires - Pergamino (+2477)", value: "2477" },
  { label: "Buenos Aires - Pinzón (+2477)", value: "2477" },
  { label: "Buenos Aires - Rancagua (+2477)", value: "2477" },
  { label: "Buenos Aires - Villa Angélica (+2477)", value: "2477" },
  { label: "Buenos Aires - Arrecifes (+2478)", value: "2478" },
  { label: "Buenos Aires - Capitán Sarmiento (+2478)", value: "2478" },
  { label: "Buenos Aires - La Luisa (+2478)", value: "2478" },
  { label: "Buenos Aires - Todd (+2478)", value: "2478" },
  { label: "Buenos Aires - Viña (+2478)", value: "2478" },
  { label: "Buenos Aires - Bahía San Blas (+2920)", value: "2920" },
  { label: "Buenos Aires - Cardenal Cagliero (+2920)", value: "2920" },
  { label: "Buenos Aires - Carmen de Patagones (+2920)", value: "2920" },
  { label: "Buenos Aires - José B. Casas (+2920)", value: "2920" },
  { label: "Buenos Aires - Los Pocitos (+2920)", value: "2920" },
  { label: "Buenos Aires - Stroeder (+2920)", value: "2920" },
  { label: "Buenos Aires - Villa Balnearia 7 de Marzo (+2920)", value: "2920" },
  { label: "Buenos Aires - Aparicio (+2921)", value: "2921" },
  { label: "Buenos Aires - Balneario Pehuen-Có (+2921)", value: "2921" },
  { label: "Buenos Aires - Balneario Sauce Grande (+2921)", value: "2921" },
  { label: "Buenos Aires - Coronel Dorrego (+2921)", value: "2921" },
  { label: "Buenos Aires - El Perdido (+2921)", value: "2921" },
  { label: "Buenos Aires - Faro (+2921)", value: "2921" },
  { label: "Buenos Aires - Irene (+2921)", value: "2921" },
  { label: "Buenos Aires - Monte Hermoso (+2921)", value: "2921" },
  { label: "Buenos Aires - San Román (+2921)", value: "2921" },
  { label: "Buenos Aires - Coronel Pringles (+2922)", value: "2922" },
  { label: "Buenos Aires - El Divisorio (+2922)", value: "2922" },
  { label: "Buenos Aires - El Pensamiento (+2922)", value: "2922" },
  { label: "Buenos Aires - Frapal (+2922)", value: "2922" },
  { label: "Buenos Aires - Lartigau (+2922)", value: "2922" },
  { label: "Buenos Aires - Pontaut (+2922)", value: "2922" },
  { label: "Buenos Aires - Arroyo Corto (+2923)", value: "2923" },
  { label: "Buenos Aires - Azopardo (+2923)", value: "2923" },
  { label: "Buenos Aires - Colonia San Martín (+2923)", value: "2923" },
  { label: "Buenos Aires - Dufaur (+2923)", value: "2923" },
  { label: "Buenos Aires - Espartillar (+2923)", value: "2923" },
  { label: "Buenos Aires - Estela (+2923)", value: "2923" },
  { label: "Buenos Aires - Goyena (+2923)", value: "2923" },
  { label: "Buenos Aires - Pigüé (+2923)", value: "2923" },
  { label: "Buenos Aires - Puan (+2923)", value: "2923" },
  { label: "Buenos Aires - Saavedra (+2923)", value: "2923" },
  { label: "Buenos Aires - San Germán (+2923)", value: "2923" },
  { label: "Buenos Aires - Villa Castelar (+2923)", value: "2923" },
  { label: "Buenos Aires - Bordenave (+2924)", value: "2924" },
  { label: "Buenos Aires - Darregueira (+2924)", value: "2924" },
  { label: "Buenos Aires - San Miguel Arcángel (+2924)", value: "2924" },
  { label: "Buenos Aires - Villa Durcudoy (17 de Agosto) (+2924)", value: "2924" },
  { label: "Buenos Aires - Felipe Solá (+2925)", value: "2925" },
  { label: "Buenos Aires - General San Martín (+2925)", value: "2925" },
  { label: "Buenos Aires - López Lecube (+2925)", value: "2925" },
  { label: "Buenos Aires - Villa Iris (+2925)", value: "2925" },
  { label: "Buenos Aires - Cascada (+2926)", value: "2926" },
  { label: "Buenos Aires - Coronel Suárez (+2926)", value: "2926" },
  { label: "Buenos Aires - Cura Malal (+2926)", value: "2926" },
  { label: "Buenos Aires - D'Orbigny (+2926)", value: "2926" },
  { label: "Buenos Aires - Pasman (+2926)", value: "2926" },
  { label: "Buenos Aires - San José (+2926)", value: "2926" },
  { label: "Buenos Aires - Santa María (+2926)", value: "2926" },
  { label: "Buenos Aires - Santa Trinidad (+2926)", value: "2926" },
  { label: "Buenos Aires - Argerich (+2927)", value: "2927" },
  { label: "Buenos Aires - Balneario Chapalcó (+2927)", value: "2927" },
  { label: "Buenos Aires - La Mascota (+2927)", value: "2927" },
  { label: "Buenos Aires - Médanos (+2927)", value: "2927" },
  { label: "Buenos Aires - Nicolás Levalle (+2927)", value: "2927" },
  { label: "Buenos Aires - Hilario Ascasubi (+2928)", value: "2928" },
  { label: "Buenos Aires - Juan A. Pradere (+2928)", value: "2928" },
  { label: "Buenos Aires - Pedro Luro (+2928)", value: "2928" },
  { label: "Buenos Aires - Villalonga (+2928)", value: "2928" },
  { label: "Buenos Aires - Arroyo Venado (+2929)", value: "2929" },
  { label: "Buenos Aires - Casbas (+2929)", value: "2929" },
  { label: "Buenos Aires - Garré (+2929)", value: "2929" },
  { label: "Buenos Aires - Guaminí (+2929)", value: "2929" },
  { label: "Buenos Aires - Laguna Alsina (+2929)", value: "2929" },
  { label: "Buenos Aires - Bajo Hondo (+2932)", value: "2932" },
  { label: "Buenos Aires - Punta Alta (+2932)", value: "2932" },
  { label: "Buenos Aires - Villa del Mar (+2932)", value: "2932" },
  { label: "Buenos Aires - Villa General Arias (+2932)", value: "2932" },
  { label: "Buenos Aires - Huanguelén (+2933)", value: "2933" },
  { label: "Buenos Aires - Rivera (+2935)", value: "2935" },
  { label: "Buenos Aires - Villa Maza (+2935)", value: "2935" },
  { label: "Buenos Aires - Carhué (+2936)", value: "2936" },
  { label: "Buenos Aires - Delfín Huergo (+2936)", value: "2936" },
  { label: "Buenos Aires - Esteban Agustín Gascón (+2936)", value: "2936" },
  { label: "Buenos Aires - La Pala (+2936)", value: "2936" },
  { label: "Buenos Aires - Thames (+2936)", value: "2936" },
  { label: "Buenos Aires - Yutuyaco (+2936)", value: "2936" },
  { label: "Buenos Aires - Balneario Orense (+2982)", value: "2982" },
  { label: "Buenos Aires - Claromecó (+2982)", value: "2982" },
  { label: "Buenos Aires - Orense (+2982)", value: "2982" },
  { label: "Buenos Aires - San Francisco de Bellocq (+2982)", value: "2982" },
  { label: "Buenos Aires - Adolfo Gonzales Chaves (+2983)", value: "2983" },
  { label: "Buenos Aires - Balneario Marisol (+2983)", value: "2983" },
  { label: "Buenos Aires - Balneario San Cayetano (+2983)", value: "2983" },
  { label: "Buenos Aires - Barrow (+2983)", value: "2983" },
  { label: "Buenos Aires - Copetonas (+2983)", value: "2983" },
  { label: "Buenos Aires - De la Garma (+2983)", value: "2983" },
  { label: "Buenos Aires - Dunamar (+2983)", value: "2983" },
  { label: "Buenos Aires - Indio Rico (+2983)", value: "2983" },
  { label: "Buenos Aires - Juan Eulogio Barra (+2983)", value: "2983" },
  { label: "Buenos Aires - Lin Calel (+2983)", value: "2983" },
  { label: "Buenos Aires - Micaela Cascallares (+2983)", value: "2983" },
  { label: "Buenos Aires - Ochandío (+2983)", value: "2983" },
  { label: "Buenos Aires - Oriente (+2983)", value: "2983" },
  { label: "Buenos Aires - Reta (+2983)", value: "2983" },
  { label: "Buenos Aires - San Cayetano (+2983)", value: "2983" },
  { label: "Buenos Aires - San Mayol (+2983)", value: "2983" },
  { label: "Buenos Aires - Tres Arroyos (+2983)", value: "2983" },
  { label: "Buenos Aires - Vásquez (+2983)", value: "2983" },
  { label: "Buenos Aires - Benavídez (+3327)", value: "3327" },
  { label: "Buenos Aires - Ricardo Rojas (+3327)", value: "3327" },
  { label: "Buenos Aires - Baradero (+3329)", value: "3329" },
  { label: "Buenos Aires - Gobernador Castro (+3329)", value: "3329" },
  { label: "Buenos Aires - La Violeta (+3329)", value: "3329" },
  { label: "Buenos Aires - Obligado (+3329)", value: "3329" },
  { label: "Buenos Aires - Pérez Millán (+3329)", value: "3329" },
  { label: "Buenos Aires - Portela Pueblo Doyle (+3329)", value: "3329" },
  { label: "Buenos Aires - Río Tala (+3329)", value: "3329" },
  { label: "Buenos Aires - San Pedro (+3329)", value: "3329" },
  { label: "Buenos Aires - Santa Coloma (+3329)", value: "3329" },
  { label: "Buenos Aires - Santa Lucía (+3329)", value: "3329" },
  { label: "Buenos Aires - Villa Alsina (+3329)", value: "3329" },
  { label: "Buenos Aires - Cañada Seca (+3382)", value: "3382" },
  { label: "Buenos Aires - Santa Regina (+3382)", value: "3382" },
  { label: "Buenos Aires - Villa Saboya (+3382)", value: "3382" },
  { label: "Buenos Aires - Ameghino (+3388)", value: "3388" },
  { label: "Buenos Aires - Banderaló (+3388)", value: "3388" },
  { label: "Buenos Aires - Blaquier (+3388)", value: "3388" },
  { label: "Buenos Aires - Coronel Charlone (+3388)", value: "3388" },
  { label: "Buenos Aires - Emilio V. Bunge (+3388)", value: "3388" },
  { label: "Buenos Aires - General Villegas (+3388)", value: "3388" },
  { label: "Buenos Aires - Massey (+3388)", value: "3388" },
  { label: "Buenos Aires - Pichincha (+3388)", value: "3388" },
  { label: "Buenos Aires - Piedritas (+3388)", value: "3388" },
  { label: "Buenos Aires - Porvenir (+3388)", value: "3388" },
  { label: "Buenos Aires - Santa Eleodora (+3388)", value: "3388" },
  { label: "Buenos Aires - Timote (+3388)", value: "3388" },
  { label: "Buenos Aires - Tres Algarrobos (+3388)", value: "3388" },
  { label: "Buenos Aires - Villa Sauze (+3388)", value: "3388" },
  { label: "Buenos Aires - El Paraíso (+3407)", value: "3407" },
  { label: "Buenos Aires - Las Bahamas (+3407)", value: "3407" },
  { label: "Buenos Aires - Ramallo (+3407)", value: "3407" },
  { label: "Buenos Aires - Villa General Savio (+3407)", value: "3407" },
  { label: "Buenos Aires - Villa Ramallo (+3407)", value: "3407" },
  { label: "Buenos Aires - Barrio Saavedra (+3487)", value: "3487" },
  { label: "Buenos Aires - Escalada (+3487)", value: "3487" },
  { label: "Buenos Aires - Gobernador Andonaegui (+3487)", value: "3487" },
  { label: "Buenos Aires - Lima (+3487)", value: "3487" },
  { label: "Buenos Aires - Zárate (+3487)", value: "3487" },
  { label: "Buenos Aires - Alto Los Cardales (+3489)", value: "3489" },
  { label: "Buenos Aires - Barrio Los Pioneros (+3489)", value: "3489" },
  { label: "Buenos Aires - Campana (+3489)", value: "3489" },
  { label: "Buenos Aires - Ingeniero Rómulo Otamendi (+3489)", value: "3489" },
  { label: "Buenos Aires - Lomas del Río Luján (+3489)", value: "3489" },
  { label: "Catamarca - Adolfo E. Carranza (+383)", value: "383" },
  { label: "Catamarca - Alijilán (+383)", value: "383" },
  { label: "Catamarca - Amadores (+383)", value: "383" },
  { label: "Catamarca - Ancasti (+383)", value: "383" },
  { label: "Catamarca - Anquincila (+383)", value: "383" },
  { label: "Catamarca - Balde de la Punta (+383)", value: "383" },
  { label: "Catamarca - Bañado de Ovanta (+383)", value: "383" },
  { label: "Catamarca - Barrio Bancario (+383)", value: "383" },
  { label: "Catamarca - Cañas (+383)", value: "383" },
  { label: "Catamarca - Capayán (+383)", value: "383" },
  { label: "Catamarca - Chuchucaruana (+383)", value: "383" },
  { label: "Catamarca - Chumbicha (+383)", value: "383" },
  { label: "Catamarca - Collagasta (+383)", value: "383" },
  { label: "Catamarca - Colonia del Valle (+383)", value: "383" },
  { label: "Catamarca - Colonia Nueva Coneta (+383)", value: "383" },
  { label: "Catamarca - Colpes (+383)", value: "383" },
  { label: "Catamarca - Concepción (+383)", value: "383" },
  { label: "Catamarca - Coneta (+383)", value: "383" },
  { label: "Catamarca - El Alto (+383)", value: "383" },
  { label: "Catamarca - El Bañado (Capayán) (+383)", value: "383" },
  { label: "Catamarca - El Bañado (Valle Viejo) (+383)", value: "383" },
  { label: "Catamarca - El Bolsón (+383)", value: "383" },
  { label: "Catamarca - El Hueco (+383)", value: "383" },
  { label: "Catamarca - El Pantanillo (+383)", value: "383" },
  { label: "Catamarca - El Portezuelo (+383)", value: "383" },
  { label: "Catamarca - El Rodeo (+383)", value: "383" },
  { label: "Catamarca - El Rosario (+383)", value: "383" },
  { label: "Catamarca - Guayamba (+383)", value: "383" },
  { label: "Catamarca - Huaycama (Ambato) (+383)", value: "383" },
  { label: "Catamarca - Huaycama (Valle Viejo) (+383)", value: "383" },
  { label: "Catamarca - Huillapima (+383)", value: "383" },
  { label: "Catamarca - Infanzón (+383)", value: "383" },
  { label: "Catamarca - La Bajada (+383)", value: "383" },
  { label: "Catamarca - Las Chacritas (+383)", value: "383" },
  { label: "Catamarca - Las Juntas (+383)", value: "383" },
  { label: "Catamarca - Las Lajas (+383)", value: "383" },
  { label: "Catamarca - Las Tejas (+383)", value: "383" },
  { label: "Catamarca - Lavalle (parte) (+383)", value: "383" },
  { label: "Catamarca - Los Altos (+383)", value: "383" },
  { label: "Catamarca - Los Ángeles (+383)", value: "383" },
  { label: "Catamarca - Los Castillos (+383)", value: "383" },
  { label: "Catamarca - Los Corrales (+383)", value: "383" },
  { label: "Catamarca - Los Talas (+383)", value: "383" },
  { label: "Catamarca - Los Varela (+383)", value: "383" },
  { label: "Catamarca - Manantiales (+383)", value: "383" },
  { label: "Catamarca - Miraflores (+383)", value: "383" },
  { label: "Catamarca - Monte Potrero (+383)", value: "383" },
  { label: "Catamarca - Palo Labrado (+383)", value: "383" },
  { label: "Catamarca - Polcos (+383)", value: "383" },
  { label: "Catamarca - Pomancillo Este (+383)", value: "383" },
  { label: "Catamarca - Pomancillo Oeste (+383)", value: "383" },
  { label: "Catamarca - Pozo del Mistol (+383)", value: "383" },
  { label: "Catamarca - San Antonio (Fray Mamerto Esquiú) (+383)", value: "383" },
  { label: "Catamarca - San Antonio (Paclín) (+383)", value: "383" },
  { label: "Catamarca - San Fernando del Valle de Catamarca (+383)", value: "383" },
  { label: "Catamarca - San Isidro (+383)", value: "383" },
  { label: "Catamarca - San José (+383)", value: "383" },
  { label: "Catamarca - San Martín (+383)", value: "383" },
  { label: "Catamarca - San Pablo (+383)", value: "383" },
  { label: "Catamarca - San Pedro (+383)", value: "383" },
  { label: "Catamarca - San Pedro de Guasayán (+383)", value: "383" },
  { label: "Catamarca - Santa Cruz (+383)", value: "383" },
  { label: "Catamarca - Santa Rosa (+383)", value: "383" },
  { label: "Catamarca - Singuil (+383)", value: "383" },
  { label: "Catamarca - Sumalao (+383)", value: "383" },
  { label: "Catamarca - Tapso (+383)", value: "383" },
  { label: "Catamarca - Vilismán (+383)", value: "383" },
  { label: "Catamarca - Villa de Balcozna (+383)", value: "383" },
  { label: "Catamarca - Villa Dolores (+383)", value: "383" },
  { label: "Catamarca - Villa Las Pirquitas (+383)", value: "383" },
  { label: "Catamarca - Casa de Piedra (+3832)", value: "3832" },
  { label: "Catamarca - El Aybal (+3832)", value: "3832" },
  { label: "Catamarca - El Bañado (+3832)", value: "3832" },
  { label: "Catamarca - El Divisadero (+3832)", value: "3832" },
  { label: "Catamarca - El Quimilo (+3832)", value: "3832" },
  { label: "Catamarca - Esquiú (+3832)", value: "3832" },
  { label: "Catamarca - Icaño (+3832)", value: "3832" },
  { label: "Catamarca - La Dorada (+3832)", value: "3832" },
  { label: "Catamarca - La Guardia (+3832)", value: "3832" },
  { label: "Catamarca - Las Palmitas (+3832)", value: "3832" },
  { label: "Catamarca - Quirós (+3832)", value: "3832" },
  { label: "Catamarca - Ramblones (+3832)", value: "3832" },
  { label: "Catamarca - Recreo (+3832)", value: "3832" },
  { label: "Catamarca - San Antonio de La Paz (+3832)", value: "3832" },
  { label: "Catamarca - Aconquija (+3835)", value: "3835" },
  { label: "Catamarca - Alto de las Juntas (+3835)", value: "3835" },
  { label: "Catamarca - Amanao (+3835)", value: "3835" },
  { label: "Catamarca - Andalgalá (+3835)", value: "3835" },
  { label: "Catamarca - Antofagasta de la Sierra (+3835)", value: "3835" },
  { label: "Catamarca - Antofalla (+3835)", value: "3835" },
  { label: "Catamarca - Apoyaco (+3835)", value: "3835" },
  { label: "Catamarca - Barranca Larga (+3835)", value: "3835" },
  { label: "Catamarca - Belén (+3835)", value: "3835" },
  { label: "Catamarca - Buena Vista (+3835)", value: "3835" },
  { label: "Catamarca - Chaquiago (+3835)", value: "3835" },
  { label: "Catamarca - Choya (+3835)", value: "3835" },
  { label: "Catamarca - Colana (+3835)", value: "3835" },
  { label: "Catamarca - Colpes (Pomán) (+3835)", value: "3835" },
  { label: "Catamarca - Cóndor Huasi (+3835)", value: "3835" },
  { label: "Catamarca - Corral Quemado (+3835)", value: "3835" },
  { label: "Catamarca - El Alamito (+3835)", value: "3835" },
  { label: "Catamarca - El Durazno (+3835)", value: "3835" },
  { label: "Catamarca - El Lindero (+3835)", value: "3835" },
  { label: "Catamarca - El Pajonal (+3835)", value: "3835" },
  { label: "Catamarca - El Peñón (+3835)", value: "3835" },
  { label: "Catamarca - El Potrero (+3835)", value: "3835" },
  { label: "Catamarca - Farallón Negro (+3835)", value: "3835" },
  { label: "Catamarca - Hualfín (+3835)", value: "3835" },
  { label: "Catamarca - Jacipunco (+3835)", value: "3835" },
  { label: "Catamarca - Joyango (+3835)", value: "3835" },
  { label: "Catamarca - La Aguada (+3835)", value: "3835" },
  { label: "Catamarca - La Puntilla (+3835)", value: "3835" },
  { label: "Catamarca - Las Juntas (+3835)", value: "3835" },
  { label: "Catamarca - Londres (+3835)", value: "3835" },
  { label: "Catamarca - Los Nacimientos (Antofagasta de la Sierra) (+3835)", value: "3835" },
  { label: "Catamarca - Los Nacimientos (Belén) (+3835)", value: "3835" },
  { label: "Catamarca - Mutquín (+3835)", value: "3835" },
  { label: "Catamarca - Pozo de la Piedra (+3835)", value: "3835" },
  { label: "Catamarca - Puerta de Corral Quemado (+3835)", value: "3835" },
  { label: "Catamarca - Puerta de San José (+3835)", value: "3835" },
  { label: "Catamarca - Rincón (+3835)", value: "3835" },
  { label: "Catamarca - San Miguel (+3835)", value: "3835" },
  { label: "Catamarca - Saujil (+3835)", value: "3835" },
  { label: "Catamarca - Siján (+3835)", value: "3835" },
  { label: "Catamarca - Villa de Pomán (+3835)", value: "3835" },
  { label: "Catamarca - Villa Vil (+3835)", value: "3835" },
  { label: "Catamarca - Anillaco (+3837)", value: "3837" },
  { label: "Catamarca - Antinaco (+3837)", value: "3837" },
  { label: "Catamarca - Banda de Lucero (+3837)", value: "3837" },
  { label: "Catamarca - Cerro Negro (+3837)", value: "3837" },
  { label: "Catamarca - Copacabana (+3837)", value: "3837" },
  { label: "Catamarca - Cordobita (+3837)", value: "3837" },
  { label: "Catamarca - Costa de Reyes (+3837)", value: "3837" },
  { label: "Catamarca - El Pueblito (+3837)", value: "3837" },
  { label: "Catamarca - El Puesto (Tinogasta) (+3837)", value: "3837" },
  { label: "Catamarca - El Salado (+3837)", value: "3837" },
  { label: "Catamarca - Fiambalá (+3837)", value: "3837" },
  { label: "Catamarca - La Puntilla (Tinogasta) (+3837)", value: "3837" },
  { label: "Catamarca - La Ramadita (+3837)", value: "3837" },
  { label: "Catamarca - Los Balverdi (+3837)", value: "3837" },
  { label: "Catamarca - Medanitos (+3837)", value: "3837" },
  { label: "Catamarca - Palo Blanco (+3837)", value: "3837" },
  { label: "Catamarca - Pampa Blanca (+3837)", value: "3837" },
  { label: "Catamarca - Punta del Agua (+3837)", value: "3837" },
  { label: "Catamarca - Santa Rosa (+3837)", value: "3837" },
  { label: "Catamarca - Saujil (Tinogasta) (+3837)", value: "3837" },
  { label: "Catamarca - Tatón (+3837)", value: "3837" },
  { label: "Catamarca - Tinogasta (+3837)", value: "3837" },
  { label: "Catamarca - Andalhualá (+3838)", value: "3838" },
  { label: "Catamarca - Casa de Piedra (+3838)", value: "3838" },
  { label: "Catamarca - Caspichango (+3838)", value: "3838" },
  { label: "Catamarca - Chañar Punco (+3838)", value: "3838" },
  { label: "Catamarca - El Cajón (+3838)", value: "3838" },
  { label: "Catamarca - El Cerrito (+3838)", value: "3838" },
  { label: "Catamarca - El Desmonte (+3838)", value: "3838" },
  { label: "Catamarca - El Puesto (+3838)", value: "3838" },
  { label: "Catamarca - Famatanca (+3838)", value: "3838" },
  { label: "Catamarca - Fuerte Quemado (+3838)", value: "3838" },
  { label: "Catamarca - La Hoyada (+3838)", value: "3838" },
  { label: "Catamarca - La Loma (+3838)", value: "3838" },
  { label: "Catamarca - La Puntilla (+3838)", value: "3838" },
  { label: "Catamarca - Lampacito (+3838)", value: "3838" },
  { label: "Catamarca - Las Mojarras (+3838)", value: "3838" },
  { label: "Catamarca - Loro Huasi (+3838)", value: "3838" },
  { label: "Catamarca - Medanitos (+3838)", value: "3838" },
  { label: "Catamarca - Ovejería (+3838)", value: "3838" },
  { label: "Catamarca - Palo Seco (+3838)", value: "3838" },
  { label: "Catamarca - Punta de Balasto (+3838)", value: "3838" },
  { label: "Catamarca - San José (+3838)", value: "3838" },
  { label: "Catamarca - San José Banda (+3838)", value: "3838" },
  { label: "Catamarca - San José Norte (+3838)", value: "3838" },
  { label: "Catamarca - San José Villa (+3838)", value: "3838" },
  { label: "Catamarca - Santa María (+3838)", value: "3838" },
  { label: "Catamarca - Yapes (+3838)", value: "3838" },
  { label: "Chaco - Barranqueras (+362)", value: "362" },
  { label: "Chaco - Barrio San Pedro Pescador (+362)", value: "362" },
  { label: "Chaco - Basail (+362)", value: "362" },
  { label: "Chaco - Colonia Baranda (+362)", value: "362" },
  { label: "Chaco - Colonia Benítez (+362)", value: "362" },
  { label: "Chaco - Colonia Popular (+362)", value: "362" },
  { label: "Chaco - Fontana (+362)", value: "362" },
  { label: "Chaco - General Obligado (+362)", value: "362" },
  { label: "Chaco - General Vedia (+362)", value: "362" },
  { label: "Chaco - Isla del Cerrito (+362)", value: "362" },
  { label: "Chaco - La Escondida (+362)", value: "362" },
  { label: "Chaco - La Leonesa (+362)", value: "362" },
  { label: "Chaco - La Verde (+362)", value: "362" },
  { label: "Chaco - Laguna Blanca (+362)", value: "362" },
  { label: "Chaco - Lapachito (+362)", value: "362" },
  { label: "Chaco - Las Palmas (+362)", value: "362" },
  { label: "Chaco - Makallé (+362)", value: "362" },
  { label: "Chaco - Margarita Belén (+362)", value: "362" },
  { label: "Chaco - Puerto Bermejo (+362)", value: "362" },
  { label: "Chaco - Puerto Bermejo Viejo (+362)", value: "362" },
  { label: "Chaco - Puerto Eva Perón (+362)", value: "362" },
  { label: "Chaco - Puerto Tirol (+362)", value: "362" },
  { label: "Chaco - Puerto Vilelas (+362)", value: "362" },
  { label: "Chaco - Resistencia (+362)", value: "362" },
  { label: "Chaco - Avia Terai (+364)", value: "364" },
  { label: "Chaco - Campo Largo (+364)", value: "364" },
  { label: "Chaco - Colonia Aborigen Chaco (+364)", value: "364" },
  { label: "Chaco - Concepción del Bermejo (+364)", value: "364" },
  { label: "Chaco - Fortín Lavalle (+364)", value: "364" },
  { label: "Chaco - Juan José Castelli (+364)", value: "364" },
  { label: "Chaco - La Chiquita (+364)", value: "364" },
  { label: "Chaco - La Tigra (+364)", value: "364" },
  { label: "Chaco - Los Frentones (+364)", value: "364" },
  { label: "Chaco - Miraflores (+364)", value: "364" },
  { label: "Chaco - Napenay (+364)", value: "364" },
  { label: "Chaco - Pampa del Infierno (+364)", value: "364" },
  { label: "Chaco - Presidencia Roque Sáenz Peña (+364)", value: "364" },
  { label: "Chaco - Quitilipi (+364)", value: "364" },
  { label: "Chaco - Río Muerto (+364)", value: "364" },
  { label: "Chaco - Tres Isletas (+364)", value: "364" },
  { label: "Chaco - Villa Río Bermejito (+364)", value: "364" },
  { label: "Chaco - Villa Rural El Palmar (+364)", value: "364" },
  { label: "Chaco - Zaparinqui (+364)", value: "364" },
  { label: "Chaco - El Sauzal (+3715)", value: "3715" },
  { label: "Chaco - El Sauzalito (+3715)", value: "3715" },
  { label: "Chaco - Fuerte Esperanza (+3715)", value: "3715" },
  { label: "Chaco - Misión Nueva Pompeya (+3715)", value: "3715" },
  { label: "Chaco - Wichí - El Pintado (+3715)", value: "3715" },
  { label: "Chaco - Charadai (+3721)", value: "3721" },
  { label: "Chaco - Cote Lai (+3721)", value: "3721" },
  { label: "Chaco - La Sabana (+3721)", value: "3721" },
  { label: "Chaco - Capitán Solari (+3725)", value: "3725" },
  { label: "Chaco - Ciervo Petiso (+3725)", value: "3725" },
  { label: "Chaco - Colonias Unidas (+3725)", value: "3725" },
  { label: "Chaco - General José de San Martín (+3725)", value: "3725" },
  { label: "Chaco - La Eduvigis (+3725)", value: "3725" },
  { label: "Chaco - Laguna Limpia (+3725)", value: "3725" },
  { label: "Chaco - Las Garcitas (+3725)", value: "3725" },
  { label: "Chaco - Pampa Almirón (+3725)", value: "3725" },
  { label: "Chaco - Pampa del Indio (+3725)", value: "3725" },
  { label: "Chaco - Presidencia Roca (+3725)", value: "3725" },
  { label: "Chaco - Selvas del Río de Oro (+3725)", value: "3725" },
  { label: "Chaco - Charata (+3731)", value: "3731" },
  { label: "Chaco - Corzuela (+3731)", value: "3731" },
  { label: "Chaco - Fortín Las Chuñas (+3731)", value: "3731" },
  { label: "Chaco - Gancedo (+3731)", value: "3731" },
  { label: "Chaco - General Capdevila (+3731)", value: "3731" },
  { label: "Chaco - General Pinedo (+3731)", value: "3731" },
  { label: "Chaco - Las Breñas (+3731)", value: "3731" },
  { label: "Chaco - Mesón de Fierro (+3731)", value: "3731" },
  { label: "Chaco - Pampa Landriel (+3731)", value: "3731" },
  { label: "Chaco - Colonia Elisa (+3734)", value: "3734" },
  { label: "Chaco - Ingeniero Barbet (+3734)", value: "3734" },
  { label: "Chaco - Machagai (+3734)", value: "3734" },
  { label: "Chaco - Napalpí (+3734)", value: "3734" },
  { label: "Chaco - Presidencia de la Plaza (+3734)", value: "3734" },
  { label: "Chaco - Chorotis (+3735)", value: "3735" },
  { label: "Chaco - Coronel Du Graty (+3735)", value: "3735" },
  { label: "Chaco - Enrique Urién (+3735)", value: "3735" },
  { label: "Chaco - Hermoso Campo (+3735)", value: "3735" },
  { label: "Chaco - Itín (+3735)", value: "3735" },
  { label: "Chaco - La Clotilde (+3735)", value: "3735" },
  { label: "Chaco - Pueblo Clodomiro Díaz (+3735)", value: "3735" },
  { label: "Chaco - Samuhú (+3735)", value: "3735" },
  { label: "Chaco - San Bernardo (+3735)", value: "3735" },
  { label: "Chaco - Santa Sylvina (+3735)", value: "3735" },
  { label: "Chaco - Venados Grandes (+3735)", value: "3735" },
  { label: "Chaco - Villa Ángela (+3735)", value: "3735" },
  { label: "Chaco - Villa Berthet (+3735)", value: "3735" },
  { label: "Chaco - Taco Pozo (+3877)", value: "3877" },
  { label: "Chubut - Blancuntre (+280)", value: "280" },
  { label: "Chubut - Cerro Cóndor (+280)", value: "280" },
  { label: "Chubut - Dolavon (+280)", value: "280" },
  { label: "Chubut - El Escorial (+280)", value: "280" },
  { label: "Chubut - El Mirasol (+280)", value: "280" },
  { label: "Chubut - El Sombrero (+280)", value: "280" },
  { label: "Chubut - Gaiman (+280)", value: "280" },
  { label: "Chubut - Gan Gan (+280)", value: "280" },
  { label: "Chubut - Gastre (+280)", value: "280" },
  { label: "Chubut - Lagunita Salada (+280)", value: "280" },
  { label: "Chubut - Las Plumas (+280)", value: "280" },
  { label: "Chubut - Los Altares (+280)", value: "280" },
  { label: "Chubut - Paso de Indios (+280)", value: "280" },
  { label: "Chubut - Playa Magagna (+280)", value: "280" },
  { label: "Chubut - Playa Unión (+280)", value: "280" },
  { label: "Chubut - Puerto Madryn (+280)", value: "280" },
  { label: "Chubut - Quinta El Mirador (+280)", value: "280" },
  { label: "Chubut - Rawson (+280)", value: "280" },
  { label: "Chubut - Telsen (+280)", value: "280" },
  { label: "Chubut - Trelew (+280)", value: "280" },
  { label: "Chubut - Veintiocho de Julio (+280)", value: "280" },
  { label: "Chubut - Villa Dique Florentino Ameghino (+280)", value: "280" },
  { label: "Chubut - Yala Laubat (+280)", value: "280" },
  { label: "Chubut - Hoyo de Epuyén (+294)", value: "294" },
  { label: "Chubut - Lago Puelo (+294)", value: "294" },
  { label: "Chubut - Aldea Beleiro (+2903)", value: "2903" },
  { label: "Chubut - Doctor Ricardo Rojas (+2903)", value: "2903" },
  { label: "Chubut - Facundo (+2903)", value: "2903" },
  { label: "Chubut - Lago Blanco (+2903)", value: "2903" },
  { label: "Chubut - Río Mayo (+2903)", value: "2903" },
  { label: "Chubut - Aldea Apeleg (+2945)", value: "2945" },
  { label: "Chubut - Aldea Epulef (+2945)", value: "2945" },
  { label: "Chubut - Alto Río Senguer (+2945)", value: "2945" },
  { label: "Chubut - Buen Pasto (+2945)", value: "2945" },
  { label: "Chubut - Buenos Aires Chico (+2945)", value: "2945" },
  { label: "Chubut - Carrenleufú (+2945)", value: "2945" },
  { label: "Chubut - Cholila (+2945)", value: "2945" },
  { label: "Chubut - Colan Conhué (+2945)", value: "2945" },
  { label: "Chubut - Corcovado (+2945)", value: "2945" },
  { label: "Chubut - Cushamen (+2945)", value: "2945" },
  { label: "Chubut - Doctor Atilio Oscar Viglione (+2945)", value: "2945" },
  { label: "Chubut - El Maitén (+2945)", value: "2945" },
  { label: "Chubut - Epuyén (+2945)", value: "2945" },
  { label: "Chubut - Esquel (+2945)", value: "2945" },
  { label: "Chubut - Gobernador Costa (+2945)", value: "2945" },
  { label: "Chubut - Gualjaina (+2945)", value: "2945" },
  { label: "Chubut - José de San Martín (+2945)", value: "2945" },
  { label: "Chubut - Lago Epuyén (+2945)", value: "2945" },
  { label: "Chubut - Lago Rosario (+2945)", value: "2945" },
  { label: "Chubut - Leleque (+2945)", value: "2945" },
  { label: "Chubut - Los Cipreses (+2945)", value: "2945" },
  { label: "Chubut - Paso del Sapo (+2945)", value: "2945" },
  { label: "Chubut - Río Pico (+2945)", value: "2945" },
  { label: "Chubut - Tecka (+2945)", value: "2945" },
  { label: "Chubut - Trevelin (+2945)", value: "2945" },
  { label: "Chubut - Villa Futalaufquen (+2945)", value: "2945" },
  { label: "Chubut - Astra (+297)", value: "297" },
  { label: "Chubut - Camarones (+297)", value: "297" },
  { label: "Chubut - Comodoro Rivadavia (+297)", value: "297" },
  { label: "Chubut - Diadema Argentina (+297)", value: "297" },
  { label: "Chubut - Garayalde (+297)", value: "297" },
  { label: "Chubut - Rada Tilly (+297)", value: "297" },
  { label: "Chubut - Sarmiento (+297)", value: "297" },
  { label: "Córdoba - Barrio Gilbert (+351)", value: "351" },
  { label: "Córdoba - Bouwer (+351)", value: "351" },
  { label: "Córdoba - Caseros Centro (+351)", value: "351" },
  { label: "Córdoba - Causana (+351)", value: "351" },
  { label: "Córdoba - Colonia Tirolesa (+351)", value: "351" },
  { label: "Córdoba - Córdoba (+351)", value: "351" },
  { label: "Córdoba - Estación Colonia Tirolesa (+351)", value: "351" },
  { label: "Córdoba - Estación Juárez Celman (+351)", value: "351" },
  { label: "Córdoba - Guiñazú Norte (+351)", value: "351" },
  { label: "Córdoba - La Carbonada (+351)", value: "351" },
  { label: "Córdoba - La Perla (+351)", value: "351" },
  { label: "Córdoba - Malagueño (+351)", value: "351" },
  { label: "Córdoba - Malvinas Argentinas (+351)", value: "351" },
  { label: "Córdoba - Mi Granja (+351)", value: "351" },
  { label: "Córdoba - Monte Cristo (+351)", value: "351" },
  { label: "Córdoba - Santa Elena (+351)", value: "351" },
  { label: "Córdoba - Toledo (+351)", value: "351" },
  { label: "Córdoba - Villa Los Llanos (+351)", value: "351" },
  { label: "Córdoba - Villa Sierras de Oro (+351)", value: "351" },
  { label: "Córdoba - Yocsina (+351)", value: "351" },
  { label: "Córdoba - Ana Zumarán (+353)", value: "353" },
  { label: "Córdoba - Arroyo Algodón (+353)", value: "353" },
  { label: "Córdoba - Arroyo Cabral (+353)", value: "353" },
  { label: "Córdoba - Ausonia (+353)", value: "353" },
  { label: "Córdoba - Ballesteros (+353)", value: "353" },
  { label: "Córdoba - Ballesteros Sud (+353)", value: "353" },
  { label: "Córdoba - Bengolea (+353)", value: "353" },
  { label: "Córdoba - Carrilobo (+353)", value: "353" },
  { label: "Córdoba - Chazón (+353)", value: "353" },
  { label: "Córdoba - Dalmacio Vélez Sarsfield (+353)", value: "353" },
  { label: "Córdoba - Etruria (+353)", value: "353" },
  { label: "Córdoba - Hernando (+353)", value: "353" },
  { label: "Córdoba - James Craik (+353)", value: "353" },
  { label: "Córdoba - La Laguna (+353)", value: "353" },
  { label: "Córdoba - La Palestina (+353)", value: "353" },
  { label: "Córdoba - La Playosa (+353)", value: "353" },
  { label: "Córdoba - Las Isletillas (+353)", value: "353" },
  { label: "Córdoba - Las Mojarras (+353)", value: "353" },
  { label: "Córdoba - Sanabria (+353)", value: "353" },
  { label: "Córdoba - Silvio Pellico (+353)", value: "353" },
  { label: "Córdoba - Ticino (+353)", value: "353" },
  { label: "Córdoba - Tío Pujio (+353)", value: "353" },
  { label: "Córdoba - Ucacha (+353)", value: "353" },
  { label: "Córdoba - Villa Albertina (+353)", value: "353" },
  { label: "Córdoba - Villa María (+353)", value: "353" },
  { label: "Córdoba - Villa Nueva (+353)", value: "353" },
  { label: "Córdoba - Villa Oeste (+353)", value: "353" },
  { label: "Córdoba - Alcira Gigena (+358)", value: "358" },
  { label: "Córdoba - Alejandro Roca (+358)", value: "358" },
  { label: "Córdoba - Alpa Corral (+358)", value: "358" },
  { label: "Córdoba - Berrotarán (+358)", value: "358" },
  { label: "Córdoba - Carnerillo (+358)", value: "358" },
  { label: "Córdoba - Charras (+358)", value: "358" },
  { label: "Córdoba - Chucul (+358)", value: "358" },
  { label: "Córdoba - Coronel Baigorria (+358)", value: "358" },
  { label: "Córdoba - Elena (+358)", value: "358" },
  { label: "Córdoba - General Cabrera (+358)", value: "358" },
  { label: "Córdoba - General Deheza (+358)", value: "358" },
  { label: "Córdoba - La Carolina (+358)", value: "358" },
  { label: "Córdoba - La Gilda (+358)", value: "358" },
  { label: "Córdoba - Las Acequias (+358)", value: "358" },
  { label: "Córdoba - Las Albahacas (+358)", value: "358" },
  { label: "Córdoba - Las Caleras (+358)", value: "358" },
  { label: "Córdoba - Las Higueras (+358)", value: "358" },
  { label: "Córdoba - Las Vertientes (+358)", value: "358" },
  { label: "Córdoba - Olaeta (+358)", value: "358" },
  { label: "Córdoba - Paso Cabral (+358)", value: "358" },
  { label: "Córdoba - Paso del Durazno (+358)", value: "358" },
  { label: "Córdoba - Río Cuarto (+358)", value: "358" },
  { label: "Córdoba - Río de Los Sauces (+358)", value: "358" },
  { label: "Córdoba - Santa Catalina (+358)", value: "358" },
  { label: "Córdoba - Villa El Chacay (+358)", value: "358" },
  { label: "Córdoba - Villa Reducción (+358)", value: "358" },
  { label: "Córdoba - Villa Santa Eugenia (+358)", value: "358" },
  { label: "Córdoba - Huinca Renancó (+2336)", value: "2336" },
  { label: "Córdoba - Pincén (+2336)", value: "2336" },
  { label: "Córdoba - Ranqueles (+2336)", value: "2336" },
  { label: "Córdoba - Villa Huidobro (+2336)", value: "2336" },
  { label: "Córdoba - La Cesira (+3382)", value: "3382" },
  { label: "Córdoba - Leguizamón (+3382)", value: "3382" },
  { label: "Córdoba - General Levalle (+3385)", value: "3385" },
  { label: "Córdoba - Jovita (+3385)", value: "3385" },
  { label: "Córdoba - Laboulaye (+3385)", value: "3385" },
  { label: "Córdoba - Melo (+3385)", value: "3385" },
  { label: "Córdoba - Río Bamba (+3385)", value: "3385" },
  { label: "Córdoba - Rosales (+3385)", value: "3385" },
  { label: "Córdoba - San Joaquín (+3385)", value: "3385" },
  { label: "Córdoba - Serrano (+3385)", value: "3385" },
  { label: "Córdoba - Villa Rossi (+3385)", value: "3385" },
  { label: "Córdoba - Buchardo (+3387)", value: "3387" },
  { label: "Córdoba - Italó (+3387)", value: "3387" },
  { label: "Córdoba - Onagoity (+3387)", value: "3387" },
  { label: "Córdoba - Aldea Santa María (+3463)", value: "3463" },
  { label: "Córdoba - Canals (+3463)", value: "3463" },
  { label: "Córdoba - Colonia Bremen (+3463)", value: "3463" },
  { label: "Córdoba - Gould (+3463)", value: "3463" },
  { label: "Córdoba - Pueblo Italiano (+3463)", value: "3463" },
  { label: "Córdoba - Pueblo Italiano (+3463)", value: "3463" },
  { label: "Córdoba - Viamonte (+3463)", value: "3463" },
  { label: "Córdoba - Colonia Veinticinco (+3467)", value: "3467" },
  { label: "Córdoba - Cruz Alta (+3467)", value: "3467" },
  { label: "Córdoba - Inriville (+3467)", value: "3467" },
  { label: "Córdoba - Los Surgentes (+3467)", value: "3467" },
  { label: "Córdoba - Monte Buey (+3467)", value: "3467" },
  { label: "Córdoba - Alejo Ledesma (+3468)", value: "3468" },
  { label: "Córdoba - Arias (+3468)", value: "3468" },
  { label: "Córdoba - Camilo Aldao (+3468)", value: "3468" },
  { label: "Córdoba - Capitán General Bernardo O'Higgins (+3468)", value: "3468" },
  { label: "Córdoba - Cavanagh (+3468)", value: "3468" },
  { label: "Córdoba - Colonia Barge (+3468)", value: "3468" },
  { label: "Córdoba - Colonia Bismarck (+3468)", value: "3468" },
  { label: "Córdoba - Colonia Italiana (+3468)", value: "3468" },
  { label: "Córdoba - General Baldissera (+3468)", value: "3468" },
  { label: "Córdoba - Guatimozín (+3468)", value: "3468" },
  { label: "Córdoba - Isla Verde (+3468)", value: "3468" },
  { label: "Córdoba - Monte Maíz (+3468)", value: "3468" },
  { label: "Córdoba - Wenceslao (+3468)", value: "3468" },
  { label: "Córdoba - General Roca (+3472)", value: "3472" },
  { label: "Córdoba - Leones (+3472)", value: "3472" },
  { label: "Córdoba - Marcos Juárez (+3472)", value: "3472" },
  { label: "Córdoba - Noetinger (+3472)", value: "3472" },
  { label: "Córdoba - Saira (+3472)", value: "3472" },
  { label: "Córdoba - Villa Elisa (+3472)", value: "3472" },
  { label: "Córdoba - Caminiaga (+3521)", value: "3521" },
  { label: "Córdoba - Chuña (+3521)", value: "3521" },
  { label: "Córdoba - Copacabana (+3521)", value: "3521" },
  { label: "Córdoba - Deán Funes (+3521)", value: "3521" },
  { label: "Córdoba - El Tuscal (+3521)", value: "3521" },
  { label: "Córdoba - Los Pozos (+3521)", value: "3521" },
  { label: "Córdoba - Lucio V. Mansilla (+3521)", value: "3521" },
  { label: "Córdoba - Quilino (+3521)", value: "3521" },
  { label: "Córdoba - San José de La Dormida (+3521)", value: "3521" },
  { label: "Córdoba - San José de Las Salinas (+3521)", value: "3521" },
  { label: "Córdoba - San Pedro de Toyos (+3521)", value: "3521" },
  { label: "Córdoba - San Pedro Norte (+3521)", value: "3521" },
  { label: "Córdoba - Villa Quilino (+3521)", value: "3521" },
  { label: "Córdoba - Villa Tulumba (+3521)", value: "3521" },
  { label: "Córdoba - Cerro Colorado (+3522)", value: "3522" },
  { label: "Córdoba - Chañar Viejo (+3522)", value: "3522" },
  { label: "Córdoba - Chuña Huasi (+3522)", value: "3522" },
  { label: "Córdoba - Churqui Cañada (+3522)", value: "3522" },
  { label: "Córdoba - El Rodeo (+3522)", value: "3522" },
  { label: "Córdoba - Eufrasio Loza (+3522)", value: "3522" },
  { label: "Córdoba - Gutemberg (+3522)", value: "3522" },
  { label: "Córdoba - La Rinconada (+3522)", value: "3522" },
  { label: "Córdoba - Las Arrias (+3522)", value: "3522" },
  { label: "Córdoba - Los Hoyos (+3522)", value: "3522" },
  { label: "Córdoba - Pozo Nuevo (+3522)", value: "3522" },
  { label: "Córdoba - Puesto de Castro (+3522)", value: "3522" },
  { label: "Córdoba - Rayo Cortado (+3522)", value: "3522" },
  { label: "Córdoba - Rosario del Saladillo (+3522)", value: "3522" },
  { label: "Córdoba - San Francisco del Chañar (+3522)", value: "3522" },
  { label: "Córdoba - Santa Elena (+3522)", value: "3522" },
  { label: "Córdoba - Sebastián Elcano (+3522)", value: "3522" },
  { label: "Córdoba - Villa Candelaria Norte (+3522)", value: "3522" },
  { label: "Córdoba - Villa de María (+3522)", value: "3522" },
  { label: "Córdoba - Avellaneda (+3524)", value: "3524" },
  { label: "Córdoba - Capilla de Sitón (+3524)", value: "3524" },
  { label: "Córdoba - Las Peñas (+3524)", value: "3524" },
  { label: "Córdoba - Simbolar (+3524)", value: "3524" },
  { label: "Córdoba - Villa del Totoral (+3524)", value: "3524" },
  { label: "Córdoba - Villa Gutiérrez (+3524)", value: "3524" },
  { label: "Córdoba - Agua de Oro (+3525)", value: "3525" },
  { label: "Córdoba - Ascochinga (+3525)", value: "3525" },
  { label: "Córdoba - Candelaria Sud (+3525)", value: "3525" },
  { label: "Córdoba - Canteras El Sauce (+3525)", value: "3525" },
  { label: "Córdoba - Cañada de Luque (+3525)", value: "3525" },
  { label: "Córdoba - Cañada de Río Pinto (+3525)", value: "3525" },
  { label: "Córdoba - Colonia Caroya (+3525)", value: "3525" },
  { label: "Córdoba - Colonia Vicente Agüero (+3525)", value: "3525" },
  { label: "Córdoba - El Manzano (+3525)", value: "3525" },
  { label: "Córdoba - Estación General Paz (+3525)", value: "3525" },
  { label: "Córdoba - Jesús María (+3525)", value: "3525" },
  { label: "Córdoba - La Granja (+3525)", value: "3525" },
  { label: "Córdoba - La Pampa (+3525)", value: "3525" },
  { label: "Córdoba - La Paz (+3525)", value: "3525" },
  { label: "Córdoba - La Puerta (+3525)", value: "3525" },
  { label: "Córdoba - Los Mistoles (+3525)", value: "3525" },
  { label: "Córdoba - Los Molles (+3525)", value: "3525" },
  { label: "Córdoba - Santa Catalina (+3525)", value: "3525" },
  { label: "Córdoba - Sarmiento (+3525)", value: "3525" },
  { label: "Córdoba - Sinsacate (+3525)", value: "3525" },
  { label: "Córdoba - Tinoco (+3525)", value: "3525" },
  { label: "Córdoba - Villa Cerro Azul (+3525)", value: "3525" },
  { label: "Córdoba - Calchín Oeste (+3532)", value: "3532" },
  { label: "Córdoba - Colazo (+3532)", value: "3532" },
  { label: "Córdoba - Colonia Almada (+3532)", value: "3532" },
  { label: "Córdoba - Colonia Videla (+3532)", value: "3532" },
  { label: "Córdoba - Las Junturas (+3532)", value: "3532" },
  { label: "Córdoba - Oliva (+3532)", value: "3532" },
  { label: "Córdoba - Pampayasta Norte (+3532)", value: "3532" },
  { label: "Córdoba - Pampayasta Sud (+3532)", value: "3532" },
  { label: "Córdoba - Alicia (+3533)", value: "3533" },
  { label: "Córdoba - El Arañado (+3533)", value: "3533" },
  { label: "Córdoba - El Fortín (+3533)", value: "3533" },
  { label: "Córdoba - Las Varas (+3533)", value: "3533" },
  { label: "Córdoba - Las Varillas (+3533)", value: "3533" },
  { label: "Córdoba - Sacanta (+3533)", value: "3533" },
  { label: "Córdoba - Saturnino María Laspiur (+3533)", value: "3533" },
  { label: "Córdoba - Villa San Esteban (+3533)", value: "3533" },
  { label: "Córdoba - Alto Alegre (+3537)", value: "3537" },
  { label: "Córdoba - Bell Ville (+3537)", value: "3537" },
  { label: "Córdoba - Chilibroste (+3537)", value: "3537" },
  { label: "Córdoba - Cintra (+3537)", value: "3537" },
  { label: "Córdoba - Idiazábal (+3537)", value: "3537" },
  { label: "Córdoba - Justiniano Posse (+3537)", value: "3537" },
  { label: "Córdoba - Laborde (+3537)", value: "3537" },
  { label: "Córdoba - Monte Leña (+3537)", value: "3537" },
  { label: "Córdoba - Morrison (+3537)", value: "3537" },
  { label: "Córdoba - Ordóñez (+3537)", value: "3537" },
  { label: "Córdoba - San Antonio de Litín (+3537)", value: "3537" },
  { label: "Córdoba - San Marcos Sud (+3537)", value: "3537" },
  { label: "Córdoba - Villa Los Patos (+3537)", value: "3537" },
  { label: "Córdoba - Bialet Massé (+3541)", value: "3541" },
  { label: "Córdoba - Cabalango (+3541)", value: "3541" },
  { label: "Córdoba - Cosquín (+3541)", value: "3541" },
  { label: "Córdoba - Cuesta Blanca (+3541)", value: "3541" },
  { label: "Córdoba - Estancia Vieja (+3541)", value: "3541" },
  { label: "Córdoba - Las Jarillas (+3541)", value: "3541" },
  { label: "Córdoba - Mallín (+3541)", value: "3541" },
  { label: "Córdoba - Mayu Sumaj (+3541)", value: "3541" },
  { label: "Córdoba - San Antonio de Arredondo (+3541)", value: "3541" },
  { label: "Córdoba - San José de los Ríos (+3541)", value: "3541" },
  { label: "Córdoba - San Nicolás (+3541)", value: "3541" },
  { label: "Córdoba - San Roque (+3541)", value: "3541" },
  { label: "Córdoba - Santa María de Punilla (+3541)", value: "3541" },
  { label: "Córdoba - Tala Huasi (+3541)", value: "3541" },
  { label: "Córdoba - Tanti (+3541)", value: "3541" },
  { label: "Córdoba - Villa Carlos Paz (+3541)", value: "3541" },
  { label: "Córdoba - Villa Flor Serrana (+3541)", value: "3541" },
  { label: "Córdoba - Villa Icho Cruz (+3541)", value: "3541" },
  { label: "Córdoba - Villa Independencia (+3541)", value: "3541" },
  { label: "Córdoba - Villa Lago Azul (+3541)", value: "3541" },
  { label: "Córdoba - Villa Parque Síquiman (+3541)", value: "3541" },
  { label: "Córdoba - Villa Santa Cruz del Lago (+3541)", value: "3541" },
  { label: "Córdoba - Ámbul (+3542)", value: "3542" },
  { label: "Córdoba - Chancaní (+3542)", value: "3542" },
  { label: "Córdoba - Ciénaga del Coro (+3542)", value: "3542" },
  { label: "Córdoba - Estancia de Guadalupe (+3542)", value: "3542" },
  { label: "Córdoba - Guasapampa (+3542)", value: "3542" },
  { label: "Córdoba - La Higuera (+3542)", value: "3542" },
  { label: "Córdoba - La Playa (+3542)", value: "3542" },
  { label: "Córdoba - Las Palmas (+3542)", value: "3542" },
  { label: "Córdoba - Los Talares (+3542)", value: "3542" },
  { label: "Córdoba - Mussi (+3542)", value: "3542" },
  { label: "Córdoba - Salsacate (+3542)", value: "3542" },
  { label: "Córdoba - San Carlos Minas (+3542)", value: "3542" },
  { label: "Córdoba - San Gerónimo (+3542)", value: "3542" },
  { label: "Córdoba - Tala Cañada (+3542)", value: "3542" },
  { label: "Córdoba - Talaini (+3542)", value: "3542" },
  { label: "Córdoba - Taninga (+3542)", value: "3542" },
  { label: "Córdoba - Tosno (+3542)", value: "3542" },
  { label: "Córdoba - Villa de Pocho (+3542)", value: "3542" },
  { label: "Córdoba - Casa Bamba (+3543)", value: "3543" },
  { label: "Córdoba - Córdoba (Argüello) (+3543)", value: "3543" },
  { label: "Córdoba - El Diquecito (+3543)", value: "3543" },
  { label: "Córdoba - La Calera (+3543)", value: "3543" },
  { label: "Córdoba - Mendiolaza (+3543)", value: "3543" },
  { label: "Córdoba - Pajas Blancas (+3543)", value: "3543" },
  { label: "Córdoba - Río Ceballos (+3543)", value: "3543" },
  { label: "Córdoba - Saldán (+3543)", value: "3543" },
  { label: "Córdoba - Salsipuedes (+3543)", value: "3543" },
  { label: "Córdoba - Unquillo (+3543)", value: "3543" },
  { label: "Córdoba - Villa Allende (+3543)", value: "3543" },
  { label: "Córdoba - Arroyo de Los Patos (+3544)", value: "3544" },
  { label: "Córdoba - Conlara (+3544)", value: "3544" },
  { label: "Córdoba - Cruz Caña (+3544)", value: "3544" },
  { label: "Córdoba - Dos Arroyos (+3544)", value: "3544" },
  { label: "Córdoba - El Huayco (+3544)", value: "3544" },
  { label: "Córdoba - El Pantanillo (+3544)", value: "3544" },
  { label: "Córdoba - La Paz (+3544)", value: "3544" },
  { label: "Córdoba - La Población (+3544)", value: "3544" },
  { label: "Córdoba - La Ramada (+3544)", value: "3544" },
  { label: "Córdoba - La Travesía (+3544)", value: "3544" },
  { label: "Córdoba - Las Calles (+3544)", value: "3544" },
  { label: "Córdoba - Las Rabonas (+3544)", value: "3544" },
  { label: "Córdoba - Las Tapias (+3544)", value: "3544" },
  { label: "Córdoba - Los Callejones (+3544)", value: "3544" },
  { label: "Córdoba - Los Cerrillos (+3544)", value: "3544" },
  { label: "Córdoba - Los Hornillos (+3544)", value: "3544" },
  { label: "Córdoba - Los Molles (+3544)", value: "3544" },
  { label: "Córdoba - Los Romeros (+3544)", value: "3544" },
  { label: "Córdoba - Luyaba (+3544)", value: "3544" },
  { label: "Córdoba - Mina Clavero (+3544)", value: "3544" },
  { label: "Córdoba - Nono (+3544)", value: "3544" },
  { label: "Córdoba - Panaholma (+3544)", value: "3544" },
  { label: "Córdoba - Quebrada de los Pozos (+3544)", value: "3544" },
  { label: "Córdoba - San Huberto (+3544)", value: "3544" },
  { label: "Córdoba - San Javier/Yacanto (+3544)", value: "3544" },
  { label: "Córdoba - San José (+3544)", value: "3544" },
  { label: "Córdoba - San Lorenzo (+3544)", value: "3544" },
  { label: "Córdoba - San Martín (+3544)", value: "3544" },
  { label: "Córdoba - San Pedro (+3544)", value: "3544" },
  { label: "Córdoba - San Vicente (+3544)", value: "3544" },
  { label: "Córdoba - Sauce Arriba (+3544)", value: "3544" },
  { label: "Córdoba - Villa Cura Brochero (+3544)", value: "3544" },
  { label: "Córdoba - Villa de Las Rosas (+3544)", value: "3544" },
  { label: "Córdoba - Villa Dolores (+3544)", value: "3544" },
  { label: "Córdoba - Villa La Viña (+3544)", value: "3544" },
  { label: "Córdoba - Villa Sarmiento (+3544)", value: "3544" },
  { label: "Córdoba - Amboy (+3546)", value: "3546" },
  { label: "Córdoba - Arroyo San Antonio (+3546)", value: "3546" },
  { label: "Córdoba - Cañada del Sauce (+3546)", value: "3546" },
  { label: "Córdoba - Capilla Vieja (+3546)", value: "3546" },
  { label: "Córdoba - El Corcovado - El Torreón (+3546)", value: "3546" },
  { label: "Córdoba - El Durazno (+3546)", value: "3546" },
  { label: "Córdoba - La Cruz (+3546)", value: "3546" },
  { label: "Córdoba - La Cumbrecita (+3546)", value: "3546" },
  { label: "Córdoba - Los Reartes (+3546)", value: "3546" },
  { label: "Córdoba - Lutti (+3546)", value: "3546" },
  { label: "Córdoba - Parque Calmayo (+3546)", value: "3546" },
  { label: "Córdoba - San Ignacio (+3546)", value: "3546" },
  { label: "Córdoba - Santa Rosa de Calamuchita (+3546)", value: "3546" },
  { label: "Córdoba - Villa Alpina (+3546)", value: "3546" },
  { label: "Córdoba - Villa Amancay (+3546)", value: "3546" },
  { label: "Córdoba - Villa Berna (+3546)", value: "3546" },
  { label: "Córdoba - Villa Ciudad Parque Los Reartes (+3546)", value: "3546" },
  { label: "Córdoba - Villa del Dique (+3546)", value: "3546" },
  { label: "Córdoba - Villa General Belgrano (+3546)", value: "3546" },
  { label: "Córdoba - Villa La Rivera (+3546)", value: "3546" },
  { label: "Córdoba - Villa Quillinzo (+3546)", value: "3546" },
  { label: "Córdoba - Villa Rumipal (+3546)", value: "3546" },
  { label: "Córdoba - Villa Yacanto (+3546)", value: "3546" },
  { label: "Córdoba - Alta Gracia (+3547)", value: "3547" },
  { label: "Córdoba - Anisacate (+3547)", value: "3547" },
  { label: "Córdoba - Costa Azul (+3547)", value: "3547" },
  { label: "Córdoba - Despeñaderos (+3547)", value: "3547" },
  { label: "Córdoba - Dique Chico (+3547)", value: "3547" },
  { label: "Córdoba - Falda del Cañete (+3547)", value: "3547" },
  { label: "Córdoba - Falda del Carmen José de la Quintana (+3547)", value: "3547" },
  { label: "Córdoba - La Boca del Río (+3547)", value: "3547" },
  { label: "Córdoba - La Paisanita (+3547)", value: "3547" },
  { label: "Córdoba - La Rancherita (+3547)", value: "3547" },
  { label: "Córdoba - La Serranita (+3547)", value: "3547" },
  { label: "Córdoba - Las Quintas (+3547)", value: "3547" },
  { label: "Córdoba - Los Cedros (+3547)", value: "3547" },
  { label: "Córdoba - Los Molinos (+3547)", value: "3547" },
  { label: "Córdoba - Monte Ralo (+3547)", value: "3547" },
  { label: "Córdoba - Potrero de Garay (+3547)", value: "3547" },
  { label: "Córdoba - Rafael García (+3547)", value: "3547" },
  { label: "Córdoba - San Agustín (+3547)", value: "3547" },
  { label: "Córdoba - San Clemente (+3547)", value: "3547" },
  { label: "Córdoba - Solar de los Molinos (+3547)", value: "3547" },
  { label: "Córdoba - Valle Alegre (+3547)", value: "3547" },
  { label: "Córdoba - Valle de Anisacate (+3547)", value: "3547" },
  { label: "Córdoba - Villa Ciudad de América (+3547)", value: "3547" },
  { label: "Córdoba - Villa del Prado (+3547)", value: "3547" },
  { label: "Córdoba - Villa La Bolsa (+3547)", value: "3547" },
  { label: "Córdoba - Villa Los Aromos (+3547)", value: "3547" },
  { label: "Córdoba - Villa Parque Santa Ana (+3547)", value: "3547" },
  { label: "Córdoba - Villa San Isidro (+3547)", value: "3547" },
  { label: "Córdoba - Villa San Miguel (+3547)", value: "3547" },
  { label: "Córdoba - Capilla del Monte (+3548)", value: "3548" },
  { label: "Córdoba - Casa Grande (+3548)", value: "3548" },
  { label: "Córdoba - Charbonier (+3548)", value: "3548" },
  { label: "Córdoba - Cruz Chica (+3548)", value: "3548" },
  { label: "Córdoba - Cruz Grande (+3548)", value: "3548" },
  { label: "Córdoba - Dolores (+3548)", value: "3548" },
  { label: "Córdoba - Huerta Grande (+3548)", value: "3548" },
  { label: "Córdoba - La Cumbre (+3548)", value: "3548" },
  { label: "Córdoba - La Falda (+3548)", value: "3548" },
  { label: "Córdoba - Las Cañadas (+3548)", value: "3548" },
  { label: "Córdoba - Los Cocos (+3548)", value: "3548" },
  { label: "Córdoba - Quebrada de Luna (+3548)", value: "3548" },
  { label: "Córdoba - San Esteban (+3548)", value: "3548" },
  { label: "Córdoba - Valle Hermoso (+3548)", value: "3548" },
  { label: "Córdoba - Villa Giardino (+3548)", value: "3548" },
  { label: "Córdoba - Alto de los Quebrachos (+3549)", value: "3549" },
  { label: "Córdoba - Bañado de Soto (+3549)", value: "3549" },
  { label: "Córdoba - Canteras Quilpo (+3549)", value: "3549" },
  { label: "Córdoba - Cruz de Caña (+3549)", value: "3549" },
  { label: "Córdoba - Cruz del Eje (+3549)", value: "3549" },
  { label: "Córdoba - El Brete (+3549)", value: "3549" },
  { label: "Córdoba - El Chacho (+3549)", value: "3549" },
  { label: "Córdoba - El Rincón (+3549)", value: "3549" },
  { label: "Córdoba - Guanaco Muerto (+3549)", value: "3549" },
  { label: "Córdoba - La Banda (+3549)", value: "3549" },
  { label: "Córdoba - La Batea (+3549)", value: "3549" },
  { label: "Córdoba - Las Playas (+3549)", value: "3549" },
  { label: "Córdoba - Los Chañaritos (+3549)", value: "3549" },
  { label: "Córdoba - Media Naranja (+3549)", value: "3549" },
  { label: "Córdoba - Olivares de San Nicolás (+3549)", value: "3549" },
  { label: "Córdoba - Paso Viejo (+3549)", value: "3549" },
  { label: "Córdoba - San Marcos Sierras (+3549)", value: "3549" },
  { label: "Córdoba - Serrezuela (+3549)", value: "3549" },
  { label: "Córdoba - Tuclame (+3549)", value: "3549" },
  { label: "Córdoba - Villa de Soto (+3549)", value: "3549" },
  { label: "Córdoba - Altos de Chipión (+3562)", value: "3562" },
  { label: "Córdoba - Brinkmann (+3562)", value: "3562" },
  { label: "Córdoba - Colonia Diez de Julio (+3562)", value: "3562" },
  { label: "Córdoba - Colonia San Pedro (+3562)", value: "3562" },
  { label: "Córdoba - Colonia Valtelina (+3562)", value: "3562" },
  { label: "Córdoba - La Paquita (+3562)", value: "3562" },
  { label: "Córdoba - Morteros (+3562)", value: "3562" },
  { label: "Córdoba - Balnearia (+3563)", value: "3563" },
  { label: "Córdoba - Marull (+3563)", value: "3563" },
  { label: "Córdoba - Miramar (+3563)", value: "3563" },
  { label: "Córdoba - Trinchera (+3563)", value: "3563" },
  { label: "Córdoba - Colonia Anita (+3564)", value: "3564" },
  { label: "Córdoba - Colonia Marina (+3564)", value: "3564" },
  { label: "Córdoba - Colonia Prosperidad (+3564)", value: "3564" },
  { label: "Córdoba - Colonia San Bartolomé (+3564)", value: "3564" },
  { label: "Córdoba - Colonia Santa María (+3564)", value: "3564" },
  { label: "Córdoba - Colonia Vignaud (+3564)", value: "3564" },
  { label: "Córdoba - Devoto (+3564)", value: "3564" },
  { label: "Córdoba - Estación Luxardo (+3564)", value: "3564" },
  { label: "Córdoba - La Francia (+3564)", value: "3564" },
  { label: "Córdoba - Plaza Luxardo (+3564)", value: "3564" },
  { label: "Córdoba - Plaza San Francisco (+3564)", value: "3564" },
  { label: "Córdoba - Porteña (+3564)", value: "3564" },
  { label: "Córdoba - Quebracho Herrado (+3564)", value: "3564" },
  { label: "Córdoba - San Francisco (+3564)", value: "3564" },
  { label: "Córdoba - Seeber (+3564)", value: "3564" },
  { label: "Córdoba - Almafuerte (+3571)", value: "3571" },
  { label: "Córdoba - Corralito (+3571)", value: "3571" },
  { label: "Córdoba - Embalse (+3571)", value: "3571" },
  { label: "Córdoba - General Fotheringham (+3571)", value: "3571" },
  { label: "Córdoba - Las Bajadas (+3571)", value: "3571" },
  { label: "Córdoba - Los Cóndores (+3571)", value: "3571" },
  { label: "Córdoba - Río Tercero (+3571)", value: "3571" },
  { label: "Córdoba - Segunda Usina (+3571)", value: "3571" },
  { label: "Córdoba - Tancacha (+3571)", value: "3571" },
  { label: "Córdoba - Villa Ascasubi (+3571)", value: "3571" },
  { label: "Córdoba - Costa Sacate (+3572)", value: "3572" },
  { label: "Córdoba - Impira (+3572)", value: "3572" },
  { label: "Córdoba - Laguna Larga (+3572)", value: "3572" },
  { label: "Córdoba - Lozada (+3572)", value: "3572" },
  { label: "Córdoba - Manfredi (+3572)", value: "3572" },
  { label: "Córdoba - Oncativo (+3572)", value: "3572" },
  { label: "Córdoba - Pilar (+3572)", value: "3572" },
  { label: "Córdoba - Río Segundo (+3572)", value: "3572" },
  { label: "Córdoba - Calchín (+3573)", value: "3573" },
  { label: "Córdoba - Capilla del Carmen (+3573)", value: "3573" },
  { label: "Córdoba - Luque (+3573)", value: "3573" },
  { label: "Córdoba - Matorrales (+3573)", value: "3573" },
  { label: "Córdoba - Rincón (+3573)", value: "3573" },
  { label: "Córdoba - Villa del Rosario (+3573)", value: "3573" },
  { label: "Córdoba - Cañada de Machado (+3574)", value: "3574" },
  { label: "Córdoba - Capilla de los Remedios (+3574)", value: "3574" },
  { label: "Córdoba - Colonia Las Cuatro Esquinas (+3574)", value: "3574" },
  { label: "Córdoba - Comechingones (+3574)", value: "3574" },
  { label: "Córdoba - El Alcalde (+3574)", value: "3574" },
  { label: "Córdoba - El Crispín (+3574)", value: "3574" },
  { label: "Córdoba - Esquina (+3574)", value: "3574" },
  { label: "Córdoba - Kilómetro 658 (+3574)", value: "3574" },
  { label: "Córdoba - Monte del Rosario (+3574)", value: "3574" },
  { label: "Córdoba - Piquillín (+3574)", value: "3574" },
  { label: "Córdoba - Río Primero (+3574)", value: "3574" },
  { label: "Córdoba - Sagrada Familia (+3574)", value: "3574" },
  { label: "Córdoba - Santa Rosa de Río Primero (+3574)", value: "3574" },
  { label: "Córdoba - Santiago Temple (+3574)", value: "3574" },
  { label: "Córdoba - Atahona (+3575)", value: "3575" },
  { label: "Córdoba - Chalacea (+3575)", value: "3575" },
  { label: "Córdoba - Diego de Rojas (+3575)", value: "3575" },
  { label: "Córdoba - La Para (+3575)", value: "3575" },
  { label: "Córdoba - La Posta (+3575)", value: "3575" },
  { label: "Córdoba - La Puerta (+3575)", value: "3575" },
  { label: "Córdoba - La Quinta (+3575)", value: "3575" },
  { label: "Córdoba - Las Saladas (+3575)", value: "3575" },
  { label: "Córdoba - Maquinista Gallini (+3575)", value: "3575" },
  { label: "Córdoba - Obispo Trejo (+3575)", value: "3575" },
  { label: "Córdoba - Plaza de Mercedes (+3575)", value: "3575" },
  { label: "Córdoba - Villa Fontana (+3575)", value: "3575" },
  { label: "Córdoba - Arroyito (+3576)", value: "3576" },
  { label: "Córdoba - Colonia Las Pichanas (+3576)", value: "3576" },
  { label: "Córdoba - El Fuertecito (+3576)", value: "3576" },
  { label: "Córdoba - El Tío (+3576)", value: "3576" },
  { label: "Córdoba - La Tordilla (+3576)", value: "3576" },
  { label: "Córdoba - Las Gramillas (+3576)", value: "3576" },
  { label: "Córdoba - Los Chañaritos (+3576)", value: "3576" },
  { label: "Córdoba - Toro Pujio (+3576)", value: "3576" },
  { label: "Córdoba - Tránsito (+3576)", value: "3576" },
  { label: "Córdoba - Villa Concepción del Tío (+3576)", value: "3576" },
  { label: "Córdoba - Villa del Tránsito (+3576)", value: "3576" },
  { label: "Córdoba - Villa Vaudagna (+3576)", value: "3576" },
  { label: "Córdoba - Achiras (+3582)", value: "3582" },
  { label: "Córdoba - Bulnes (+3582)", value: "3582" },
  { label: "Córdoba - Chaján (+3582)", value: "3582" },
  { label: "Córdoba - Coronel Moldes (+3582)", value: "3582" },
  { label: "Córdoba - La Punilla (+3582)", value: "3582" },
  { label: "Córdoba - Malena (+3582)", value: "3582" },
  { label: "Córdoba - Sampacho (+3582)", value: "3582" },
  { label: "Córdoba - Suco (+3582)", value: "3582" },
  { label: "Córdoba - Del Campillo (+3583)", value: "3583" },
  { label: "Córdoba - La Cautiva (+3583)", value: "3583" },
  { label: "Córdoba - Mattaldi (+3583)", value: "3583" },
  { label: "Córdoba - Nicolás Bruzzone (+3583)", value: "3583" },
  { label: "Córdoba - Tosquita (+3583)", value: "3583" },
  { label: "Córdoba - Vicuña Mackenna (+3583)", value: "3583" },
  { label: "Córdoba - Villa Sarmiento (+3583)", value: "3583" },
  { label: "Córdoba - Villa Valeria (+3583)", value: "3583" },
  { label: "Córdoba - Washington (+3583)", value: "3583" },
  { label: "Córdoba - Assunta (+3584)", value: "3584" },
  { label: "Córdoba - El Rastreador (+3584)", value: "3584" },
  { label: "Córdoba - Huanchillas (+3584)", value: "3584" },
  { label: "Córdoba - La Carlota (+3584)", value: "3584" },
  { label: "Córdoba - Los Cisnes (+3584)", value: "3584" },
  { label: "Córdoba - Pacheco de Melo (+3584)", value: "3584" },
  { label: "Córdoba - Santa Eufemia (+3584)", value: "3584" },
  { label: "Córdoba - Adelia María (+3585)", value: "3585" },
  { label: "Córdoba - Monte de Los Gauchos (+3585)", value: "3585" },
  { label: "Córdoba - San Basilio (+3585)", value: "3585" },
  { label: "Corrientes - Barrio Esperanza (+379)", value: "379" },
  { label: "Corrientes - Corrientes (+379)", value: "379" },
  { label: "Corrientes - El Sombrero (+379)", value: "379" },
  { label: "Corrientes - Empedrado (+379)", value: "379" },
  { label: "Corrientes - Herlitzka (+379)", value: "379" },
  { label: "Corrientes - Itatí (+379)", value: "379" },
  { label: "Corrientes - Laguna Brava (+379)", value: "379" },
  { label: "Corrientes - Paso de la Patria (+379)", value: "379" },
  { label: "Corrientes - Ramada Paso (+379)", value: "379" },
  { label: "Corrientes - Riachuelo (+379)", value: "379" },
  { label: "Corrientes - San Cayetano (+379)", value: "379" },
  { label: "Corrientes - San Cosme (+379)", value: "379" },
  { label: "Corrientes - San Luis del Palmar (+379)", value: "379" },
  { label: "Corrientes - Santa Ana de los Guácaras (+379)", value: "379" },
  { label: "Corrientes - Garabí (+3756)", value: "3756" },
  { label: "Corrientes - Garruchos (+3756)", value: "3756" },
  { label: "Corrientes - Gobernador Virasoro (+3756)", value: "3756" },
  { label: "Corrientes - Santo Tomé (+3756)", value: "3756" },
  { label: "Corrientes - Colonia Liebig (+3758)", value: "3758" },
  { label: "Corrientes - San Carlos (+3758)", value: "3758" },
  { label: "Corrientes - San José (+3758)", value: "3758" },
  { label: "Corrientes - Alvear (+3772)", value: "3772" },
  { label: "Corrientes - Bonpland (+3772)", value: "3772" },
  { label: "Corrientes - Estación Torrent (+3772)", value: "3772" },
  { label: "Corrientes - Guaviraví (+3772)", value: "3772" },
  { label: "Corrientes - La Cruz (+3772)", value: "3772" },
  { label: "Corrientes - Parada Pucheta (+3772)", value: "3772" },
  { label: "Corrientes - Paso de los Libres (+3772)", value: "3772" },
  { label: "Corrientes - Tapebicuá (+3772)", value: "3772" },
  { label: "Corrientes - Yapeyú (+3772)", value: "3772" },
  { label: "Corrientes - Chavarría (+3773)", value: "3773" },
  { label: "Corrientes - Colonia Carlos Pellegrini (+3773)", value: "3773" },
  { label: "Corrientes - Felipe Yofre (+3773)", value: "3773" },
  { label: "Corrientes - Mariano I. Loza (+3773)", value: "3773" },
  { label: "Corrientes - Mercedes (+3773)", value: "3773" },
  { label: "Corrientes - Perugorría (+3773)", value: "3773" },
  { label: "Corrientes - Cazadores Correntinos (+3774)", value: "3774" },
  { label: "Corrientes - Curuzú Cuatiá (+3774)", value: "3774" },
  { label: "Corrientes - Sauce (+3774)", value: "3774" },
  { label: "Corrientes - Colonia Libertad (+3775)", value: "3775" },
  { label: "Corrientes - Estación Libertad (+3775)", value: "3775" },
  { label: "Corrientes - Juan Pujol (+3775)", value: "3775" },
  { label: "Corrientes - Labougle (+3775)", value: "3775" },
  { label: "Corrientes - Mocoretá (+3775)", value: "3775" },
  { label: "Corrientes - Monte Caseros (+3775)", value: "3775" },
  { label: "Corrientes - Parada Acuña (+3775)", value: "3775" },
  { label: "Corrientes - Bella Vista (+3777)", value: "3777" },
  { label: "Corrientes - Colonia Carolina (+3777)", value: "3777" },
  { label: "Corrientes - Colonia Pando (+3777)", value: "3777" },
  { label: "Corrientes - Cruz de los Milagros (+3777)", value: "3777" },
  { label: "Corrientes - Esquina (+3777)", value: "3777" },
  { label: "Corrientes - Gobernador Juan E. Martínez (+3777)", value: "3777" },
  { label: "Corrientes - Goya (+3777)", value: "3777" },
  { label: "Corrientes - Lavalle (+3777)", value: "3777" },
  { label: "Corrientes - Nueve de Julio (+3777)", value: "3777" },
  { label: "Corrientes - Pedro R. Fernández (+3777)", value: "3777" },
  { label: "Corrientes - Pueblo Libertador (+3777)", value: "3777" },
  { label: "Corrientes - San Isidro (+3777)", value: "3777" },
  { label: "Corrientes - San Roque (+3777)", value: "3777" },
  { label: "Corrientes - Santa Lucía (+3777)", value: "3777" },
  { label: "Corrientes - Tres de Abril (+3777)", value: "3777" },
  { label: "Corrientes - Villa Córdoba (+3777)", value: "3777" },
  { label: "Corrientes - Yatay Tí Calle (+3777)", value: "3777" },
  { label: "Corrientes - Berón de Astrada (+3781)", value: "3781" },
  { label: "Corrientes - Caá Catí (+3781)", value: "3781" },
  { label: "Corrientes - Itá Ibaté (+3781)", value: "3781" },
  { label: "Corrientes - Lomas de Vallejos (+3781)", value: "3781" },
  { label: "Corrientes - Loreto (+3781)", value: "3781" },
  { label: "Corrientes - Palmar Grande (+3781)", value: "3781" },
  { label: "Corrientes - San Miguel (+3781)", value: "3781" },
  { label: "Corrientes - Tacuaral (+3781)", value: "3781" },
  { label: "Corrientes - Yahapé (+3781)", value: "3781" },
  { label: "Corrientes - Colonia Santa Rosa (+3782)", value: "3782" },
  { label: "Corrientes - Concepción (+3782)", value: "3782" },
  { label: "Corrientes - Mburucuyá (+3782)", value: "3782" },
  { label: "Corrientes - Pago de los Deseos (+3782)", value: "3782" },
  { label: "Corrientes - Saladas (+3782)", value: "3782" },
  { label: "Corrientes - San Lorenzo (+3782)", value: "3782" },
  { label: "Corrientes - Tabay (+3782)", value: "3782" },
  { label: "Corrientes - Tatacuá (+3782)", value: "3782" },
  { label: "Corrientes - Ituzaingó (+3786)", value: "3786" },
  { label: "Corrientes - San Antonio (+3786)", value: "3786" },
  { label: "Corrientes - Villa Olivari (+3786)", value: "3786" },
  { label: "Corrientes - Las Esquinas (+3832)", value: "3832" },
  { label: "Entre Ríos - Aldea Brasilera (+343)", value: "343" },
  { label: "Entre Ríos - Aldea María Luisa (+343)", value: "343" },
  { label: "Entre Ríos - Aldea Protestante (+343)", value: "343" },
  { label: "Entre Ríos - Aldea Salto (+343)", value: "343" },
  { label: "Entre Ríos - Aldea Santa María (+343)", value: "343" },
  { label: "Entre Ríos - Aldea Spatzenkutter (+343)", value: "343" },
  { label: "Entre Ríos - Aldea Valle María (+343)", value: "343" },
  { label: "Entre Ríos - Cerrito (+343)", value: "343" },
  { label: "Entre Ríos - Colonia Avellaneda (+343)", value: "343" },
  { label: "Entre Ríos - Colonia Ensayo (+343)", value: "343" },
  { label: "Entre Ríos - Crespo (+343)", value: "343" },
  { label: "Entre Ríos - Diamante (+343)", value: "343" },
  { label: "Entre Ríos - El Palenque (+343)", value: "343" },
  { label: "Entre Ríos - El Pingo (+343)", value: "343" },
  { label: "Entre Ríos - Estación Camps (+343)", value: "343" },
  { label: "Entre Ríos - General Racedo (+343)", value: "343" },
  { label: "Entre Ríos - General Ramírez (+343)", value: "343" },
  { label: "Entre Ríos - Gobernador Etchevehere (+343)", value: "343" },
  { label: "Entre Ríos - Hasenkamp (+343)", value: "343" },
  { label: "Entre Ríos - La Picada (+343)", value: "343" },
  { label: "Entre Ríos - Las Tunas (+343)", value: "343" },
  { label: "Entre Ríos - Libertador San Martín (+343)", value: "343" },
  { label: "Entre Ríos - María Grande (+343)", value: "343" },
  { label: "Entre Ríos - Oro Verde (+343)", value: "343" },
  { label: "Entre Ríos - Paraná (+343)", value: "343" },
  { label: "Entre Ríos - Paso de la Arena (+343)", value: "343" },
  { label: "Entre Ríos - Pueblo Bellocq (+343)", value: "343" },
  { label: "Entre Ríos - Pueblo Brugo (+343)", value: "343" },
  { label: "Entre Ríos - Puerto Alvear (+343)", value: "343" },
  { label: "Entre Ríos - Puerto Las Cuevas (+343)", value: "343" },
  { label: "Entre Ríos - San Benito (+343)", value: "343" },
  { label: "Entre Ríos - Sauce Montrull (+343)", value: "343" },
  { label: "Entre Ríos - Sauce Pinto (+343)", value: "343" },
  { label: "Entre Ríos - Seguí (+343)", value: "343" },
  { label: "Entre Ríos - Sosa (+343)", value: "343" },
  { label: "Entre Ríos - Tabossi (+343)", value: "343" },
  { label: "Entre Ríos - Tezanos Pinto (+343)", value: "343" },
  { label: "Entre Ríos - Viale (+343)", value: "343" },
  { label: "Entre Ríos - Villa Fontana (+343)", value: "343" },
  { label: "Entre Ríos - Villa Hernandarias (+343)", value: "343" },
  { label: "Entre Ríos - Villa Urquiza (+343)", value: "343" },
  { label: "Entre Ríos - Clodomiro Ledesma (+345)", value: "345" },
  { label: "Entre Ríos - Colonia Ayuí (+345)", value: "345" },
  { label: "Entre Ríos - Colonia Baylina (+345)", value: "345" },
  { label: "Entre Ríos - Colonia Oficial Nº 5 (+345)", value: "345" },
  { label: "Entre Ríos - Colonia Roca (+345)", value: "345" },
  { label: "Entre Ríos - Colonia San Justo (+345)", value: "345" },
  { label: "Entre Ríos - Concordia (+345)", value: "345" },
  { label: "Entre Ríos - El Redomón (+345)", value: "345" },
  { label: "Entre Ríos - Estación Yeruá (+345)", value: "345" },
  { label: "Entre Ríos - Estancia Grande (+345)", value: "345" },
  { label: "Entre Ríos - General Campos (+345)", value: "345" },
  { label: "Entre Ríos - Hambis (+345)", value: "345" },
  { label: "Entre Ríos - La Criolla (+345)", value: "345" },
  { label: "Entre Ríos - Los Charrúas (+345)", value: "345" },
  { label: "Entre Ríos - Nueva Escocia (+345)", value: "345" },
  { label: "Entre Ríos - Pedernal (+345)", value: "345" },
  { label: "Entre Ríos - Puerto Yeruá (+345)", value: "345" },
  { label: "Entre Ríos - San Salvador (+345)", value: "345" },
  { label: "Entre Ríos - Ubajay (+345)", value: "345" },
  { label: "Entre Ríos - Walter Moss (+345)", value: "345" },
  { label: "Entre Ríos - Betbeder (+3435)", value: "3435" },
  { label: "Entre Ríos - Don Cristóbal Primero (+3435)", value: "3435" },
  { label: "Entre Ríos - Febre (+3435)", value: "3435" },
  { label: "Entre Ríos - Hernández (+3435)", value: "3435" },
  { label: "Entre Ríos - Lucas González (+3435)", value: "3435" },
  { label: "Entre Ríos - Nogoyá (+3435)", value: "3435" },
  { label: "Entre Ríos - XX de Setiembre (+3435)", value: "3435" },
  { label: "Entre Ríos - Antelo (+3436)", value: "3436" },
  { label: "Entre Ríos - Aranguren (+3436)", value: "3436" },
  { label: "Entre Ríos - Chilcas (+3436)", value: "3436" },
  { label: "Entre Ríos - Laguna del Pescado (+3436)", value: "3436" },
  { label: "Entre Ríos - Molino Doll (+3436)", value: "3436" },
  { label: "Entre Ríos - Rincón de Nogoyá (+3436)", value: "3436" },
  { label: "Entre Ríos - Victoria (+3436)", value: "3436" },
  { label: "Entre Ríos - La Paz (+3437)", value: "3437" },
  { label: "Entre Ríos - San Gustavo (+3437)", value: "3437" },
  { label: "Entre Ríos - Santa Elena (+3437)", value: "3437" },
  { label: "Entre Ríos - Bovril (+3438)", value: "3438" },
  { label: "Entre Ríos - Colonia Avigdor (+3438)", value: "3438" },
  { label: "Entre Ríos - El Solar (+3438)", value: "3438" },
  { label: "Entre Ríos - Piedras Blancas (+3438)", value: "3438" },
  { label: "Entre Ríos - Sauce de Luna (+3438)", value: "3438" },
  { label: "Entre Ríos - Sir Leonard (+3438)", value: "3438" },
  { label: "Entre Ríos - Villa Alcaraz (+3438)", value: "3438" },
  { label: "Entre Ríos - Caseros (+3442)", value: "3442" },
  { label: "Entre Ríos - Colonia Elía (+3442)", value: "3442" },
  { label: "Entre Ríos - Concepción del Uruguay (+3442)", value: "3442" },
  { label: "Entre Ríos - Herrera (+3442)", value: "3442" },
  { label: "Entre Ríos - Pronunciamiento (+3442)", value: "3442" },
  { label: "Entre Ríos - Villa San Justo (+3442)", value: "3442" },
  { label: "Entre Ríos - Aldea Asunción (+3444)", value: "3444" },
  { label: "Entre Ríos - Distrito Sexto Costa de Nogoyá (+3444)", value: "3444" },
  { label: "Entre Ríos - Enrique Carbó (+3444)", value: "3444" },
  { label: "Entre Ríos - Estación Lazo (+3444)", value: "3444" },
  { label: "Entre Ríos - General Galarza (+3444)", value: "3444" },
  { label: "Entre Ríos - Gualeguay (+3444)", value: "3444" },
  { label: "Entre Ríos - Altamirano Sur (+3445)", value: "3445" },
  { label: "Entre Ríos - Arroyo Clé (+3445)", value: "3445" },
  { label: "Entre Ríos - Basavilbaso (+3445)", value: "3445" },
  { label: "Entre Ríos - Estación Gobernador Echagüe (+3445)", value: "3445" },
  { label: "Entre Ríos - Estación Gobernador Sola (+3445)", value: "3445" },
  { label: "Entre Ríos - Estación Líbaros (+3445)", value: "3445" },
  { label: "Entre Ríos - Gobernador Mansilla (+3445)", value: "3445" },
  { label: "Entre Ríos - Guardamonte (+3445)", value: "3445" },
  { label: "Entre Ríos - Las Guachas (+3445)", value: "3445" },
  { label: "Entre Ríos - Las Moscas (+3445)", value: "3445" },
  { label: "Entre Ríos - Maciá (+3445)", value: "3445" },
  { label: "Entre Ríos - Rocamora (+3445)", value: "3445" },
  { label: "Entre Ríos - Rosario del Tala (+3445)", value: "3445" },
  { label: "Entre Ríos - Santa Anita (+3445)", value: "3445" },
  { label: "Entre Ríos - Villa Mantero (+3445)", value: "3445" },
  { label: "Entre Ríos - Villa San Marcial (+3445)", value: "3445" },
  { label: "Entre Ríos - Aldea San Antonio (Gualeguaychú) (+3446)", value: "3446" },
  { label: "Entre Ríos - Aldea San Juan (+3446)", value: "3446" },
  { label: "Entre Ríos - Ceibas (+3446)", value: "3446" },
  { label: "Entre Ríos - Estación Escriña (+3446)", value: "3446" },
  { label: "Entre Ríos - Faustino M. Parera (+3446)", value: "3446" },
  { label: "Entre Ríos - General Almada (+3446)", value: "3446" },
  { label: "Entre Ríos - Gilbert (+3446)", value: "3446" },
  { label: "Entre Ríos - Gualeguaychú (+3446)", value: "3446" },
  { label: "Entre Ríos - Irazusta (+3446)", value: "3446" },
  { label: "Entre Ríos - Larroque (+3446)", value: "3446" },
  { label: "Entre Ríos - Médanos (+3446)", value: "3446" },
  { label: "Entre Ríos - Ñancay (+3446)", value: "3446" },
  { label: "Entre Ríos - Pastor Britos (+3446)", value: "3446" },
  { label: "Entre Ríos - Pueblo General Belgrano (+3446)", value: "3446" },
  { label: "Entre Ríos - Puerto Ibicuy (+3446)", value: "3446" },
  { label: "Entre Ríos - Rincón del Cinto (+3446)", value: "3446" },
  { label: "Entre Ríos - Rincón del Gato (+3446)", value: "3446" },
  { label: "Entre Ríos - Urdinarrain (+3446)", value: "3446" },
  { label: "Entre Ríos - Villa Paranacito (+3446)", value: "3446" },
  { label: "Entre Ríos - Arroyo Barú (+3447)", value: "3447" },
  { label: "Entre Ríos - Colón (+3447)", value: "3447" },
  { label: "Entre Ríos - Colonia Hocker (+3447)", value: "3447" },
  { label: "Entre Ríos - Colonia San Anselmo y Aledañas (+3447)", value: "3447" },
  { label: "Entre Ríos - La Clarita (+3447)", value: "3447" },
  { label: "Entre Ríos - Primero de Mayo (+3447)", value: "3447" },
  { label: "Entre Ríos - Pueblo Cazes (+3447)", value: "3447" },
  { label: "Entre Ríos - Pueblo Liebig (+3447)", value: "3447" },
  { label: "Entre Ríos - San Ernesto (+3447)", value: "3447" },
  { label: "Entre Ríos - San José (+3447)", value: "3447" },
  { label: "Entre Ríos - Villa Elisa (+3447)", value: "3447" },
  { label: "Entre Ríos - Conscripto Bernardi (+3454)", value: "3454" },
  { label: "Entre Ríos - El Cimarrón (+3454)", value: "3454" },
  { label: "Entre Ríos - Federal (+3454)", value: "3454" },
  { label: "Entre Ríos - Nueva Vizcaya (+3454)", value: "3454" },
  { label: "Entre Ríos - Durazno (+3455)", value: "3455" },
  { label: "Entre Ríos - Estación Raíces (+3455)", value: "3455" },
  { label: "Entre Ríos - Ingeniero Sajaroff (+3455)", value: "3455" },
  { label: "Entre Ríos - Mojones Norte (+3455)", value: "3455" },
  { label: "Entre Ríos - Paso de la Laguna (+3455)", value: "3455" },
  { label: "Entre Ríos - Villa Clara (+3455)", value: "3455" },
  { label: "Entre Ríos - Villa Domínguez (+3455)", value: "3455" },
  { label: "Entre Ríos - Villaguay (+3455)", value: "3455" },
  { label: "Entre Ríos - Chajarí (+3456)", value: "3456" },
  { label: "Entre Ríos - Colonia Alemana (+3456)", value: "3456" },
  { label: "Entre Ríos - Colonia La Argentina (+3456)", value: "3456" },
  { label: "Entre Ríos - Colonia Peña (+3456)", value: "3456" },
  { label: "Entre Ríos - Colonia Santa María (+3456)", value: "3456" },
  { label: "Entre Ríos - Federación (+3456)", value: "3456" },
  { label: "Entre Ríos - La Florida (+3456)", value: "3456" },
  { label: "Entre Ríos - San Pedro (+3456)", value: "3456" },
  { label: "Entre Ríos - Santa Ana (+3456)", value: "3456" },
  { label: "Entre Ríos - Villa del Rosario (+3456)", value: "3456" },
  { label: "Entre Ríos - Estación La Esmeralda (+3458)", value: "3458" },
  { label: "Entre Ríos - La Hierra (+3458)", value: "3458" },
  { label: "Entre Ríos - Los Conquistadores (+3458)", value: "3458" },
  { label: "Entre Ríos - San Jaime de la Frontera (+3458)", value: "3458" },
  { label: "Entre Ríos - San José de Feliciano (+3458)", value: "3458" },
  { label: "Entre Ríos - San Víctor (+3458)", value: "3458" },
  { label: "Formosa - Banco Payaguá (+370)", value: "370" },
  { label: "Formosa - Colonia Pastoril (+370)", value: "370" },
  { label: "Formosa - El Colorado (+370)", value: "370" },
  { label: "Formosa - Formosa (+370)", value: "370" },
  { label: "Formosa - General Lucio V. Mansilla (+370)", value: "370" },
  { label: "Formosa - Gran Guardia (+370)", value: "370" },
  { label: "Formosa - Herradura (+370)", value: "370" },
  { label: "Formosa - Mariano Boedo (+370)", value: "370" },
  { label: "Formosa - Mayor Vicente Villafañe (+370)", value: "370" },
  { label: "Formosa - Mojón de Fierro (+370)", value: "370" },
  { label: "Formosa - Palo Santo (+370)", value: "370" },
  { label: "Formosa - Pirané (+370)", value: "370" },
  { label: "Formosa - San Francisco de Laishi (+370)", value: "370" },
  { label: "Formosa - San Hilario (+370)", value: "370" },
  { label: "Formosa - Subteniente Perín (+370)", value: "370" },
  { label: "Formosa - Tatané (+370)", value: "370" },
  { label: "Formosa - Villa del Carmen (+370)", value: "370" },
  { label: "Formosa - Villa Dos Trece (+370)", value: "370" },
  { label: "Formosa - Villa Escolar (+370)", value: "370" },
  { label: "Formosa - Villa Trinidad (+370)", value: "370" },
  { label: "Formosa - El Potrillo (+3711)", value: "3711" },
  { label: "Formosa - General Mosconi (+3711)", value: "3711" },
  { label: "Formosa - Ingeniero Juárez (+3711)", value: "3711" },
  { label: "Formosa - Laguna Yema (+3711)", value: "3711" },
  { label: "Formosa - Los Chiriguanos (+3711)", value: "3711" },
  { label: "Formosa - Pozo de Maza (+3711)", value: "3711" },
  { label: "Formosa - Pozo del Mortero (+3711)", value: "3711" },
  { label: "Formosa - El Espinillo (+3715)", value: "3715" },
  { label: "Formosa - Las Lomitas (+3715)", value: "3715" },
  { label: "Formosa - Pozo del Tigre (+3715)", value: "3715" },
  { label: "Formosa - Bartolomé de las Casas (+3716)", value: "3716" },
  { label: "Formosa - Colonia Sarmiento (+3716)", value: "3716" },
  { label: "Formosa - Comandante Fontana (+3716)", value: "3716" },
  { label: "Formosa - El Recreo (+3716)", value: "3716" },
  { label: "Formosa - Estanislao del Campo (+3716)", value: "3716" },
  { label: "Formosa - Fortín Leyes (+3716)", value: "3716" },
  { label: "Formosa - Fortín Lugones (+3716)", value: "3716" },
  { label: "Formosa - General Manuel Belgrano (+3716)", value: "3716" },
  { label: "Formosa - Ibarreta (+3716)", value: "3716" },
  { label: "Formosa - Juan G. Bazán (+3716)", value: "3716" },
  { label: "Formosa - Posta Cambio Zalazar (+3716)", value: "3716" },
  { label: "Formosa - San Martín 1 (+3716)", value: "3716" },
  { label: "Formosa - San Martín 2 (+3716)", value: "3716" },
  { label: "Formosa - Villa General Güemes (+3716)", value: "3716" },
  { label: "Formosa - Buena Vista (+3718)", value: "3718" },
  { label: "Formosa - Clorinda (+3718)", value: "3718" },
  { label: "Formosa - El Espinillo (+3718)", value: "3718" },
  { label: "Formosa - Laguna Blanca (+3718)", value: "3718" },
  { label: "Formosa - Laguna Naick Neck (+3718)", value: "3718" },
  { label: "Formosa - Misión Tacaaglé (+3718)", value: "3718" },
  { label: "Formosa - Palma Sola (+3718)", value: "3718" },
  { label: "Formosa - Portón Negro (+3718)", value: "3718" },
  { label: "Formosa - Puerto Pilcomayo (+3718)", value: "3718" },
  { label: "Formosa - Riacho He-Hé (+3718)", value: "3718" },
  { label: "Formosa - Riacho Negro (+3718)", value: "3718" },
  { label: "Formosa - Siete Palmas (+3718)", value: "3718" },
  { label: "Formosa - Tres Lagunas (+3718)", value: "3718" },
  { label: "Jujuy - Aguas Calientes (+388)", value: "388" },
  { label: "Jujuy - Alto Comedero (+388)", value: "388" },
  { label: "Jujuy - Barrio La Unión (+388)", value: "388" },
  { label: "Jujuy - Carahunco (+388)", value: "388" },
  { label: "Jujuy - Centro Forestal (+388)", value: "388" },
  { label: "Jujuy - Colonia San José (+388)", value: "388" },
  { label: "Jujuy - El Carmen (+388)", value: "388" },
  { label: "Jujuy - El Ceibal (+388)", value: "388" },
  { label: "Jujuy - El Cóndor (+388)", value: "388" },
  { label: "Jujuy - Guerrero (+388)", value: "388" },
  { label: "Jujuy - Huacalera (+388)", value: "388" },
  { label: "Jujuy - Juella (+388)", value: "388" },
  { label: "Jujuy - La Almona (+388)", value: "388" },
  { label: "Jujuy - La Ovejería (+388)", value: "388" },
  { label: "Jujuy - León (+388)", value: "388" },
  { label: "Jujuy - Los Alisos (+388)", value: "388" },
  { label: "Jujuy - Los Lapachos (+388)", value: "388" },
  { label: "Jujuy - Los Nogales (+388)", value: "388" },
  { label: "Jujuy - Maimará (+388)", value: "388" },
  { label: "Jujuy - Manantiales (+388)", value: "388" },
  { label: "Jujuy - Mina 9 de Octubre (+388)", value: "388" },
  { label: "Jujuy - Monterrico (+388)", value: "388" },
  { label: "Jujuy - Ocloyas (+388)", value: "388" },
  { label: "Jujuy - Palpalá (+388)", value: "388" },
  { label: "Jujuy - Pampa Blanca (+388)", value: "388" },
  { label: "Jujuy - Perico (+388)", value: "388" },
  { label: "Jujuy - Posta de Hornillos (+388)", value: "388" },
  { label: "Jujuy - Puesto Viejo (+388)", value: "388" },
  { label: "Jujuy - Purmamarca (+388)", value: "388" },
  { label: "Jujuy - Río Blanco (+388)", value: "388" },
  { label: "Jujuy - San Antonio (+388)", value: "388" },
  { label: "Jujuy - San Isidro (+388)", value: "388" },
  { label: "Jujuy - San Juancito (+388)", value: "388" },
  { label: "Jujuy - San Pablo de Reyes (+388)", value: "388" },
  { label: "Jujuy - San Salvador de Jujuy (+388)", value: "388" },
  { label: "Jujuy - Tilcara (+388)", value: "388" },
  { label: "Jujuy - Tumbaya (+388)", value: "388" },
  { label: "Jujuy - Villa Palpalá (+388)", value: "388" },
  { label: "Jujuy - Volcán (+388)", value: "388" },
  { label: "Jujuy - Yala (+388)", value: "388" },
  { label: "Jujuy - Cusi Cusi (+3885)", value: "3885" },
  { label: "Jujuy - La Quiaca (+3885)", value: "3885" },
  { label: "Jujuy - Lagunillas del Farallón (+3885)", value: "3885" },
  { label: "Jujuy - Liviara (+3885)", value: "3885" },
  { label: "Jujuy - Yavi (+3885)", value: "3885" },
  { label: "Jujuy - Bananal (+3886)", value: "3886" },
  { label: "Jujuy - Bermejito (+3886)", value: "3886" },
  { label: "Jujuy - Caimancito (+3886)", value: "3886" },
  { label: "Jujuy - Calilegua (+3886)", value: "3886" },
  { label: "Jujuy - Chalicán (+3886)", value: "3886" },
  { label: "Jujuy - El Talar (+3886)", value: "3886" },
  { label: "Jujuy - Fraile Pintado (+3886)", value: "3886" },
  { label: "Jujuy - Libertador General San Martín (+3886)", value: "3886" },
  { label: "Jujuy - Palma Sola (+3886)", value: "3886" },
  { label: "Jujuy - Paulina (+3886)", value: "3886" },
  { label: "Jujuy - Valle Grande (+3886)", value: "3886" },
  { label: "Jujuy - Vinalito (+3886)", value: "3886" },
  { label: "Jujuy - Yuto (+3886)", value: "3886" },
  { label: "Jujuy - Abdón Castro Tolay (+3887)", value: "3887" },
  { label: "Jujuy - Abra Pampa (+3887)", value: "3887" },
  { label: "Jujuy - Abralaite (+3887)", value: "3887" },
  { label: "Jujuy - Cangrejillos (+3887)", value: "3887" },
  { label: "Jujuy - Casabindo (+3887)", value: "3887" },
  { label: "Jujuy - Caspalá (+3887)", value: "3887" },
  { label: "Jujuy - Catua (+3887)", value: "3887" },
  { label: "Jujuy - Ciénega de Paicone (+3887)", value: "3887" },
  { label: "Jujuy - Cieneguillas (+3887)", value: "3887" },
  { label: "Jujuy - Cochinoca (+3887)", value: "3887" },
  { label: "Jujuy - Coctaca (+3887)", value: "3887" },
  { label: "Jujuy - Coranzulí (+3887)", value: "3887" },
  { label: "Jujuy - El Aguilar (+3887)", value: "3887" },
  { label: "Jujuy - El Toro (+3887)", value: "3887" },
  { label: "Jujuy - Huáncar (+3887)", value: "3887" },
  { label: "Jujuy - Humahuaca (+3887)", value: "3887" },
  { label: "Jujuy - Iturbe (+3887)", value: "3887" },
  { label: "Jujuy - Mina Providencia (+3887)", value: "3887" },
  { label: "Jujuy - Olaroz Chico (+3887)", value: "3887" },
  { label: "Jujuy - Pairique Chico (+3887)", value: "3887" },
  { label: "Jujuy - Pastos Chicos (+3887)", value: "3887" },
  { label: "Jujuy - Pastos Chicos (+3887)", value: "3887" },
  { label: "Jujuy - Puesto Sey (+3887)", value: "3887" },
  { label: "Jujuy - Pumahuasi (+3887)", value: "3887" },
  { label: "Jujuy - Rinconada (+3887)", value: "3887" },
  { label: "Jujuy - Rinconadillas (+3887)", value: "3887" },
  { label: "Jujuy - San Francisco de Alfarcito (+3887)", value: "3887" },
  { label: "Jujuy - San Juan de Quillaques (+3887)", value: "3887" },
  { label: "Jujuy - Santa Ana (+3887)", value: "3887" },
  { label: "Jujuy - Santa Catalina (+3887)", value: "3887" },
  { label: "Jujuy - Santuario de Tres Pozos (+3887)", value: "3887" },
  { label: "Jujuy - Susques (+3887)", value: "3887" },
  { label: "Jujuy - Tabladitas (+3887)", value: "3887" },
  { label: "Jujuy - Tres Cruces (+3887)", value: "3887" },
  { label: "Jujuy - Tusaquillas (+3887)", value: "3887" },
  { label: "Jujuy - Uquía (+3887)", value: "3887" },
  { label: "Jujuy - Valle Colorado (+3887)", value: "3887" },
  { label: "Jujuy - Arrayanal (+3888)", value: "3888" },
  { label: "Jujuy - Arroyo Colorado (+3888)", value: "3888" },
  { label: "Jujuy - Don Emilio (+3888)", value: "3888" },
  { label: "Jujuy - El Acheral (+3888)", value: "3888" },
  { label: "Jujuy - El Fuerte (+3888)", value: "3888" },
  { label: "Jujuy - El Piquete (+3888)", value: "3888" },
  { label: "Jujuy - El Puesto (+3888)", value: "3888" },
  { label: "Jujuy - El Quemado (+3888)", value: "3888" },
  { label: "Jujuy - El Sauzal (+3888)", value: "3888" },
  { label: "Jujuy - La Esperanza (+3888)", value: "3888" },
  { label: "Jujuy - La Manga (+3888)", value: "3888" },
  { label: "Jujuy - La Mendieta (+3888)", value: "3888" },
  { label: "Jujuy - Miraflores (+3888)", value: "3888" },
  { label: "Jujuy - Palos Blancos (+3888)", value: "3888" },
  { label: "Jujuy - Parapetí (+3888)", value: "3888" },
  { label: "Jujuy - Piedritas (+3888)", value: "3888" },
  { label: "Jujuy - Puente Lavayén (+3888)", value: "3888" },
  { label: "Jujuy - Rodeíto (+3888)", value: "3888" },
  { label: "Jujuy - Rosario de Río Grande (+3888)", value: "3888" },
  { label: "Jujuy - San Lucas (+3888)", value: "3888" },
  { label: "Jujuy - San Pedro de Jujuy (+3888)", value: "3888" },
  { label: "Jujuy - Santa Clara (+3888)", value: "3888" },
  { label: "La Pampa - Casa de Piedra (+299)", value: "299" },
  { label: "La Pampa - Puelén (+299)", value: "299" },
  { label: "La Pampa - Ceballos (+2302)", value: "2302" },
  { label: "La Pampa - Dorila (+2302)", value: "2302" },
  { label: "La Pampa - Intendente Alvear (+2302)", value: "2302" },
  { label: "La Pampa - Metileo (+2302)", value: "2302" },
  { label: "La Pampa - Trebolares (+2302)", value: "2302" },
  { label: "La Pampa - Trenel (+2302)", value: "2302" },
  { label: "La Pampa - Adolfo Van Praet (+2331)", value: "2331" },
  { label: "La Pampa - Falucho (+2331)", value: "2331" },
  { label: "La Pampa - Maisonave (+2331)", value: "2331" },
  { label: "La Pampa - Ojeda (+2331)", value: "2331" },
  { label: "La Pampa - Parera (+2331)", value: "2331" },
  { label: "La Pampa - Quetrequén (+2331)", value: "2331" },
  { label: "La Pampa - Rancul (+2331)", value: "2331" },
  { label: "La Pampa - Realicó (+2331)", value: "2331" },
  { label: "La Pampa - Colonia Barón (+2333)", value: "2333" },
  { label: "La Pampa - Colonia San José (+2333)", value: "2333" },
  { label: "La Pampa - Mauricio Mayer (+2333)", value: "2333" },
  { label: "La Pampa - Miguel Cané (+2333)", value: "2333" },
  { label: "La Pampa - Quemú Quemú (+2333)", value: "2333" },
  { label: "La Pampa - Relmo (+2333)", value: "2333" },
  { label: "La Pampa - Villa Mirasol (+2333)", value: "2333" },
  { label: "La Pampa - Winifreda (+2333)", value: "2333" },
  { label: "La Pampa - Conhelo (+2334)", value: "2334" },
  { label: "La Pampa - Eduardo Castex (+2334)", value: "2334" },
  { label: "La Pampa - Monte Nievas (+2334)", value: "2334" },
  { label: "La Pampa - Rucanelo (+2334)", value: "2334" },
  { label: "La Pampa - Arata (+2335)", value: "2335" },
  { label: "La Pampa - Caleufú (+2335)", value: "2335" },
  { label: "La Pampa - Embajador Martini (+2335)", value: "2335" },
  { label: "La Pampa - Ingeniero Luiggi (+2335)", value: "2335" },
  { label: "La Pampa - La Maruja (+2335)", value: "2335" },
  { label: "La Pampa - Pichi Huinca (+2335)", value: "2335" },
  { label: "La Pampa - Algarrobo del Águila (+2338)", value: "2338" },
  { label: "La Pampa - Carro Quemado (+2338)", value: "2338" },
  { label: "La Pampa - La Humada (+2338)", value: "2338" },
  { label: "La Pampa - Loventué (+2338)", value: "2338" },
  { label: "La Pampa - Luan Toro (+2338)", value: "2338" },
  { label: "La Pampa - Rucanelo (+2338)", value: "2338" },
  { label: "La Pampa - Santa Isabel (+2338)", value: "2338" },
  { label: "La Pampa - Telén (+2338)", value: "2338" },
  { label: "La Pampa - Victorica (+2338)", value: "2338" },
  { label: "La Pampa - Guatraché (+2924)", value: "2924" },
  { label: "La Pampa - Santa Teresa (+2924)", value: "2924" },
  { label: "La Pampa - Abramo (+2925)", value: "2925" },
  { label: "La Pampa - Bernasconi (+2925)", value: "2925" },
  { label: "La Pampa - Hucal (+2925)", value: "2925" },
  { label: "La Pampa - Jacinto Aráuz (+2925)", value: "2925" },
  { label: "La Pampa - Perú (+2925)", value: "2925" },
  { label: "La Pampa - Anzoategui (+2931)", value: "2931" },
  { label: "La Pampa - La Adela (+2931)", value: "2931" },
  { label: "La Pampa - Chacharramendi (+2952)", value: "2952" },
  { label: "La Pampa - Colonia Santa María (+2952)", value: "2952" },
  { label: "La Pampa - Cuchillo-Có (+2952)", value: "2952" },
  { label: "La Pampa - General Acha (+2952)", value: "2952" },
  { label: "La Pampa - Gobernador Duval (+2952)", value: "2952" },
  { label: "La Pampa - La Reforma (+2952)", value: "2952" },
  { label: "La Pampa - Limay Mahuida (+2952)", value: "2952" },
  { label: "La Pampa - Puelches (+2952)", value: "2952" },
  { label: "La Pampa - Quehué (+2952)", value: "2952" },
  { label: "La Pampa - Unanué (+2952)", value: "2952" },
  { label: "La Pampa - Alpachiri (+2953)", value: "2953" },
  { label: "La Pampa - Doblas (+2953)", value: "2953" },
  { label: "La Pampa - General Manuel Campos (+2953)", value: "2953" },
  { label: "La Pampa - Macachín (+2953)", value: "2953" },
  { label: "La Pampa - Miguel Riglos (+2953)", value: "2953" },
  { label: "La Pampa - Rolón (+2953)", value: "2953" },
  { label: "La Pampa - Tomás de Anchorena (+2953)", value: "2953" },
  { label: "La Pampa - Anguil (+2954)", value: "2954" },
  { label: "La Pampa - Ataliva Roca (+2954)", value: "2954" },
  { label: "La Pampa - Cachirulo (+2954)", value: "2954" },
  { label: "La Pampa - Catriló (+2954)", value: "2954" },
  { label: "La Pampa - Lonquimay (+2954)", value: "2954" },
  { label: "La Pampa - Naicó (+2954)", value: "2954" },
  { label: "La Pampa - Santa Rosa (+2954)", value: "2954" },
  { label: "La Pampa - Toay (+2954)", value: "2954" },
  { label: "La Pampa - Uriburu (+2954)", value: "2954" },
  { label: "La Pampa - Agustoni (+2302)", value: "2302" },
  { label: "La Pampa - Alta Italia (+2302)", value: "2302" },
  { label: "La Pampa - Bernardo Larroudé (+2302)", value: "2302" },
  { label: "La Pampa - Coronel Hilario Lagos (+2302)", value: "2302" },
  { label: "La Pampa - General Pico (+2302)", value: "2302" },
  { label: "La Pampa - Speluzzi (+2302)", value: "2302" },
  { label: "La Pampa - Vértiz (+2302)", value: "2302" },
  { label: "La Rioja - Amaná (+380)", value: "380" },
  { label: "La Rioja - La Rioja (+380)", value: "380" },
  { label: "La Rioja - Patquía (+380)", value: "380" },
  { label: "La Rioja - Punta de los Llanos (+380)", value: "380" },
  { label: "La Rioja - Tama (+380)", value: "380" },
  { label: "La Rioja - Villa Sanagasta (+380)", value: "380" },
  { label: "La Rioja - Chepes (+3821)", value: "3821" },
  { label: "La Rioja - Desiderio Tello (+3821)", value: "3821" },
  { label: "La Rioja - Ulapes (+3821)", value: "3821" },
  { label: "La Rioja - Aicuña (+3825)", value: "3825" },
  { label: "La Rioja - Alto Carrizal (+3825)", value: "3825" },
  { label: "La Rioja - Anguinán (+3825)", value: "3825" },
  { label: "La Rioja - Angulos (+3825)", value: "3825" },
  { label: "La Rioja - Antinaco (+3825)", value: "3825" },
  { label: "La Rioja - Bajo Carrizal (+3825)", value: "3825" },
  { label: "La Rioja - Banda Florida (+3825)", value: "3825" },
  { label: "La Rioja - Campanas (+3825)", value: "3825" },
  { label: "La Rioja - Chañarmuyo (+3825)", value: "3825" },
  { label: "La Rioja - Chilecito (+3825)", value: "3825" },
  { label: "La Rioja - Colonia Anguinán (+3825)", value: "3825" },
  { label: "La Rioja - Colonia Catinzaco (+3825)", value: "3825" },
  { label: "La Rioja - Colonia Malligasta (+3825)", value: "3825" },
  { label: "La Rioja - Colonia Vichigasta (+3825)", value: "3825" },
  { label: "La Rioja - Famatina (+3825)", value: "3825" },
  { label: "La Rioja - Guanchín (+3825)", value: "3825" },
  { label: "La Rioja - Guandacol (+3825)", value: "3825" },
  { label: "La Rioja - Jagüé (+3825)", value: "3825" },
  { label: "La Rioja - La Cuadra (+3825)", value: "3825" },
  { label: "La Rioja - La Puntilla (+3825)", value: "3825" },
  { label: "La Rioja - Los Palacios (+3825)", value: "3825" },
  { label: "La Rioja - Los Sarmientos (+3825)", value: "3825" },
  { label: "La Rioja - Malligasta (+3825)", value: "3825" },
  { label: "La Rioja - Miranda (+3825)", value: "3825" },
  { label: "La Rioja - Nonogasta (+3825)", value: "3825" },
  { label: "La Rioja - Pagancillo (+3825)", value: "3825" },
  { label: "La Rioja - Pituil (+3825)", value: "3825" },
  { label: "La Rioja - Plaza Vieja (+3825)", value: "3825" },
  { label: "La Rioja - Punta de Agua (+3825)", value: "3825" },
  { label: "La Rioja - San Miguel (+3825)", value: "3825" },
  { label: "La Rioja - San Nicolás (+3825)", value: "3825" },
  { label: "La Rioja - Santa Clara (+3825)", value: "3825" },
  { label: "La Rioja - Santa Cruz (+3825)", value: "3825" },
  { label: "La Rioja - Santa Florentina (+3825)", value: "3825" },
  { label: "La Rioja - Santo Domingo (+3825)", value: "3825" },
  { label: "La Rioja - Sañogasta (+3825)", value: "3825" },
  { label: "La Rioja - Tilimuqui (+3825)", value: "3825" },
  { label: "La Rioja - Vichigasta (+3825)", value: "3825" },
  { label: "La Rioja - Villa Castelli (+3825)", value: "3825" },
  { label: "La Rioja - Villa San José de Vinchina (+3825)", value: "3825" },
  { label: "La Rioja - Villa Unión (+3825)", value: "3825" },
  { label: "La Rioja - Ambil (+3826)", value: "3826" },
  { label: "La Rioja - Castro Barros (+3826)", value: "3826" },
  { label: "La Rioja - Chamical (+3826)", value: "3826" },
  { label: "La Rioja - Chañar (+3826)", value: "3826" },
  { label: "La Rioja - Colonia Ortiz de Ocampo (+3826)", value: "3826" },
  { label: "La Rioja - Loma Blanca (+3826)", value: "3826" },
  { label: "La Rioja - Malanzán (+3826)", value: "3826" },
  { label: "La Rioja - Milagro (+3826)", value: "3826" },
  { label: "La Rioja - Nácate (+3826)", value: "3826" },
  { label: "La Rioja - Olpas (+3826)", value: "3826" },
  { label: "La Rioja - Olta (+3826)", value: "3826" },
  { label: "La Rioja - Polco (+3826)", value: "3826" },
  { label: "La Rioja - Portezuelo (+3826)", value: "3826" },
  { label: "La Rioja - San Antonio (+3826)", value: "3826" },
  { label: "La Rioja - Villa Santa Rita de Catuna (+3826)", value: "3826" },
  { label: "La Rioja - Agua Blanca (+3827)", value: "3827" },
  { label: "La Rioja - Aimogasta (+3827)", value: "3827" },
  { label: "La Rioja - Alpasinche (+3827)", value: "3827" },
  { label: "La Rioja - Aminga (+3827)", value: "3827" },
  { label: "La Rioja - Amuschinas (+3827)", value: "3827" },
  { label: "La Rioja - Andolucas (+3827)", value: "3827" },
  { label: "La Rioja - Anillaco (+3827)", value: "3827" },
  { label: "La Rioja - Anjullón (+3827)", value: "3827" },
  { label: "La Rioja - Arauco (+3827)", value: "3827" },
  { label: "La Rioja - Bañado de los Pantanos (+3827)", value: "3827" },
  { label: "La Rioja - Chaupihuasi (+3827)", value: "3827" },
  { label: "La Rioja - Chuquis (+3827)", value: "3827" },
  { label: "La Rioja - Cuipán (+3827)", value: "3827" },
  { label: "La Rioja - Estación Mazán (+3827)", value: "3827" },
  { label: "La Rioja - Las Talas (+3827)", value: "3827" },
  { label: "La Rioja - Los Molinos (+3827)", value: "3827" },
  { label: "La Rioja - Los Robles (+3827)", value: "3827" },
  { label: "La Rioja - Machigasta (+3827)", value: "3827" },
  { label: "La Rioja - Pinchas (+3827)", value: "3827" },
  { label: "La Rioja - Salicas (+3827)", value: "3827" },
  { label: "La Rioja - San Antonio (+3827)", value: "3827" },
  { label: "La Rioja - San Blas (+3827)", value: "3827" },
  { label: "La Rioja - San Pedro (+3827)", value: "3827" },
  { label: "La Rioja - Santa Vera Cruz (+3827)", value: "3827" },
  { label: "La Rioja - Shaqui (+3827)", value: "3827" },
  { label: "La Rioja - Suriyaco (+3827)", value: "3827" },
  { label: "La Rioja - Termas de Santa Teresita (+3827)", value: "3827" },
  { label: "La Rioja - Tuyubil (+3827)", value: "3827" },
  { label: "La Rioja - Villa Mazán (+3827)", value: "3827" },
  { label: "Mendoza - Agua Escondida (+260)", value: "260" },
  { label: "Mendoza - Bardas Blancas (+260)", value: "260" },
  { label: "Mendoza - Bardas Blancas (+260)", value: "260" },
  { label: "Mendoza - Barrio Empleados de Comercio (+260)", value: "260" },
  { label: "Mendoza - Barrio Intendencia (+260)", value: "260" },
  { label: "Mendoza - Barrio Primavera (+260)", value: "260" },
  { label: "Mendoza - Capitán Montoya (+260)", value: "260" },
  { label: "Mendoza - Costa El Toledano (+260)", value: "260" },
  { label: "Mendoza - Cuadro Benegas (+260)", value: "260" },
  { label: "Mendoza - Cuadro Nacional (+260)", value: "260" },
  { label: "Mendoza - El Nihuil (+260)", value: "260" },
  { label: "Mendoza - El Sosneado (+260)", value: "260" },
  { label: "Mendoza - El Tropezón (+260)", value: "260" },
  { label: "Mendoza - Goudge (+260)", value: "260" },
  { label: "Mendoza - La Llave (+260)", value: "260" },
  { label: "Mendoza - Las Leñas (+260)", value: "260" },
  { label: "Mendoza - Las Malvinas (+260)", value: "260" },
  { label: "Mendoza - Las Paredes (+260)", value: "260" },
  { label: "Mendoza - Los Reyunos (+260)", value: "260" },
  { label: "Mendoza - Malargüe (+260)", value: "260" },
  { label: "Mendoza - Monte Comán (+260)", value: "260" },
  { label: "Mendoza - Rama Caída (+260)", value: "260" },
  { label: "Mendoza - Salto de las Rosas (+260)", value: "260" },
  { label: "Mendoza - San Rafael (+260)", value: "260" },
  { label: "Mendoza - Villa Veinticinco de Mayo (+260)", value: "260" },
  { label: "Mendoza - Agrelo (+261)", value: "261" },
  { label: "Mendoza - Alto del Olvido (+261)", value: "261" },
  { label: "Mendoza - Barrancas (+261)", value: "261" },
  { label: "Mendoza - Barrio Jesús de Nazaret (+261)", value: "261" },
  { label: "Mendoza - Barrio Jocolí II (+261)", value: "261" },
  { label: "Mendoza - Barrio La Esperanza (+261)", value: "261" },
  { label: "Mendoza - Barrio Los Jarilleros (+261)", value: "261" },
  { label: "Mendoza - Barrio Tres Olivos (+261)", value: "261" },
  { label: "Mendoza - Blanco Encalada (+261)", value: "261" },
  { label: "Mendoza - Cacheuta (+261)", value: "261" },
  { label: "Mendoza - Capdevilla (+261)", value: "261" },
  { label: "Mendoza - Carrodilla (+261)", value: "261" },
  { label: "Mendoza - Chacras de Coria (+261)", value: "261" },
  { label: "Mendoza - Colonia Segovia (+261)", value: "261" },
  { label: "Mendoza - Coquimbito (+261)", value: "261" },
  { label: "Mendoza - Costa de Araujo (+261)", value: "261" },
  { label: "Mendoza - Cruz de Piedra (+261)", value: "261" },
  { label: "Mendoza - El Carrizal (+261)", value: "261" },
  { label: "Mendoza - El Paramillo (+261)", value: "261" },
  { label: "Mendoza - El Vergel (+261)", value: "261" },
  { label: "Mendoza - Fray Luis Beltrán (+261)", value: "261" },
  { label: "Mendoza - Godoy Cruz (+261)", value: "261" },
  { label: "Mendoza - Ingeniero Gustavo André (+261)", value: "261" },
  { label: "Mendoza - Jocolí (+261)", value: "261" },
  { label: "Mendoza - Jocolí Viejo (+261)", value: "261" },
  { label: "Mendoza - La Palmera (+261)", value: "261" },
  { label: "Mendoza - La Pega (+261)", value: "261" },
  { label: "Mendoza - La Primavera (+261)", value: "261" },
  { label: "Mendoza - Lagunas de Bartoluzzi (+261)", value: "261" },
  { label: "Mendoza - Las Compuertas (+261)", value: "261" },
  { label: "Mendoza - Las Heras (+261)", value: "261" },
  { label: "Mendoza - Las Violetas (+261)", value: "261" },
  { label: "Mendoza - Los Corralitos (+261)", value: "261" },
  { label: "Mendoza - Luján de Cuyo (+261)", value: "261" },
  { label: "Mendoza - Lunlunta (+261)", value: "261" },
  { label: "Mendoza - Luzuriaga (+261)", value: "261" },
  { label: "Mendoza - Maipú (+261)", value: "261" },
  { label: "Mendoza - Mendoza (+261)", value: "261" },
  { label: "Mendoza - Perdriel (+261)", value: "261" },
  { label: "Mendoza - Puente de Hierro (+261)", value: "261" },
  { label: "Mendoza - Rodeo de la Cruz (+261)", value: "261" },
  { label: "Mendoza - Rodeo del Medio (+261)", value: "261" },
  { label: "Mendoza - Russell (+261)", value: "261" },
  { label: "Mendoza - San Roque (+261)", value: "261" },
  { label: "Mendoza - Tres de Mayo (+261)", value: "261" },
  { label: "Mendoza - Tres Esquinas (+261)", value: "261" },
  { label: "Mendoza - Ugarteche (+261)", value: "261" },
  { label: "Mendoza - Villa Nueva (+261)", value: "261" },
  { label: "Mendoza - Villa Teresa (+261)", value: "261" },
  { label: "Mendoza - Villa Tulumaya (+261)", value: "261" },
  { label: "Mendoza - Alto Salvador (+263)", value: "263" },
  { label: "Mendoza - Alto Verde (+263)", value: "263" },
  { label: "Mendoza - Andrade (+263)", value: "263" },
  { label: "Mendoza - Barrio Chivilcoy (+263)", value: "263" },
  { label: "Mendoza - Barrio Cooperativa Los Campamentos (+263)", value: "263" },
  { label: "Mendoza - Barrio María Auxiliadora (+263)", value: "263" },
  { label: "Mendoza - Barrio Rivadavia (+263)", value: "263" },
  { label: "Mendoza - Chapanay (+263)", value: "263" },
  { label: "Mendoza - Cuadro Ortega (+263)", value: "263" },
  { label: "Mendoza - Doce de Octubre (+263)", value: "263" },
  { label: "Mendoza - El Central (+263)", value: "263" },
  { label: "Mendoza - El Marcado (+263)", value: "263" },
  { label: "Mendoza - El Mirador (+263)", value: "263" },
  { label: "Mendoza - Ingeniero Giagnoni (+263)", value: "263" },
  { label: "Mendoza - Junín (+263)", value: "263" },
  { label: "Mendoza - La Central (+263)", value: "263" },
  { label: "Mendoza - La Colonia (+263)", value: "263" },
  { label: "Mendoza - La Dormida (+263)", value: "263" },
  { label: "Mendoza - La Esperanza (+263)", value: "263" },
  { label: "Mendoza - La Florida (+263)", value: "263" },
  { label: "Mendoza - La Libertad (+263)", value: "263" },
  { label: "Mendoza - La Reducción (+263)", value: "263" },
  { label: "Mendoza - Las Catitas (+263)", value: "263" },
  { label: "Mendoza - Los Árboles (+263)", value: "263" },
  { label: "Mendoza - Los Campamentos (+263)", value: "263" },
  { label: "Mendoza - Los Charabones (+263)", value: "263" },
  { label: "Mendoza - Medrano (+263)", value: "263" },
  { label: "Mendoza - Montecaseros (+263)", value: "263" },
  { label: "Mendoza - Mundo Nuevo (+263)", value: "263" },
  { label: "Mendoza - Nueva California (+263)", value: "263" },
  { label: "Mendoza - Palmira (+263)", value: "263" },
  { label: "Mendoza - Phillips (+263)", value: "263" },
  { label: "Mendoza - Rivadavia (+263)", value: "263" },
  { label: "Mendoza - Rodríguez Peña (+263)", value: "263" },
  { label: "Mendoza - San Martín, (+263)", value: "263" },
  { label: "Mendoza - Santa María de Oro (+263)", value: "263" },
  { label: "Mendoza - Santa Rosa (+263)", value: "263" },
  { label: "Mendoza - Tres Porteñas (+263)", value: "263" },
  { label: "Mendoza - Villa Los Barriales (+263)", value: "263" },
  { label: "Mendoza - Barrio San Cayetano (+2622)", value: "2622" },
  { label: "Mendoza - Campo de los Andes (+2622)", value: "2622" },
  { label: "Mendoza - Chilecito (+2622)", value: "2622" },
  { label: "Mendoza - Colonia Las Rosas (+2622)", value: "2622" },
  { label: "Mendoza - Cordón del Plata (+2622)", value: "2622" },
  { label: "Mendoza - El Cepillo (+2622)", value: "2622" },
  { label: "Mendoza - El Peral (+2622)", value: "2622" },
  { label: "Mendoza - Eugenio Bustos (+2622)", value: "2622" },
  { label: "Mendoza - La Arboleda (+2622)", value: "2622" },
  { label: "Mendoza - La Consulta (+2622)", value: "2622" },
  { label: "Mendoza - Los Sauces (+2622)", value: "2622" },
  { label: "Mendoza - Pareditas (+2622)", value: "2622" },
  { label: "Mendoza - San José (+2622)", value: "2622" },
  { label: "Mendoza - Tunuyán (+2622)", value: "2622" },
  { label: "Mendoza - Tupungato (+2622)", value: "2622" },
  { label: "Mendoza - Villa Bastías (+2622)", value: "2622" },
  { label: "Mendoza - Villa San Carlos (+2622)", value: "2622" },
  { label: "Mendoza - Vista Flores (+2622)", value: "2622" },
  { label: "Mendoza - El Carmelo (+2624)", value: "2624" },
  { label: "Mendoza - El Salto (+2624)", value: "2624" },
  { label: "Mendoza - Las Carditas (+2624)", value: "2624" },
  { label: "Mendoza - Las Cuevas (+2624)", value: "2624" },
  { label: "Mendoza - Las Vegas (+2624)", value: "2624" },
  { label: "Mendoza - Los Penitentes (+2624)", value: "2624" },
  { label: "Mendoza - Manantiales (+2624)", value: "2624" },
  { label: "Mendoza - Piedras Blancas (+2624)", value: "2624" },
  { label: "Mendoza - Polvaredas (+2624)", value: "2624" },
  { label: "Mendoza - Potrerillos (+2624)", value: "2624" },
  { label: "Mendoza - Puente del Inca (+2624)", value: "2624" },
  { label: "Mendoza - Punta de Vacas (+2624)", value: "2624" },
  { label: "Mendoza - Uspallata (+2624)", value: "2624" },
  { label: "Mendoza - Valle del Sol (+2624)", value: "2624" },
  { label: "Mendoza - Villa El Refugio (+2624)", value: "2624" },
  { label: "Mendoza - Barrio El Nevado (+2625)", value: "2625" },
  { label: "Mendoza - Bowen (+2625)", value: "2625" },
  { label: "Mendoza - Carmensa (+2625)", value: "2625" },
  { label: "Mendoza - General Alvear (+2625)", value: "2625" },
  { label: "Mendoza - Jaime Prats (+2625)", value: "2625" },
  { label: "Mendoza - Los Compartos (+2625)", value: "2625" },
  { label: "Mendoza - Punta del Agua (+2625)", value: "2625" },
  { label: "Mendoza - Real del Padre (+2625)", value: "2625" },
  { label: "Mendoza - Villa Atuel (+2625)", value: "2625" },
  { label: "Mendoza - Villa Atuel Norte (+2625)", value: "2625" },
  { label: "Mendoza - Desaguadero (parte) (+2626)", value: "2626" },
  { label: "Mendoza - La Paz (+2626)", value: "2626" },
  { label: "Mendoza - Villa Antigua (+2626)", value: "2626" },
  { label: "Misiones - Barrio del Lago (+376)", value: "376" },
  { label: "Misiones - Barrio Eva Perón (Helvecia) (+376)", value: "376" },
  { label: "Misiones - Bonpland (+376)", value: "376" },
  { label: "Misiones - Candelaria (+376)", value: "376" },
  { label: "Misiones - Cerro Azul (+376)", value: "376" },
  { label: "Misiones - Cerro Corá (+376)", value: "376" },
  { label: "Misiones - Corpus (+376)", value: "376" },
  { label: "Misiones - Domingo Savio (+376)", value: "376" },
  { label: "Misiones - Fachinal (+376)", value: "376" },
  { label: "Misiones - Garupá (+376)", value: "376" },
  { label: "Misiones - General Urquiza (+376)", value: "376" },
  { label: "Misiones - Gobernador Roca (+376)", value: "376" },
  { label: "Misiones - Hipólito Yrigoyen (+376)", value: "376" },
  { label: "Misiones - Loreto (+376)", value: "376" },
  { label: "Misiones - Mártires (+376)", value: "376" },
  { label: "Misiones - Nemesio Parma (+376)", value: "376" },
  { label: "Misiones - Posadas (+376)", value: "376" },
  { label: "Misiones - Profundidad (+376)", value: "376" },
  { label: "Misiones - Roca Chica (+376)", value: "376" },
  { label: "Misiones - San Ignacio (+376)", value: "376" },
  { label: "Misiones - Santa Ana (+376)", value: "376" },
  { label: "Misiones - Santo Pipó (+376)", value: "376" },
  { label: "Misiones - Bernardo de Irigoyen (+3741)", value: "3741" },
  { label: "Misiones - Dos Hermanas (+3741)", value: "3741" },
  { label: "Misiones - San Antonio (+3741)", value: "3741" },
  { label: "Misiones - Capioví (+3743)", value: "3743" },
  { label: "Misiones - Colonia Polana (+3743)", value: "3743" },
  { label: "Misiones - Garuhapé (+3743)", value: "3743" },
  { label: "Misiones - Garuhapé-Mi (+3743)", value: "3743" },
  { label: "Misiones - Jardín América (+3743)", value: "3743" },
  { label: "Misiones - Mbopicuá (+3743)", value: "3743" },
  { label: "Misiones - Oasis (+3743)", value: "3743" },
  { label: "Misiones - Puerto Leoni (+3743)", value: "3743" },
  { label: "Misiones - Puerto Mineral (+3743)", value: "3743" },
  { label: "Misiones - Puerto Rico (+3743)", value: "3743" },
  { label: "Misiones - Ruiz de Montoya (+3743)", value: "3743" },
  { label: "Misiones - San Alberto (+3743)", value: "3743" },
  { label: "Misiones - San Gotardo (+3743)", value: "3743" },
  { label: "Misiones - San Ignacio (+3743)", value: "3743" },
  { label: "Misiones - Villa Akerman (+3743)", value: "3743" },
  { label: "Misiones - Caraguatay (+3751)", value: "3751" },
  { label: "Misiones - Colonia Delicia (+3751)", value: "3751" },
  { label: "Misiones - Colonia Victoria (+3751)", value: "3751" },
  { label: "Misiones - Cruce Caballero (+3751)", value: "3751" },
  { label: "Misiones - El Alcázar (+3751)", value: "3751" },
  { label: "Misiones - El Alcázar (+3751)", value: "3751" },
  { label: "Misiones - Eldorado (+3751)", value: "3751" },
  { label: "Misiones - Fracrán (+3751)", value: "3751" },
  { label: "Misiones - Laharrague (+3751)", value: "3751" },
  { label: "Misiones - Montecarlo (+3751)", value: "3751" },
  { label: "Misiones - Nueve de Julio (+3751)", value: "3751" },
  { label: "Misiones - Nueve de Julio Kilómetro 20 (+3751)", value: "3751" },
  { label: "Misiones - Piñalito Sur (+3751)", value: "3751" },
  { label: "Misiones - Piray Kilómetro 18 (+3751)", value: "3751" },
  { label: "Misiones - Puerto Mado (+3751)", value: "3751" },
  { label: "Misiones - Puerto Pinares (+3751)", value: "3751" },
  { label: "Misiones - Puerto Piray (+3751)", value: "3751" },
  { label: "Misiones - San Pedro (+3751)", value: "3751" },
  { label: "Misiones - Santiago de Liniers (+3751)", value: "3751" },
  { label: "Misiones - Tarumá (+3751)", value: "3751" },
  { label: "Misiones - Tobuna (+3751)", value: "3751" },
  { label: "Misiones - Valle Hermoso (+3751)", value: "3751" },
  { label: "Misiones - Villa Parodi (+3751)", value: "3751" },
  { label: "Misiones - Villa Roulet (+3751)", value: "3751" },
  { label: "Misiones - Arroyo del Medio (+3754)", value: "3754" },
  { label: "Misiones - Dos Arroyos (+3754)", value: "3754" },
  { label: "Misiones - Gobernador López (+3754)", value: "3754" },
  { label: "Misiones - Itacaruaré (+3754)", value: "3754" },
  { label: "Misiones - Leandro N. Alem (+3754)", value: "3754" },
  { label: "Misiones - Mojón Grande (+3754)", value: "3754" },
  { label: "Misiones - Olegario Víctor Andrade (+3754)", value: "3754" },
  { label: "Misiones - Panambí (+3754)", value: "3754" },
  { label: "Misiones - Panambí Kilómetro 8 (+3754)", value: "3754" },
  { label: "Misiones - San Javier (+3754)", value: "3754" },
  { label: "Misiones - Alba Posse (+3755)", value: "3755" },
  { label: "Misiones - Almafuerte (+3755)", value: "3755" },
  { label: "Misiones - Aristóbulo del Valle (+3755)", value: "3755" },
  { label: "Misiones - Barrio Bernardino Rivadavia (+3755)", value: "3755" },
  { label: "Misiones - Caá Yarí (+3755)", value: "3755" },
  { label: "Misiones - Camión Cue (+3755)", value: "3755" },
  { label: "Misiones - Campo Grande (+3755)", value: "3755" },
  { label: "Misiones - Campo Ramón (+3755)", value: "3755" },
  { label: "Misiones - Campo Viera (+3755)", value: "3755" },
  { label: "Misiones - Colonia Alberdi (+3755)", value: "3755" },
  { label: "Misiones - Colonia Alicia (+3755)", value: "3755" },
  { label: "Misiones - Colonia Aurora (+3755)", value: "3755" },
  { label: "Misiones - Dos de Mayo (+3755)", value: "3755" },
  { label: "Misiones - El Salto Florentino Ameghino (+3755)", value: "3755" },
  { label: "Misiones - El Soberbio (+3755)", value: "3755" },
  { label: "Misiones - General Alvear (+3755)", value: "3755" },
  { label: "Misiones - Guaraní (+3755)", value: "3755" },
  { label: "Misiones - Kilómetro 17 (+3755)", value: "3755" },
  { label: "Misiones - Los Helechos (+3755)", value: "3755" },
  { label: "Misiones - Oberá (+3755)", value: "3755" },
  { label: "Misiones - Pueblo Illia (+3755)", value: "3755" },
  { label: "Misiones - San Francisco de Asís (+3755)", value: "3755" },
  { label: "Misiones - San Martín (+3755)", value: "3755" },
  { label: "Misiones - San Vicente (+3755)", value: "3755" },
  { label: "Misiones - Santa Rita (+3755)", value: "3755" },
  { label: "Misiones - Torta Quemada (+3755)", value: "3755" },
  { label: "Misiones - Veinticinco de Mayo (+3755)", value: "3755" },
  { label: "Misiones - Villa Bonita (+3755)", value: "3755" },
  { label: "Misiones - Villa Salto Encantado (+3755)", value: "3755" },
  { label: "Misiones - Colonia Helvecia (+3757)", value: "3757" },
  { label: "Misiones - Comandante Andresito (+3757)", value: "3757" },
  { label: "Misiones - Gobernador Lanusse (+3757)", value: "3757" },
  { label: "Misiones - Integración (+3757)", value: "3757" },
  { label: "Misiones - Puerto Esperanza (+3757)", value: "3757" },
  { label: "Misiones - Puerto Iguazú, (+3757)", value: "3757" },
  { label: "Misiones - Puerto Libertad (+3757)", value: "3757" },
  { label: "Misiones - Wanda (+3757)", value: "3757" },
  { label: "Misiones - Apóstoles (+3758)", value: "3758" },
  { label: "Misiones - Azara (+3758)", value: "3758" },
  { label: "Misiones - Barra Concepción (+3758)", value: "3758" },
  { label: "Misiones - Barrio Rural (+3758)", value: "3758" },
  { label: "Misiones - Concepción de la Sierra (+3758)", value: "3758" },
  { label: "Misiones - La Corita (+3758)", value: "3758" },
  { label: "Misiones - Pindapoy (+3758)", value: "3758" },
  { label: "Misiones - Puerto Azara (+3758)", value: "3758" },
  { label: "Misiones - Santa María (+3758)", value: "3758" },
  { label: "Misiones - Tres Capones (+3758)", value: "3758" },
  { label: "Neuquén - Octavio Pico (+299)", value: "299" },
  { label: "Neuquén - San Patricio del Chañar (+299)", value: "299" },
  { label: "Neuquén - Aluminé (+2942)", value: "2942" },
  { label: "Neuquén - Arroyito (+2942)", value: "2942" },
  { label: "Neuquén - Bajada del Agrio (+2942)", value: "2942" },
  { label: "Neuquén - Covunco Abajo (+2942)", value: "2942" },
  { label: "Neuquén - La Buitrera (+2942)", value: "2942" },
  { label: "Neuquén - Las Coloradas (+2942)", value: "2942" },
  { label: "Neuquén - Las Lajas (+2942)", value: "2942" },
  { label: "Neuquén - Los Catutos (+2942)", value: "2942" },
  { label: "Neuquén - Mari Menuco (+2942)", value: "2942" },
  { label: "Neuquén - Mariano Moreno (+2942)", value: "2942" },
  { label: "Neuquén - Paso Aguerre (+2942)", value: "2942" },
  { label: "Neuquén - Picún Leufú (+2942)", value: "2942" },
  { label: "Neuquén - Piedra del Águila (+2942)", value: "2942" },
  { label: "Neuquén - Ramón M. Castro (+2942)", value: "2942" },
  { label: "Neuquén - Santo Tomás (+2942)", value: "2942" },
  { label: "Neuquén - Villa Pehuenia (+2942)", value: "2942" },
  { label: "Neuquén - Zapala (+2942)", value: "2942" },
  { label: "Neuquén - Andacollo (+2948)", value: "2948" },
  { label: "Neuquén - Barrancas (+2948)", value: "2948" },
  { label: "Neuquén - Buta Ranquil (+2948)", value: "2948" },
  { label: "Neuquén - Caviahue (+2948)", value: "2948" },
  { label: "Neuquén - Chorriaca (+2948)", value: "2948" },
  { label: "Neuquén - Chos Malal (+2948)", value: "2948" },
  { label: "Neuquén - Coyuco-Cochico (+2948)", value: "2948" },
  { label: "Neuquén - El Cholar (+2948)", value: "2948" },
  { label: "Neuquén - El Huecú (+2948)", value: "2948" },
  { label: "Neuquén - Huinganco (+2948)", value: "2948" },
  { label: "Neuquén - Las Ovejas (+2948)", value: "2948" },
  { label: "Neuquén - Loncopué (+2948)", value: "2948" },
  { label: "Neuquén - Los Miches (+2948)", value: "2948" },
  { label: "Neuquén - Manzano Amargo (+2948)", value: "2948" },
  { label: "Neuquén - Sauzal Bonito (+2948)", value: "2948" },
  { label: "Neuquén - Taquimilán (+2948)", value: "2948" },
  { label: "Neuquén - Termas de Copahue (+2948)", value: "2948" },
  { label: "Neuquén - Tricao Malal (+2948)", value: "2948" },
  { label: "Neuquén - Varvarco (+2948)", value: "2948" },
  { label: "Neuquén - Villa Curí Leuvú (+2948)", value: "2948" },
  { label: "Neuquén - Villa del Nahueve (+2948)", value: "2948" },
  { label: "Neuquén - Junín de los Andes (+2972)", value: "2972" },
  { label: "Neuquén - San Martín de los Andes (+2972)", value: "2972" },
  { label: "Neuquén - Villa Meliquina (+2972)", value: "2972" },
  { label: "Neuquén - Paso Flores (+294)", value: "294" },
  { label: "Neuquén - Villa La Angostura (+294)", value: "294" },
  { label: "Neuquén - Villa Traful (+294)", value: "294" },
  { label: "Neuquén - Aguada San Roque (+299)", value: "299" },
  { label: "Neuquén - Añelo (+299)", value: "299" },
  { label: "Neuquén - Centenario (+299)", value: "299" },
  { label: "Neuquén - Cutral-Co (+299)", value: "299" },
  { label: "Neuquén - Neuquén (+299)", value: "299" },
  { label: "Neuquén - Plaza Huincul (+299)", value: "299" },
  { label: "Neuquén - Plottier (+299)", value: "299" },
  { label: "Neuquén - Rincón de los Sauces (+299)", value: "299" },
  { label: "Neuquén - Senillosa (+299)", value: "299" },
  { label: "Neuquén - Veinticinco de Mayo (+299)", value: "299" },
  { label: "Neuquén - Villa El Chocón (+299)", value: "299" },
  { label: "Rio Negro - Barrio Unión (+2946)", value: "2946" },
  { label: "Río Negro - Colonia Suiza (+294)", value: "294" },
  { label: "Río Negro - Dina Huapi (+294)", value: "294" },
  { label: "Río Negro - Villa Los Coihues (+294)", value: "294" },
  { label: "Río Negro - Ingeniero Luis A. Huergo (+298)", value: "298" },
  { label: "Río Negro - Bahía Creek (+2920)", value: "2920" },
  { label: "Río Negro - Balneario El Cóndor (+2920)", value: "2920" },
  { label: "Río Negro - El Juncal (+2920)", value: "2920" },
  { label: "Río Negro - Guardia Mitre, (+2920)", value: "2920" },
  { label: "Río Negro - La Lobería (+2920)", value: "2920" },
  { label: "Río Negro - Loteo Costa de Río (+2920)", value: "2920" },
  { label: "Río Negro - Pozo Salado (+2920)", value: "2920" },
  { label: "Río Negro - San Javier (+2920)", value: "2920" },
  { label: "Río Negro - Viedma (+2920)", value: "2920" },
  { label: "Río Negro - Colonia Juliá y Echarren (+2931)", value: "2931" },
  { label: "Río Negro - General Conesa (+2931)", value: "2931" },
  { label: "Río Negro - Río Colorado (+2931)", value: "2931" },
  { label: "Río Negro - Aguada Cecilio (+2934)", value: "2934" },
  { label: "Río Negro - Arroyo de La Ventana (+2934)", value: "2934" },
  { label: "Río Negro - Arroyo Los Berros (+2934)", value: "2934" },
  { label: "Río Negro - Cona Niyeu (+2934)", value: "2934" },
  { label: "Río Negro - Las Grutas (+2934)", value: "2934" },
  { label: "Río Negro - Ministro Ramos Mexía (+2934)", value: "2934" },
  { label: "Río Negro - Nahuel Niyeu (+2934)", value: "2934" },
  { label: "Río Negro - Playas Doradas (+2934)", value: "2934" },
  { label: "Río Negro - Punta Colorada (+2934)", value: "2934" },
  { label: "Río Negro - San Antonio Este (+2934)", value: "2934" },
  { label: "Río Negro - San Antonio Oeste (+2934)", value: "2934" },
  { label: "Río Negro - Sierra Colorada (+2934)", value: "2934" },
  { label: "Río Negro - Sierra Grande (+2934)", value: "2934" },
  { label: "Río Negro - Sierra Pailemán (+2934)", value: "2934" },
  { label: "Río Negro - Treneta (+2934)", value: "2934" },
  { label: "Río Negro - Valcheta (+2934)", value: "2934" },
  { label: "Río Negro - Yaminué (+2934)", value: "2934" },
  { label: "Río Negro - Aguada de Guerra (+2940)", value: "2940" },
  { label: "Río Negro - Clemente Onelli (+2940)", value: "2940" },
  { label: "Río Negro - Colan Conhue (+2940)", value: "2940" },
  { label: "Río Negro - Comallo (+2940)", value: "2940" },
  { label: "Río Negro - Comicó (+2940)", value: "2940" },
  { label: "Río Negro - El Caín (+2940)", value: "2940" },
  { label: "Río Negro - Ingeniero Jacobacci (+2940)", value: "2940" },
  { label: "Río Negro - Laguna Blanca (+2940)", value: "2940" },
  { label: "Río Negro - Las Bayas (+2940)", value: "2940" },
  { label: "Río Negro - Los Menucos (+2940)", value: "2940" },
  { label: "Río Negro - Maquinchao (+2940)", value: "2940" },
  { label: "Río Negro - Mina Santa Teresita (+2940)", value: "2940" },
  { label: "Río Negro - Ojos de Agua (+2940)", value: "2940" },
  { label: "Río Negro - Pilquiniyeu (+2940)", value: "2940" },
  { label: "Río Negro - Prahuaniyeu (+2940)", value: "2940" },
  { label: "Río Negro - Naupa Huen (+2942)", value: "2942" },
  { label: "Río Negro - Chelforó (+2946)", value: "2946" },
  { label: "Río Negro - Chimpay (+2946)", value: "2946" },
  { label: "Río Negro - Choele Choel (+2946)", value: "2946" },
  { label: "Río Negro - Coronel Belisle (+2946)", value: "2946" },
  { label: "Río Negro - Darwin (+2946)", value: "2946" },
  { label: "Río Negro - Lamarque (+2946)", value: "2946" },
  { label: "Río Negro - Luis Beltrán (+2946)", value: "2946" },
  { label: "Río Negro - Pomona (+2946)", value: "2946" },
  { label: "Río Negro - El Bolsón (+294)", value: "294" },
  { label: "Río Negro - El Foyel (+294)", value: "294" },
  { label: "Río Negro - El Manso (+294)", value: "294" },
  { label: "Río Negro - Mamuel Choique (+294)", value: "294" },
  { label: "Río Negro - Ñirihuau (+294)", value: "294" },
  { label: "Río Negro - Ñorquincó (+294)", value: "294" },
  { label: "Río Negro - Pilcaniyeu (+294)", value: "294" },
  { label: "Río Negro - Pilquiniyeu del Limay (+294)", value: "294" },
  { label: "Río Negro - Río Chico Río Villegas (+294)", value: "294" },
  { label: "Río Negro - San Carlos de Bariloche (+294)", value: "294" },
  { label: "Río Negro - Villa Campanario (+294)", value: "294" },
  { label: "Río Negro - Villa Cerro Catedral (+294)", value: "294" },
  { label: "Río Negro - Villa Llanquín (+294)", value: "294" },
  { label: "Río Negro - Villa Llao Llao (+294)", value: "294" },
  { label: "Río Negro - Villa Mascardi (+294)", value: "294" },
  { label: "Río Negro - Aguada Guzmán (+298)", value: "298" },
  { label: "Río Negro - Allen (+298)", value: "298" },
  { label: "Río Negro - Cerro Policía (+298)", value: "298" },
  { label: "Río Negro - Cervantes (+298)", value: "298" },
  { label: "Río Negro - Chichinales (+298)", value: "298" },
  { label: "Río Negro - Coronel Juan José Gómez (+298)", value: "298" },
  { label: "Río Negro - El Cuy (+298)", value: "298" },
  { label: "Río Negro - General Enrique Godoy (+298)", value: "298" },
  { label: "Río Negro - General Roca (+298)", value: "298" },
  { label: "Río Negro - Guerrico (+298)", value: "298" },
  { label: "Río Negro - Ingeniero Otto Krause (+298)", value: "298" },
  { label: "Río Negro - Mainqué (+298)", value: "298" },
  { label: "Río Negro - Mencué (+298)", value: "298" },
  { label: "Río Negro - Padre Stefenelli (+298)", value: "298" },
  { label: "Río Negro - Paso Córdoba (+298)", value: "298" },
  { label: "Río Negro - Valle Azul (+298)", value: "298" },
  { label: "Río Negro - Villa Alberdi (+298)", value: "298" },
  { label: "Río Negro - Villa del Parque (+298)", value: "298" },
  { label: "Río Negro - Villa Regina (+298)", value: "298" },
  { label: "Río Negro - Bajo San Cayetano (+299)", value: "299" },
  { label: "Río Negro - Barda del Medio (+299)", value: "299" },
  { label: "Río Negro - Campo Grande (+299)", value: "299" },
  { label: "Río Negro - Catriel (+299)", value: "299" },
  { label: "Río Negro - Cinco Saltos (+299)", value: "299" },
  { label: "Río Negro - Cipolletti (+299)", value: "299" },
  { label: "Río Negro - Contralmirante Cordero (+299)", value: "299" },
  { label: "Río Negro - Ferri (+299)", value: "299" },
  { label: "Río Negro - General Fernández Oro (+299)", value: "299" },
  { label: "Río Negro - Las Perlas (+299)", value: "299" },
  { label: "Río Negro - Península Ruca Co (+299)", value: "299" },
  { label: "Río Negro - Peñas Blancas (+299)", value: "299" },
  { label: "Río Negro - Sargento Vidal (+299)", value: "299" },
  { label: "Río Negro - Villa Manzano (+299)", value: "299" },
  { label: "Río Negro - Villa San Isidro (+299)", value: "299" },
  { label: "Salta - Alemanía (+387)", value: "387" },
  { label: "Salta - Ampascachi (+387)", value: "387" },
  { label: "Salta - Cabra Corral (+387)", value: "387" },
  { label: "Salta - Campo Quijano (+387)", value: "387" },
  { label: "Salta - Campo Santo (+387)", value: "387" },
  { label: "Salta - Cerrillos (+387)", value: "387" },
  { label: "Salta - Chicoana (+387)", value: "387" },
  { label: "Salta - Cobos (+387)", value: "387" },
  { label: "Salta - Coronel Moldes (+387)", value: "387" },
  { label: "Salta - El Bordo (+387)", value: "387" },
  { label: "Salta - El Carril (+387)", value: "387" },
  { label: "Salta - General Güemes (+387)", value: "387" },
  { label: "Salta - Guachipas (+387)", value: "387" },
  { label: "Salta - Iruya (+387)", value: "387" },
  { label: "Salta - La Caldera (+387)", value: "387" },
  { label: "Salta - La Ciénaga (+387)", value: "387" },
  { label: "Salta - La Merced (+387)", value: "387" },
  { label: "Salta - La Silleta (+387)", value: "387" },
  { label: "Salta - La Viña (+387)", value: "387" },
  { label: "Salta - Las Costas (+387)", value: "387" },
  { label: "Salta - Olacapato (+387)", value: "387" },
  { label: "Salta - Rosario de Lerma (+387)", value: "387" },
  { label: "Salta - Salta (+387)", value: "387" },
  { label: "Salta - San Agustín (+387)", value: "387" },
  { label: "Salta - San Antonio de los Cobres (+387)", value: "387" },
  { label: "Salta - Santa Rosa de los Pastos Grandes (+387)", value: "387" },
  { label: "Salta - Talapampa (+387)", value: "387" },
  { label: "Salta - Tolar Grande (+387)", value: "387" },
  { label: "Salta - Vaqueros (+387)", value: "387" },
  { label: "Salta - Villa Los Álamos (+387)", value: "387" },
  { label: "Salta - Villa San Lorenzo (+387)", value: "387" },
  { label: "Salta - Angastaco (+3868)", value: "3868" },
  { label: "Salta - Animaná (+3868)", value: "3868" },
  { label: "Salta - Cachi (+3868)", value: "3868" },
  { label: "Salta - Cafayate (+3868)", value: "3868" },
  { label: "Salta - Cobres (+3868)", value: "3868" },
  { label: "Salta - El Barrial (+3868)", value: "3868" },
  { label: "Salta - La Poma (+3868)", value: "3868" },
  { label: "Salta - La Puerta (+3868)", value: "3868" },
  { label: "Salta - Molinos (+3868)", value: "3868" },
  { label: "Salta - Payogasta (+3868)", value: "3868" },
  { label: "Salta - San Carlos (+3868)", value: "3868" },
  { label: "Salta - Santa Bárbara (+3868)", value: "3868" },
  { label: "Salta - Seclantás (+3868)", value: "3868" },
  { label: "Salta - Tolombón (+3868)", value: "3868" },
  { label: "Salta - Aguaray (+3873)", value: "3873" },
  { label: "Salta - Alto de la Sierra (+3873)", value: "3873" },
  { label: "Salta - Campamento Vespucio (+3873)", value: "3873" },
  { label: "Salta - Campo Durán (+3873)", value: "3873" },
  { label: "Salta - Capiazuti (+3873)", value: "3873" },
  { label: "Salta - Coronel Cornejo (+3873)", value: "3873" },
  { label: "Salta - General Ballivián (+3873)", value: "3873" },
  { label: "Salta - General Mosconi (+3873)", value: "3873" },
  { label: "Salta - Misión Kilómetro 6 (+3873)", value: "3873" },
  { label: "Salta - Pacará (+3873)", value: "3873" },
  { label: "Salta - Piquirenda (+3873)", value: "3873" },
  { label: "Salta - Recaredo (+3873)", value: "3873" },
  { label: "Salta - Salvador Mazza (+3873)", value: "3873" },
  { label: "Salta - Santa María (+3873)", value: "3873" },
  { label: "Salta - Santa Victoria Este (+3873)", value: "3873" },
  { label: "Salta - Tartagal (+3873)", value: "3873" },
  { label: "Salta - Tobantirenda (+3873)", value: "3873" },
  { label: "Salta - Tranquitas (+3873)", value: "3873" },
  { label: "Salta - Yacuy (+3873)", value: "3873" },
  { label: "Salta - Antilla (+3876)", value: "3876" },
  { label: "Salta - Copo Quile (+3876)", value: "3876" },
  { label: "Salta - El Galpón (+3876)", value: "3876" },
  { label: "Salta - El Jardín (+3876)", value: "3876" },
  { label: "Salta - El Naranjo (+3876)", value: "3876" },
  { label: "Salta - El Potrero (+3876)", value: "3876" },
  { label: "Salta - El Tala (+3876)", value: "3876" },
  { label: "Salta - El Tunal (+3876)", value: "3876" },
  { label: "Salta - La Candelaria (+3876)", value: "3876" },
  { label: "Salta - Lumbreras (+3876)", value: "3876" },
  { label: "Salta - Metán Viejo (+3876)", value: "3876" },
  { label: "Salta - Presa El Tunal (+3876)", value: "3876" },
  { label: "Salta - Río Piedras (+3876)", value: "3876" },
  { label: "Salta - Rosario de la Frontera (+3876)", value: "3876" },
  { label: "Salta - San Felipe (+3876)", value: "3876" },
  { label: "Salta - San José de Metán (+3876)", value: "3876" },
  { label: "Salta - Apolinario Saravia (+3877)", value: "3877" },
  { label: "Salta - Ceibalito (+3877)", value: "3877" },
  { label: "Salta - Centro 25 de Junio (+3877)", value: "3877" },
  { label: "Salta - Coronel Mollinedo (+3877)", value: "3877" },
  { label: "Salta - Coronel Olleros (+3877)", value: "3877" },
  { label: "Salta - El Quebrachal (+3877)", value: "3877" },
  { label: "Salta - Gaona (+3877)", value: "3877" },
  { label: "Salta - General Pizarro (+3877)", value: "3877" },
  { label: "Salta - Joaquín Víctor González (+3877)", value: "3877" },
  { label: "Salta - Las Lajitas (+3877)", value: "3877" },
  { label: "Salta - Luis Burela (+3877)", value: "3877" },
  { label: "Salta - Macapillo (+3877)", value: "3877" },
  { label: "Salta - Piquete Cabado (+3877)", value: "3877" },
  { label: "Salta - Río del Valle (+3877)", value: "3877" },
  { label: "Salta - San José de la Orquera (+3877)", value: "3877" },
  { label: "Salta - Tolloche (+3877)", value: "3877" },
  { label: "Salta - Aguas Blancas (+3878)", value: "3878" },
  { label: "Salta - Campichuelo (+3878)", value: "3878" },
  { label: "Salta - Capitán Juan Pagé (+3878)", value: "3878" },
  { label: "Salta - Carboncito (+3878)", value: "3878" },
  { label: "Salta - Colonia Santa Rosa (+3878)", value: "3878" },
  { label: "Salta - Coronel Juan Solá (+3878)", value: "3878" },
  { label: "Salta - Dragones (+3878)", value: "3878" },
  { label: "Salta - Embarcación (+3878)", value: "3878" },
  { label: "Salta - Hickman (+3878)", value: "3878" },
  { label: "Salta - Hipólito Yrigoyen (+3878)", value: "3878" },
  { label: "Salta - Isla de Cañas (+3878)", value: "3878" },
  { label: "Salta - La Misión (+3878)", value: "3878" },
  { label: "Salta - La Unión (+3878)", value: "3878" },
  { label: "Salta - Los Blancos (+3878)", value: "3878" },
  { label: "Salta - Los Toldos (+3878)", value: "3878" },
  { label: "Salta - Misión Chaqueña (+3878)", value: "3878" },
  { label: "Salta - Misión Tierras Fiscales (+3878)", value: "3878" },
  { label: "Salta - Orán (+3878)", value: "3878" },
  { label: "Salta - Padre Lozano (+3878)", value: "3878" },
  { label: "Salta - Pichanal (+3878)", value: "3878" },
  { label: "Salta - Pluma de Pato (+3878)", value: "3878" },
  { label: "Salta - Pueblo Viejo (+3878)", value: "3878" },
  { label: "Salta - Rivadavia (+3878)", value: "3878" },
  { label: "Salta - San Isidro de Iruya (+3878)", value: "3878" },
  { label: "Salta - Santa Rosa (+3878)", value: "3878" },
  { label: "Salta - Urundel (+3878)", value: "3878" },
  { label: "Salta - Acoyte (+3885)", value: "3885" },
  { label: "Salta - Barrios (+3885)", value: "3885" },
  { label: "Salta - Campo La Cruz (+3885)", value: "3885" },
  { label: "Salta - Nazareno (+3885)", value: "3885" },
  { label: "Salta - Poscaya (+3885)", value: "3885" },
  { label: "Salta - San Marcos (+3885)", value: "3885" },
  { label: "Salta - Santa Victoria Oeste (+3885)", value: "3885" },
  { label: "San Juan - Albardón (+264)", value: "264" },
  { label: "San Juan - Alto de Sierra (Nueve de Julio) (+264)", value: "264" },
  { label: "San Juan - Alto de Sierra (Santa Lucía) (+264)", value: "264" },
  { label: "San Juan - Barrio Ruta 40 (+264)", value: "264" },
  { label: "San Juan - Barrio Sadop (+264)", value: "264" },
  { label: "San Juan - Bermejo (+264)", value: "264" },
  { label: "San Juan - Campo Afuera (+264)", value: "264" },
  { label: "San Juan - Cañada Honda (+264)", value: "264" },
  { label: "San Juan - Carpintería (+264)", value: "264" },
  { label: "San Juan - Caucete (+264)", value: "264" },
  { label: "San Juan - Cienaguita (+264)", value: "264" },
  { label: "San Juan - Colonia Fiorito (+264)", value: "264" },
  { label: "San Juan - Colonia Fiscal (+264)", value: "264" },
  { label: "San Juan - Colonia Gutiérrez (+264)", value: "264" },
  { label: "San Juan - Divisadero (+264)", value: "264" },
  { label: "San Juan - Dos Acequias (+264)", value: "264" },
  { label: "San Juan - El Encón (+264)", value: "264" },
  { label: "San Juan - El Medanito (+264)", value: "264" },
  { label: "San Juan - El Rincón (Albardón) (+264)", value: "264" },
  { label: "San Juan - El Rincón (Caucete) (+264)", value: "264" },
  { label: "San Juan - General San Martín (+264)", value: "264" },
  { label: "San Juan - Guanacache (+264)", value: "264" },
  { label: "San Juan - La Cañada (+264)", value: "264" },
  { label: "San Juan - La Chimbera (+264)", value: "264" },
  { label: "San Juan - La Rinconada (+264)", value: "264" },
  { label: "San Juan - Las Chacritas (+264)", value: "264" },
  { label: "San Juan - Las Lagunas (+264)", value: "264" },
  { label: "San Juan - Las Talas (+264)", value: "264" },
  { label: "San Juan - Las Tapias (+264)", value: "264" },
  { label: "San Juan - Los Berros (+264)", value: "264" },
  { label: "San Juan - Los Berros (+264)", value: "264" },
  { label: "San Juan - Marayes (+264)", value: "264" },
  { label: "San Juan - Media Agua (+264)", value: "264" },
  { label: "San Juan - Nueve de Julio (+264)", value: "264" },
  { label: "San Juan - Pedernal (+264)", value: "264" },
  { label: "San Juan - Pie de Palo (+264)", value: "264" },
  { label: "San Juan - Punta del Médano (+264)", value: "264" },
  { label: "San Juan - Quinto Cuartel (+264)", value: "264" },
  { label: "San Juan - Rawson (+264)", value: "264" },
  { label: "San Juan - Rivadavia (+264)", value: "264" },
  { label: "San Juan - San Isidro (+264)", value: "264" },
  { label: "San Juan - San Juan (+264)", value: "264" },
  { label: "San Juan - San Martín (+264)", value: "264" },
  { label: "San Juan - Santa Lucía (+264)", value: "264" },
  { label: "San Juan - Santa Rosa (+264)", value: "264" },
  { label: "San Juan - Tupelí (+264)", value: "264" },
  { label: "San Juan - Vallecito (+264)", value: "264" },
  { label: "San Juan - Villa Aberastain (+264)", value: "264" },
  { label: "San Juan - Villa Ampacama (+264)", value: "264" },
  { label: "San Juan - Villa Barboza (+264)", value: "264" },
  { label: "San Juan - Villa Basilio Nievas (+264)", value: "264" },
  { label: "San Juan - Villa Bolaños (+264)", value: "264" },
  { label: "San Juan - Villa Borjas (+264)", value: "264" },
  { label: "San Juan - Villa Centenario (+264)", value: "264" },
  { label: "San Juan - Villa del Salvador (+264)", value: "264" },
  { label: "San Juan - Villa Dominguito (+264)", value: "264" },
  { label: "San Juan - Villa Don Bosco (+264)", value: "264" },
  { label: "San Juan - Villa El Tango (+264)", value: "264" },
  { label: "San Juan - Villa Ibáñez (+264)", value: "264" },
  { label: "San Juan - Villa Independencia (+264)", value: "264" },
  { label: "San Juan - Villa Krause (+264)", value: "264" },
  { label: "San Juan - Villa Nacusi (+264)", value: "264" },
  { label: "San Juan - Villa Paula Albarracín de Sarmiento (+264)", value: "264" },
  { label: "San Juan - Villa Sefair Talacasto (+264)", value: "264" },
  { label: "San Juan - Villa Tacú (+264)", value: "264" },
  { label: "San Juan - Astica (+2646)", value: "2646" },
  { label: "San Juan - Baldes del Rosario (+2646)", value: "2646" },
  { label: "San Juan - Chucuma (+2646)", value: "2646" },
  { label: "San Juan - Los Baldecitos (+2646)", value: "2646" },
  { label: "San Juan - Usno (+2646)", value: "2646" },
  { label: "San Juan - Villa San Agustín (+2646)", value: "2646" },
  { label: "San Juan - Angualasto (+2647)", value: "2647" },
  { label: "San Juan - Bella Vista (+2647)", value: "2647" },
  { label: "San Juan - Colola (+2647)", value: "2647" },
  { label: "San Juan - El Médano (+2647)", value: "2647" },
  { label: "San Juan - Gran China (+2647)", value: "2647" },
  { label: "San Juan - Huaco (+2647)", value: "2647" },
  { label: "San Juan - Iglesia (+2647)", value: "2647" },
  { label: "San Juan - La Falda (+2647)", value: "2647" },
  { label: "San Juan - Las Flores (+2647)", value: "2647" },
  { label: "San Juan - Mogna (+2647)", value: "2647" },
  { label: "San Juan - Niquivil (+2647)", value: "2647" },
  { label: "San Juan - Pampa Vieja (+2647)", value: "2647" },
  { label: "San Juan - Pismanta (+2647)", value: "2647" },
  { label: "San Juan - Rodeo (+2647)", value: "2647" },
  { label: "San Juan - San Isidro (+2647)", value: "2647" },
  { label: "San Juan - San José de Jáchal (+2647)", value: "2647" },
  { label: "San Juan - Tamberías (+2647)", value: "2647" },
  { label: "San Juan - Tudcum (+2647)", value: "2647" },
  { label: "San Juan - Villa Malvinas Argentinas (+2647)", value: "2647" },
  { label: "San Juan - Villa Mercedes (+2647)", value: "2647" },
  { label: "San Juan - Barreal (+2648)", value: "2648" },
  { label: "San Juan - Calingasta (+2648)", value: "2648" },
  { label: "San Juan - Tamberías (+2648)", value: "2648" },
  { label: "San Juan - Villa Pituil (+2648)", value: "2648" },
  { label: "San Luis - Alto Pelado (+266)", value: "266" },
  { label: "San Luis - Alto Pencoso (+266)", value: "266" },
  { label: "San Luis - Carolina (+266)", value: "266" },
  { label: "San Luis - Desaguadero (parte) (+266)", value: "266" },
  { label: "San Luis - El Trapiche (+266)", value: "266" },
  { label: "San Luis - El Volcán (+266)", value: "266" },
  { label: "San Luis - Juana Koslay (+266)", value: "266" },
  { label: "San Luis - La Calera (+266)", value: "266" },
  { label: "San Luis - La Florida (+266)", value: "266" },
  { label: "San Luis - La Punta (+266)", value: "266" },
  { label: "San Luis - Potrero de los Funes (parte) (+266)", value: "266" },
  { label: "San Luis - San Gerónimo (+266)", value: "266" },
  { label: "San Luis - San Luis (+266)", value: "266" },
  { label: "San Luis - Villa de la Quebrada (+266)", value: "266" },
  { label: "San Luis - Zanjitas (+266)", value: "266" },
  { label: "San Luis - Candelaria (+2651)", value: "2651" },
  { label: "San Luis - Luján (+2651)", value: "2651" },
  { label: "San Luis - Nogolí (+2651)", value: "2651" },
  { label: "San Luis - Quines (+2651)", value: "2651" },
  { label: "San Luis - San Francisco del Monte de Oro (+2651)", value: "2651" },
  { label: "San Luis - Juan Llerena (+2655)", value: "2655" },
  { label: "San Luis - La Toma (+2655)", value: "2655" },
  { label: "San Luis - Las Vertientes (+2655)", value: "2655" },
  { label: "San Luis - Paso Grande (+2655)", value: "2655" },
  { label: "San Luis - Saladillo (+2655)", value: "2655" },
  { label: "San Luis - Carpintería (+2656)", value: "2656" },
  { label: "San Luis - Cerro de Oro (+2656)", value: "2656" },
  { label: "San Luis - Concarán (+2656)", value: "2656" },
  { label: "San Luis - Cortaderas (+2656)", value: "2656" },
  { label: "San Luis - Lafinur (+2656)", value: "2656" },
  { label: "San Luis - Los Cajones (+2656)", value: "2656" },
  { label: "San Luis - Los Molles (+2656)", value: "2656" },
  { label: "San Luis - Merlo (+2656)", value: "2656" },
  { label: "San Luis - Naschel (+2656)", value: "2656" },
  { label: "San Luis - Papagayos (+2656)", value: "2656" },
  { label: "San Luis - Renca (+2656)", value: "2656" },
  { label: "San Luis - San Pablo (+2656)", value: "2656" },
  { label: "San Luis - Santa Rosa de Conlara (+2656)", value: "2656" },
  { label: "San Luis - Tilisarao (+2656)", value: "2656" },
  { label: "San Luis - Villa de Praga (+2656)", value: "2656" },
  { label: "San Luis - Villa del Carmen (+2656)", value: "2656" },
  { label: "San Luis - Villa Larca (+2656)", value: "2656" },
  { label: "San Luis - Fraga (+2657)", value: "2657" },
  { label: "San Luis - Juan Jorba (+2657)", value: "2657" },
  { label: "San Luis - Justo Daract (+2657)", value: "2657" },
  { label: "San Luis - Lavaisse (+2657)", value: "2657" },
  { label: "San Luis - San José del Morro (+2657)", value: "2657" },
  { label: "San Luis - Villa Mercedes (+2657)", value: "2657" },
  { label: "San Luis - Villa Reynolds (+2657)", value: "2657" },
  { label: "San Luis - Villa Salles (+2657)", value: "2657" },
  { label: "San Luis - Anchorena (+2658)", value: "2658" },
  { label: "San Luis - Arizona (+2658)", value: "2658" },
  { label: "San Luis - Bagual (+2658)", value: "2658" },
  { label: "San Luis - Batavia (+2658)", value: "2658" },
  { label: "San Luis - Buena Esperanza (+2658)", value: "2658" },
  { label: "San Luis - Fortín El Patria (+2658)", value: "2658" },
  { label: "San Luis - Fortuna (+2658)", value: "2658" },
  { label: "San Luis - La Maroma (+2658)", value: "2658" },
  { label: "San Luis - Martín de Loyola (+2658)", value: "2658" },
  { label: "San Luis - Nahuel Mapá (+2658)", value: "2658" },
  { label: "San Luis - Navia (+2658)", value: "2658" },
  { label: "San Luis - Nueva Galia (+2658)", value: "2658" },
  { label: "San Luis - Unión (+2658)", value: "2658" },
  { label: "Santa Cruz - Caleta Olivia (+297)", value: "297" },
  { label: "Santa Cruz - Cañadón Seco (+297)", value: "297" },
  { label: "Santa Cruz - Fitz Roy (+297)", value: "297" },
  { label: "Santa Cruz - Jaramillo (+297)", value: "297" },
  { label: "Santa Cruz - Koluel Kayke (+297)", value: "297" },
  { label: "Santa Cruz - Las Heras (+297)", value: "297" },
  { label: "Santa Cruz - Pico Truncado (+297)", value: "297" },
  { label: "Santa Cruz - Puerto Deseado (+297)", value: "297" },
  { label: "Santa Cruz - Tellier (+297)", value: "297" },
  { label: "Santa Cruz - El Calafate (+2902)", value: "2902" },
  { label: "Santa Cruz - El Turbio (+2902)", value: "2902" },
  { label: "Santa Cruz - Esperanza (+2902)", value: "2902" },
  { label: "Santa Cruz - Julia Dufour (+2902)", value: "2902" },
  { label: "Santa Cruz - Mina 3 (+2902)", value: "2902" },
  { label: "Santa Cruz - Río Turbio (+2902)", value: "2902" },
  { label: "Santa Cruz - Rospentek Aike (+2902)", value: "2902" },
  { label: "Santa Cruz - Veintiocho de Noviembre (+2902)", value: "2902" },
  { label: "Santa Cruz - Comandante Luis Piedrabuena (+2962)", value: "2962" },
  { label: "Santa Cruz - El Chaltén (+2962)", value: "2962" },
  { label: "Santa Cruz - Gobernador Gregores (+2962)", value: "2962" },
  { label: "Santa Cruz - Puerto San Julián (+2962)", value: "2962" },
  { label: "Santa Cruz - Puerto Santa Cruz (+2962)", value: "2962" },
  { label: "Santa Cruz - Tres Lagos (+2962)", value: "2962" },
  { label: "Santa Cruz - Bajo Caracoles (+2963)", value: "2963" },
  { label: "Santa Cruz - Lago Posadas (+2963)", value: "2963" },
  { label: "Santa Cruz - Los Antiguos (+2963)", value: "2963" },
  { label: "Santa Cruz - Perito Moreno (+2963)", value: "2963" },
  { label: "Santa Cruz - Río Gallegos (+2966)", value: "2966" },
  { label: "Santa Fe - Rosario (+341)", value: "341" },
  { label: "Santa Fe - Teodelina (parte) (+2353)", value: "2353" },
  { label: "Santa Fe - Colón (+2473)", value: "2473" },
  { label: "Santa Fe - Hughes (+2473)", value: "2473" },
  { label: "Santa Fe - Juncal (+2473)", value: "2473" },
  { label: "Santa Fe - Santa Emilia (parte) (+2473)", value: "2473" },
  { label: "Santa Fe - Wheelwright (+2473)", value: "2473" },
  { label: "Santa Fe - General Gelly (+2477)", value: "2477" },
  { label: "Santa Fe - Villa San José (+2477)", value: "2477" },
  { label: "Santa Fe - Aarón Castellanos (+3382)", value: "3382" },
  { label: "Santa Fe - Amenábar (+3382)", value: "3382" },
  { label: "Santa Fe - Christophersen (+3382)", value: "3382" },
  { label: "Santa Fe - Diego de Alvear (+3382)", value: "3382" },
  { label: "Santa Fe - Rufino (+3382)", value: "3382" },
  { label: "Santa Fe - San Gregorio (+3382)", value: "3382" },
  { label: "Santa Fe - Barrio Arroyo del Medio (+3400)", value: "3400" },
  { label: "Santa Fe - Barrio Mitre (+3400)", value: "3400" },
  { label: "Santa Fe - Empalme Villa Constitución (+3400)", value: "3400" },
  { label: "Santa Fe - Pavón (+3400)", value: "3400" },
  { label: "Santa Fe - Rueda (+3400)", value: "3400" },
  { label: "Santa Fe - Theobald (+3400)", value: "3400" },
  { label: "Santa Fe - Villa Constitución (+3400)", value: "3400" },
  { label: "Santa Fe - Cañada Rosquín (+3401)", value: "3401" },
  { label: "Santa Fe - Carlos Pellegrini (+3401)", value: "3401" },
  { label: "Santa Fe - Casas (+3401)", value: "3401" },
  { label: "Santa Fe - Centeno (+3401)", value: "3401" },
  { label: "Santa Fe - El Trébol (+3401)", value: "3401" },
  { label: "Santa Fe - Las Bandurrias (+3401)", value: "3401" },
  { label: "Santa Fe - Los Cardos (+3401)", value: "3401" },
  { label: "Santa Fe - María Susana (+3401)", value: "3401" },
  { label: "Santa Fe - Piamonte (+3401)", value: "3401" },
  { label: "Santa Fe - San Genaro (+3401)", value: "3401" },
  { label: "Santa Fe - San Genaro Norte (+3401)", value: "3401" },
  { label: "Santa Fe - Albarellos (+3402)", value: "3402" },
  { label: "Santa Fe - Álvarez (+3402)", value: "3402" },
  { label: "Santa Fe - Arroyo Seco (+3402)", value: "3402" },
  { label: "Santa Fe - Coronel Bogado (+3402)", value: "3402" },
  { label: "Santa Fe - Coronel Rodolfo S. Domínguez (+3402)", value: "3402" },
  { label: "Santa Fe - Fighiera (+3402)", value: "3402" },
  { label: "Santa Fe - General Lagos (+3402)", value: "3402" },
  { label: "Santa Fe - Los Muchachos - La Alborada (+3402)", value: "3402" },
  { label: "Santa Fe - Monte Flores (+3402)", value: "3402" },
  { label: "Santa Fe - Piñero (+3402)", value: "3402" },
  { label: "Santa Fe - Pueblo Esther (+3402)", value: "3402" },
  { label: "Santa Fe - Puerto Arroyo Seco (+3402)", value: "3402" },
  { label: "Santa Fe - Villa Amelia (+3402)", value: "3402" },
  { label: "Santa Fe - Campo Piaggio (+3404)", value: "3404" },
  { label: "Santa Fe - Colonia Belgrano (+3404)", value: "3404" },
  { label: "Santa Fe - Gálvez (+3404)", value: "3404" },
  { label: "Santa Fe - Gessler (+3404)", value: "3404" },
  { label: "Santa Fe - Larrechea (+3404)", value: "3404" },
  { label: "Santa Fe - Loma Alta (+3404)", value: "3404" },
  { label: "Santa Fe - López (+3404)", value: "3404" },
  { label: "Santa Fe - Pilar (+3404)", value: "3404" },
  { label: "Santa Fe - Sa Pereira (+3404)", value: "3404" },
  { label: "Santa Fe - San Carlos Centro (+3404)", value: "3404" },
  { label: "Santa Fe - San Carlos Norte (+3404)", value: "3404" },
  { label: "Santa Fe - San Carlos Sud (+3404)", value: "3404" },
  { label: "Santa Fe - San Eugenio (+3404)", value: "3404" },
  { label: "Santa Fe - San Jerónimo del Sauce (+3404)", value: "3404" },
  { label: "Santa Fe - San Jerónimo Norte (+3404)", value: "3404" },
  { label: "Santa Fe - San Mariano (+3404)", value: "3404" },
  { label: "Santa Fe - Santa Clara de Buena Vista (+3404)", value: "3404" },
  { label: "Santa Fe - Santa María Centro (+3404)", value: "3404" },
  { label: "Santa Fe - Santa María Norte (+3404)", value: "3404" },
  { label: "Santa Fe - Wildermuth (+3404)", value: "3404" },
  { label: "Santa Fe - Alejandra (+3405)", value: "3405" },
  { label: "Santa Fe - Cacique Ariacaiquín (+3405)", value: "3405" },
  { label: "Santa Fe - Cayastá (+3405)", value: "3405" },
  { label: "Santa Fe - Colonia Mascías (+3405)", value: "3405" },
  { label: "Santa Fe - Helvecia (+3405)", value: "3405" },
  { label: "Santa Fe - La Brava (+3405)", value: "3405" },
  { label: "Santa Fe - Los Zapallos (+3405)", value: "3405" },
  { label: "Santa Fe - Saladero Mariano Cabal (+3405)", value: "3405" },
  { label: "Santa Fe - San Javier (+3405)", value: "3405" },
  { label: "Santa Fe - Castelar (+3406)", value: "3406" },
  { label: "Santa Fe - Crispi (+3406)", value: "3406" },
  { label: "Santa Fe - Garibaldi (+3406)", value: "3406" },
  { label: "Santa Fe - Landeta (+3406)", value: "3406" },
  { label: "Santa Fe - Las Petacas (+3406)", value: "3406" },
  { label: "Santa Fe - María Juana (+3406)", value: "3406" },
  { label: "Santa Fe - San Jorge (+3406)", value: "3406" },
  { label: "Santa Fe - San Martín de las Escobas (+3406)", value: "3406" },
  { label: "Santa Fe - Sastre y Ortiz (+3406)", value: "3406" },
  { label: "Santa Fe - Traill (+3406)", value: "3406" },
  { label: "Santa Fe - Aguará Grande (+3408)", value: "3408" },
  { label: "Santa Fe - Balneario La Verde (+3408)", value: "3408" },
  { label: "Santa Fe - Capivara (+3408)", value: "3408" },
  { label: "Santa Fe - Colonia La Clara (+3408)", value: "3408" },
  { label: "Santa Fe - Huanqueros (+3408)", value: "3408" },
  { label: "Santa Fe - La Cabral (+3408)", value: "3408" },
  { label: "Santa Fe - La Lucila (+3408)", value: "3408" },
  { label: "Santa Fe - Las Avispas (+3408)", value: "3408" },
  { label: "Santa Fe - Ñanducita (+3408)", value: "3408" },
  { label: "Santa Fe - San Cristóbal (+3408)", value: "3408" },
  { label: "Santa Fe - Santurce (+3408)", value: "3408" },
  { label: "Santa Fe - Colonia Bossi (+3409)", value: "3409" },
  { label: "Santa Fe - Constanza (+3409)", value: "3409" },
  { label: "Santa Fe - Las Palmeras (+3409)", value: "3409" },
  { label: "Santa Fe - Moisés Ville (+3409)", value: "3409" },
  { label: "Santa Fe - Monigotes (+3409)", value: "3409" },
  { label: "Santa Fe - Palacios (+3409)", value: "3409" },
  { label: "Santa Fe - Cañada Rica (+3460)", value: "3460" },
  { label: "Santa Fe - Cepeda (+3460)", value: "3460" },
  { label: "Santa Fe - Godoy (+3460)", value: "3460" },
  { label: "Santa Fe - Juan Bernabé Molina (+3460)", value: "3460" },
  { label: "Santa Fe - La Vanguardia (+3460)", value: "3460" },
  { label: "Santa Fe - Máximo Paz (+3460)", value: "3460" },
  { label: "Santa Fe - Peyrano (+3460)", value: "3460" },
  { label: "Santa Fe - Santa Teresa (+3460)", value: "3460" },
  { label: "Santa Fe - Sargento Cabral (+3460)", value: "3460" },
  { label: "Santa Fe - Stephenson (+3460)", value: "3460" },
  { label: "Santa Fe - Carmen (+3462)", value: "3462" },
  { label: "Santa Fe - Chapuy (+3462)", value: "3462" },
  { label: "Santa Fe - Elortondo (+3462)", value: "3462" },
  { label: "Santa Fe - La Chispa (+3462)", value: "3462" },
  { label: "Santa Fe - Lazzarino (+3462)", value: "3462" },
  { label: "Santa Fe - Maggiolo (+3462)", value: "3462" },
  { label: "Santa Fe - María Teresa (+3462)", value: "3462" },
  { label: "Santa Fe - Murphy (+3462)", value: "3462" },
  { label: "Santa Fe - San Eduardo (+3462)", value: "3462" },
  { label: "Santa Fe - San Francisco de Santa Fe (+3462)", value: "3462" },
  { label: "Santa Fe - Sancti Spiritu (+3462)", value: "3462" },
  { label: "Santa Fe - Santa Emilia (parte) (+3462)", value: "3462" },
  { label: "Santa Fe - Santa Isabel (+3462)", value: "3462" },
  { label: "Santa Fe - Teodelina (parte) (+3462)", value: "3462" },
  { label: "Santa Fe - Venado Tuerto (+3462)", value: "3462" },
  { label: "Santa Fe - Villa Cañás (+3462)", value: "3462" },
  { label: "Santa Fe - Arequito (+3464)", value: "3464" },
  { label: "Santa Fe - Bigand (+3464)", value: "3464" },
  { label: "Santa Fe - Casilda (+3464)", value: "3464" },
  { label: "Santa Fe - Chabás (+3464)", value: "3464" },
  { label: "Santa Fe - Fuentes (+3464)", value: "3464" },
  { label: "Santa Fe - Los Molinos (+3464)", value: "3464" },
  { label: "Santa Fe - Pujato (+3464)", value: "3464" },
  { label: "Santa Fe - Sanford (+3464)", value: "3464" },
  { label: "Santa Fe - Villa Mugueta (+3464)", value: "3464" },
  { label: "Santa Fe - Alcorta (+3465)", value: "3465" },
  { label: "Santa Fe - Berabevú (+3465)", value: "3465" },
  { label: "Santa Fe - Bombal (+3465)", value: "3465" },
  { label: "Santa Fe - Cañada del Ucle (+3465)", value: "3465" },
  { label: "Santa Fe - Carreras (+3465)", value: "3465" },
  { label: "Santa Fe - Chovet (+3465)", value: "3465" },
  { label: "Santa Fe - Firmat (+3465)", value: "3465" },
  { label: "Santa Fe - Gödeken (+3465)", value: "3465" },
  { label: "Santa Fe - Labordeboy (+3465)", value: "3465" },
  { label: "Santa Fe - Los Quirquinchos (+3465)", value: "3465" },
  { label: "Santa Fe - Melincué (+3465)", value: "3465" },
  { label: "Santa Fe - Miguel Torres (+3465)", value: "3465" },
  { label: "Santa Fe - Paraje El Jardín (+3465)", value: "3465" },
  { label: "Santa Fe - Villa Estela (+3465)", value: "3465" },
  { label: "Santa Fe - Villada (+3465)", value: "3465" },
  { label: "Santa Fe - Arocena (+3466)", value: "3466" },
  { label: "Santa Fe - Balneario Monje (+3466)", value: "3466" },
  { label: "Santa Fe - Barrancas (+3466)", value: "3466" },
  { label: "Santa Fe - Bernardo de Irigoyen (+3466)", value: "3466" },
  { label: "Santa Fe - Casalegno (+3466)", value: "3466" },
  { label: "Santa Fe - Díaz (+3466)", value: "3466" },
  { label: "Santa Fe - Monje (+3466)", value: "3466" },
  { label: "Santa Fe - Paraje Comipini (+3466)", value: "3466" },
  { label: "Santa Fe - Pueblo Irigoyen (+3466)", value: "3466" },
  { label: "Santa Fe - Puerto Aragón (+3466)", value: "3466" },
  { label: "Santa Fe - San Fabián (+3466)", value: "3466" },
  { label: "Santa Fe - Arteaga (+3467)", value: "3467" },
  { label: "Santa Fe - Los Nogales (+3467)", value: "3467" },
  { label: "Santa Fe - Saladillo (+3467)", value: "3467" },
  { label: "Santa Fe - San José de la Esquina (+3467)", value: "3467" },
  { label: "Santa Fe - Cafferata (+3468)", value: "3468" },
  { label: "Santa Fe - Chañar Ladeado (+3468)", value: "3468" },
  { label: "Santa Fe - Corral de Bustos (+3468)", value: "3468" },
  { label: "Santa Fe - Acebal (+3469)", value: "3469" },
  { label: "Santa Fe - Arminda (+3469)", value: "3469" },
  { label: "Santa Fe - Carmen del Sauce (+3469)", value: "3469" },
  { label: "Santa Fe - Cuatro Esquinas (+3469)", value: "3469" },
  { label: "Santa Fe - Pavón Arriba (+3469)", value: "3469" },
  { label: "Santa Fe - Pueblo Muñoz (+3469)", value: "3469" },
  { label: "Santa Fe - Pueblo Uranga (+3469)", value: "3469" },
  { label: "Santa Fe - Armstrong (+3471)", value: "3471" },
  { label: "Santa Fe - Berreta (+3471)", value: "3471" },
  { label: "Santa Fe - Bouquet (+3471)", value: "3471" },
  { label: "Santa Fe - Bustinza (+3471)", value: "3471" },
  { label: "Santa Fe - Cañada de Gómez (+3471)", value: "3471" },
  { label: "Santa Fe - Clason (+3471)", value: "3471" },
  { label: "Santa Fe - Colonia Medici (+3471)", value: "3471" },
  { label: "Santa Fe - Correa (+3471)", value: "3471" },
  { label: "Santa Fe - Las Parejas (+3471)", value: "3471" },
  { label: "Santa Fe - Las Rosas (+3471)", value: "3471" },
  { label: "Santa Fe - Montes de Oca (+3471)", value: "3471" },
  { label: "Santa Fe - Tortugas (+3471)", value: "3471" },
  { label: "Santa Fe - Villa Eloísa (+3471)", value: "3471" },
  { label: "Santa Fe - Aldao (+3476)", value: "3476" },
  { label: "Santa Fe - Cicarelli (+3476)", value: "3476" },
  { label: "Santa Fe - Clarke (+3476)", value: "3476" },
  { label: "Santa Fe - Larguía (+3476)", value: "3476" },
  { label: "Santa Fe - Lucio V. López (+3476)", value: "3476" },
  { label: "Santa Fe - Luis Palacios (+3476)", value: "3476" },
  { label: "Santa Fe - Maciel Oliveros (+3476)", value: "3476" },
  { label: "Santa Fe - Pueblo Andino (+3476)", value: "3476" },
  { label: "Santa Fe - Puerto Gaboto (+3476)", value: "3476" },
  { label: "Santa Fe - Puerto General San Martín (+3476)", value: "3476" },
  { label: "Santa Fe - Ricardone (+3476)", value: "3476" },
  { label: "Santa Fe - Salto Grande (+3476)", value: "3476" },
  { label: "Santa Fe - San Lorenzo (+3476)", value: "3476" },
  { label: "Santa Fe - Serodino (+3476)", value: "3476" },
  { label: "Santa Fe - Timbúes (+3476)", value: "3476" },
  { label: "Santa Fe - Totoras (+3476)", value: "3476" },
  { label: "Santa Fe - Villa Elvira (+3476)", value: "3476" },
  { label: "Santa Fe - Villa La Ribera (+3476)", value: "3476" },
  { label: "Santa Fe - Arroyo Ceibal (+3482)", value: "3482" },
  { label: "Santa Fe - Avellaneda (+3482)", value: "3482" },
  { label: "Santa Fe - Berna (+3482)", value: "3482" },
  { label: "Santa Fe - Cañada Ombú (+3482)", value: "3482" },
  { label: "Santa Fe - Colonia Durán (+3482)", value: "3482" },
  { label: "Santa Fe - El Arazá (+3482)", value: "3482" },
  { label: "Santa Fe - El Rabón (+3482)", value: "3482" },
  { label: "Santa Fe - El Sombrerito (+3482)", value: "3482" },
  { label: "Santa Fe - Florencia (+3482)", value: "3482" },
  { label: "Santa Fe - Garabato (+3482)", value: "3482" },
  { label: "Santa Fe - Guadalupe Norte (+3482)", value: "3482" },
  { label: "Santa Fe - Ingeniero Chanourdie (+3482)", value: "3482" },
  { label: "Santa Fe - Intiyaco (+3482)", value: "3482" },
  { label: "Santa Fe - Kilómetro 115 (+3482)", value: "3482" },
  { label: "Santa Fe - La Isleta (+3482)", value: "3482" },
  { label: "Santa Fe - La Sarita (+3482)", value: "3482" },
  { label: "Santa Fe - Lanteri (+3482)", value: "3482" },
  { label: "Santa Fe - Las Garzas (+3482)", value: "3482" },
  { label: "Santa Fe - Las Toscas (+3482)", value: "3482" },
  { label: "Santa Fe - Los Amores (+3482)", value: "3482" },
  { label: "Santa Fe - Los Laureles (+3482)", value: "3482" },
  { label: "Santa Fe - Los Tábanos (+3482)", value: "3482" },
  { label: "Santa Fe - Malabrigo (+3482)", value: "3482" },
  { label: "Santa Fe - Nicanor Molinas Paraje San Manuel (+3482)", value: "3482" },
  { label: "Santa Fe - Pozo de los Indios (+3482)", value: "3482" },
  { label: "Santa Fe - Reconquista (+3482)", value: "3482" },
  { label: "Santa Fe - Romang (+3482)", value: "3482" },
  { label: "Santa Fe - San Antonio de Obligado (+3482)", value: "3482" },
  { label: "Santa Fe - Tacuarendí (+3482)", value: "3482" },
  { label: "Santa Fe - Tartagal (+3482)", value: "3482" },
  { label: "Santa Fe - Villa Ana (+3482)", value: "3482" },
  { label: "Santa Fe - Villa Guillermina (+3482)", value: "3482" },
  { label: "Santa Fe - Villa Ocampo (+3482)", value: "3482" },
  { label: "Santa Fe - Calchaquí (+3483)", value: "3483" },
  { label: "Santa Fe - Colmena (+3483)", value: "3483" },
  { label: "Santa Fe - Fortín Olmos (+3483)", value: "3483" },
  { label: "Santa Fe - Golondrina (+3483)", value: "3483" },
  { label: "Santa Fe - La Gallareta (+3483)", value: "3483" },
  { label: "Santa Fe - Margarita (+3483)", value: "3483" },
  { label: "Santa Fe - Pueblo Santa Lucía (+3483)", value: "3483" },
  { label: "Santa Fe - Toba (+3483)", value: "3483" },
  { label: "Santa Fe - Vera (+3483)", value: "3483" },
  { label: "Santa Fe - Ambrosetti (+3491)", value: "3491" },
  { label: "Santa Fe - Arrufó (+3491)", value: "3491" },
  { label: "Santa Fe - Ceres (+3491)", value: "3491" },
  { label: "Santa Fe - Colonia Ana (+3491)", value: "3491" },
  { label: "Santa Fe - Curupaity (+3491)", value: "3491" },
  { label: "Santa Fe - Esteban Rams (+3491)", value: "3491" },
  { label: "Santa Fe - Gato Colorado (+3491)", value: "3491" },
  { label: "Santa Fe - Gregoria Pérez de Denis (+3491)", value: "3491" },
  { label: "Santa Fe - Hersilia (+3491)", value: "3491" },
  { label: "Santa Fe - La Rubia (+3491)", value: "3491" },
  { label: "Santa Fe - Logroño (+3491)", value: "3491" },
  { label: "Santa Fe - Montefiore (+3491)", value: "3491" },
  { label: "Santa Fe - Pozo Borrado (+3491)", value: "3491" },
  { label: "Santa Fe - San Bernardo (+3491)", value: "3491" },
  { label: "Santa Fe - Santa Margarita (+3491)", value: "3491" },
  { label: "Santa Fe - Tostado (+3491)", value: "3491" },
  { label: "Santa Fe - Villa Minetti (+3491)", value: "3491" },
  { label: "Santa Fe - Villa Trinidad (+3491)", value: "3491" },
  { label: "Santa Fe - Angélica (+3492)", value: "3492" },
  { label: "Santa Fe - Aurelia (+3492)", value: "3492" },
  { label: "Santa Fe - Bauer y Sigel (+3492)", value: "3492" },
  { label: "Santa Fe - Bella Italia (+3492)", value: "3492" },
  { label: "Santa Fe - Castellanos (+3492)", value: "3492" },
  { label: "Santa Fe - Colonia Cello (+3492)", value: "3492" },
  { label: "Santa Fe - Colonia Margarita (+3492)", value: "3492" },
  { label: "Santa Fe - Coronel Fraga (+3492)", value: "3492" },
  { label: "Santa Fe - Egusquiza (+3492)", value: "3492" },
  { label: "Santa Fe - Esmeralda (+3492)", value: "3492" },
  { label: "Santa Fe - Estación Clucellas (+3492)", value: "3492" },
  { label: "Santa Fe - Eustolia (+3492)", value: "3492" },
  { label: "Santa Fe - Josefina (+3492)", value: "3492" },
  { label: "Santa Fe - Lehmann (+3492)", value: "3492" },
  { label: "Santa Fe - Nueva Lehmann (+3492)", value: "3492" },
  { label: "Santa Fe - Plaza Clucellas (+3492)", value: "3492" },
  { label: "Santa Fe - Plaza Saguier (+3492)", value: "3492" },
  { label: "Santa Fe - Presidente Roca (+3492)", value: "3492" },
  { label: "Santa Fe - Pueblo Marini (+3492)", value: "3492" },
  { label: "Santa Fe - Rafaela (+3492)", value: "3492" },
  { label: "Santa Fe - Ramona (+3492)", value: "3492" },
  { label: "Santa Fe - San Antonio (+3492)", value: "3492" },
  { label: "Santa Fe - San Vicente (+3492)", value: "3492" },
  { label: "Santa Fe - Santa Clara de Saguier (+3492)", value: "3492" },
  { label: "Santa Fe - Susana (+3492)", value: "3492" },
  { label: "Santa Fe - Vila (+3492)", value: "3492" },
  { label: "Santa Fe - Villa San José (+3492)", value: "3492" },
  { label: "Santa Fe - Aldao (+3493)", value: "3493" },
  { label: "Santa Fe - Ataliva (+3493)", value: "3493" },
  { label: "Santa Fe - Colonia Bicha (+3493)", value: "3493" },
  { label: "Santa Fe - Colonia Raquel (+3493)", value: "3493" },
  { label: "Santa Fe - Colonia Tacurales (+3493)", value: "3493" },
  { label: "Santa Fe - Eusebia y Carolina (+3493)", value: "3493" },
  { label: "Santa Fe - Galisteo (+3493)", value: "3493" },
  { label: "Santa Fe - Humberto Primo (+3493)", value: "3493" },
  { label: "Santa Fe - Sunchales (+3493)", value: "3493" },
  { label: "Santa Fe - Tacural (+3493)", value: "3493" },
  { label: "Santa Fe - Virginia (+3493)", value: "3493" },
  { label: "Santa Fe - Colonia Cavour (+3496)", value: "3496" },
  { label: "Santa Fe - Esperanza (+3496)", value: "3496" },
  { label: "Santa Fe - Felicia (+3496)", value: "3496" },
  { label: "Santa Fe - Grutly (+3496)", value: "3496" },
  { label: "Santa Fe - Humboldt (+3496)", value: "3496" },
  { label: "Santa Fe - Ituzaingó (+3496)", value: "3496" },
  { label: "Santa Fe - Nuevo Torino (+3496)", value: "3496" },
  { label: "Santa Fe - Pujato Norte (+3496)", value: "3496" },
  { label: "Santa Fe - Rivadavia (+3496)", value: "3496" },
  { label: "Santa Fe - Cululú (+3497)", value: "3497" },
  { label: "Santa Fe - Emilia (+3497)", value: "3497" },
  { label: "Santa Fe - Hipatía (+3497)", value: "3497" },
  { label: "Santa Fe - Jacinto L. Aráuz (+3497)", value: "3497" },
  { label: "Santa Fe - La Pelada (+3497)", value: "3497" },
  { label: "Santa Fe - Llambi Campbell (+3497)", value: "3497" },
  { label: "Santa Fe - María Luisa (+3497)", value: "3497" },
  { label: "Santa Fe - Progreso (+3497)", value: "3497" },
  { label: "Santa Fe - Providencia (+3497)", value: "3497" },
  { label: "Santa Fe - Santo Domingo (+3497)", value: "3497" },
  { label: "Santa Fe - Sarmiento (+3497)", value: "3497" },
  { label: "Santa Fe - Angeloni (+3498)", value: "3498" },
  { label: "Santa Fe - Cayastacito (+3498)", value: "3498" },
  { label: "Santa Fe - Colonia Dolores (+3498)", value: "3498" },
  { label: "Santa Fe - Colonia Esther (+3498)", value: "3498" },
  { label: "Santa Fe - Colonia Silva (+3498)", value: "3498" },
  { label: "Santa Fe - Elisa (+3498)", value: "3498" },
  { label: "Santa Fe - Gobernador Crespo (+3498)", value: "3498" },
  { label: "Santa Fe - La Camila (+3498)", value: "3498" },
  { label: "Santa Fe - La Criolla (+3498)", value: "3498" },
  { label: "Santa Fe - La Penca y Caraguatá (+3498)", value: "3498" },
  { label: "Santa Fe - Marcelino Escalada (+3498)", value: "3498" },
  { label: "Santa Fe - Naré (+3498)", value: "3498" },
  { label: "Santa Fe - Pedro Gómez Cello (+3498)", value: "3498" },
  { label: "Santa Fe - Ramayón (+3498)", value: "3498" },
  { label: "Santa Fe - San Bernardo (San Justo) (+3498)", value: "3498" },
  { label: "Santa Fe - San Justo (+3498)", value: "3498" },
  { label: "Santa Fe - San Martín Norte (+3498)", value: "3498" },
  { label: "Santa Fe - Soledad (+3498)", value: "3498" },
  { label: "Santa Fe - Vera y Pintado (+3498)", value: "3498" },
  { label: "Santa Fe - Videla (+3498)", value: "3498" },
  { label: "Santa Fe - Villa Saralegui (+3498)", value: "3498" },
  { label: "Santa Fe - Colonia Dos Rosas y La Legua (+3562)", value: "3562" },
  { label: "Santa Fe - Colonia Rosa (+3562)", value: "3562" },
  { label: "Santa Fe - Monte Oscuridad (+3562)", value: "3562" },
  { label: "Santa Fe - San Guillermo (+3562)", value: "3562" },
  { label: "Santa Fe - Suardi (+3562)", value: "3562" },
  { label: "Santa Fe - Barrios Acapulco y Veracruz (+3564)", value: "3564" },
  { label: "Santa Fe - Colonia Iturraspe (+3564)", value: "3564" },
  { label: "Santa Fe - Freyre (+3564)", value: "3564" },
  { label: "Santa Fe - Frontera (+3564)", value: "3564" },
  { label: "Santa Fe - Villa Josefina (+3564)", value: "3564" },
  { label: "Santa Fe - Zenón Pereyra (+3564)", value: "3564" },
  { label: "Santiago del Estero - Antajé (+385)", value: "385" },
  { label: "Santiago del Estero - Ardiles (+385)", value: "385" },
  { label: "Santiago del Estero - Árraga (+385)", value: "385" },
  { label: "Santiago del Estero - Beltrán (+385)", value: "385" },
  { label: "Santiago del Estero - Cañada Escobar (+385)", value: "385" },
  { label: "Santiago del Estero - Chaupi Pozo (+385)", value: "385" },
  { label: "Santiago del Estero - Clodomira (+385)", value: "385" },
  { label: "Santiago del Estero - Colonia El Simbolar (+385)", value: "385" },
  { label: "Santiago del Estero - El Deán (+385)", value: "385" },
  { label: "Santiago del Estero - El Mojón (+385)", value: "385" },
  { label: "Santiago del Estero - El Puestito de San Antonio (+385)", value: "385" },
  { label: "Santiago del Estero - El Zanjón (+385)", value: "385" },
  { label: "Santiago del Estero - Estación Robles (+385)", value: "385" },
  { label: "Santiago del Estero - Estación Simbolar (+385)", value: "385" },
  { label: "Santiago del Estero - Estación Taboada (+385)", value: "385" },
  { label: "Santiago del Estero - Fernández (+385)", value: "385" },
  { label: "Santiago del Estero - Ingeniero Forres (+385)", value: "385" },
  { label: "Santiago del Estero - La Aurora (+385)", value: "385" },
  { label: "Santiago del Estero - La Banda (+385)", value: "385" },
  { label: "Santiago del Estero - La Dársena (San Ramón) (+385)", value: "385" },
  { label: "Santiago del Estero - Los Cardozos (+385)", value: "385" },
  { label: "Santiago del Estero - Los Morales (+385)", value: "385" },
  { label: "Santiago del Estero - Los Núñez (+385)", value: "385" },
  { label: "Santiago del Estero - Los Quiroga (+385)", value: "385" },
  { label: "Santiago del Estero - Maco (+385)", value: "385" },
  { label: "Santiago del Estero - Maquito (+385)", value: "385" },
  { label: "Santiago del Estero - San Pedro (+385)", value: "385" },
  { label: "Santiago del Estero - Santa María (+385)", value: "385" },
  { label: "Santiago del Estero - Santiago del Estero (+385)", value: "385" },
  { label: "Santiago del Estero - Tramo 16 (+385)", value: "385" },
  { label: "Santiago del Estero - Villa Robles (+385)", value: "385" },
  { label: "Santiago del Estero - Vilmer (+385)", value: "385" },
  { label: "Santiago del Estero - Yanda (+385)", value: "385" },
  { label: "Santiago del Estero - Colonia Alpina (+3491)", value: "3491" },
  { label: "Santiago del Estero - Coronel Rico (+3841)", value: "3841" },
  { label: "Santiago del Estero - Los Pirpintos (+3841)", value: "3841" },
  { label: "Santiago del Estero - Monte Quemado (+3841)", value: "3841" },
  { label: "Santiago del Estero - Pampa de los Guanacos (+3841)", value: "3841" },
  { label: "Santiago del Estero - Sacháyoj (+3841)", value: "3841" },
  { label: "Santiago del Estero - Las Tinajas (+3843)", value: "3843" },
  { label: "Santiago del Estero - Quimilí (+3843)", value: "3843" },
  { label: "Santiago del Estero - Roversi (+3843)", value: "3843" },
  { label: "Santiago del Estero - Weisburd (+3843)", value: "3843" },
  { label: "Santiago del Estero - Añatuya (+3844)", value: "3844" },
  { label: "Santiago del Estero - Averías (+3844)", value: "3844" },
  { label: "Santiago del Estero - Colonia Dora (+3844)", value: "3844" },
  { label: "Santiago del Estero - Estación Tacañitas (+3844)", value: "3844" },
  { label: "Santiago del Estero - Garza (+3844)", value: "3844" },
  { label: "Santiago del Estero - Herrera (+3844)", value: "3844" },
  { label: "Santiago del Estero - Icaño (+3844)", value: "3844" },
  { label: "Santiago del Estero - Lugones (+3844)", value: "3844" },
  { label: "Santiago del Estero - Real Sayana (+3844)", value: "3844" },
  { label: "Santiago del Estero - Tomás Young (+3844)", value: "3844" },
  { label: "Santiago del Estero - Villa Salavina (+3844)", value: "3844" },
  { label: "Santiago del Estero - Brea Pozo (+3845)", value: "3845" },
  { label: "Santiago del Estero - Estación Atamisqui (+3845)", value: "3845" },
  { label: "Santiago del Estero - Loreto (+3845)", value: "3845" },
  { label: "Santiago del Estero - Medellín (+3845)", value: "3845" },
  { label: "Santiago del Estero - Nueva Francia (+3845)", value: "3845" },
  { label: "Santiago del Estero - Sumamao (+3845)", value: "3845" },
  { label: "Santiago del Estero - Villa Atamisqui (+3845)", value: "3845" },
  { label: "Santiago del Estero - Villa Silípica (+3845)", value: "3845" },
  { label: "Santiago del Estero - Campo Gallo (+3846)", value: "3846" },
  { label: "Santiago del Estero - Hasse (+3846)", value: "3846" },
  { label: "Santiago del Estero - Hernán Mejía Miraval (+3846)", value: "3846" },
  { label: "Santiago del Estero - Libertad (+3846)", value: "3846" },
  { label: "Santiago del Estero - Lilo Viejo (+3846)", value: "3846" },
  { label: "Santiago del Estero - Patay (+3846)", value: "3846" },
  { label: "Santiago del Estero - Tintina (+3846)", value: "3846" },
  { label: "Santiago del Estero - Ancaján (+3854)", value: "3854" },
  { label: "Santiago del Estero - Choya (+3854)", value: "3854" },
  { label: "Santiago del Estero - Estación La Punta (+3854)", value: "3854" },
  { label: "Santiago del Estero - Frías (+3854)", value: "3854" },
  { label: "Santiago del Estero - Laprida (+3854)", value: "3854" },
  { label: "Santiago del Estero - Lavalle (parte) (+3854)", value: "3854" },
  { label: "Santiago del Estero - San Pedro de Choya (+3854)", value: "3854" },
  { label: "Santiago del Estero - San Pedro de Guasayán (+3854)", value: "3854" },
  { label: "Santiago del Estero - Tapso (+3854)", value: "3854" },
  { label: "Santiago del Estero - Villa La Punta (+3854)", value: "3854" },
  { label: "Santiago del Estero - Bandera Bajada (+3855)", value: "3855" },
  { label: "Santiago del Estero - El Cuadrado (+3855)", value: "3855" },
  { label: "Santiago del Estero - La Cañada (+3855)", value: "3855" },
  { label: "Santiago del Estero - Matará (+3855)", value: "3855" },
  { label: "Santiago del Estero - Suncho Corral (+3855)", value: "3855" },
  { label: "Santiago del Estero - Vilelas (+3855)", value: "3855" },
  { label: "Santiago del Estero - Chilca Juliana (+3856)", value: "3856" },
  { label: "Santiago del Estero - Los Telares (+3856)", value: "3856" },
  { label: "Santiago del Estero - Ramírez de Velazco (+3856)", value: "3856" },
  { label: "Santiago del Estero - Sol de Julio (+3856)", value: "3856" },
  { label: "Santiago del Estero - Sumampa (+3856)", value: "3856" },
  { label: "Santiago del Estero - Sumampa Viejo (+3856)", value: "3856" },
  { label: "Santiago del Estero - Villa Ojo de Agua (+3856)", value: "3856" },
  { label: "Santiago del Estero - Bandera (+3857)", value: "3857" },
  { label: "Santiago del Estero - Fortín Inca (+3857)", value: "3857" },
  { label: "Santiago del Estero - Guardia Escolta (+3857)", value: "3857" },
  { label: "Santiago del Estero - Los Juríes (+3857)", value: "3857" },
  { label: "Santiago del Estero - Malbrán (+3857)", value: "3857" },
  { label: "Santiago del Estero - Palo Negro (+3857)", value: "3857" },
  { label: "Santiago del Estero - Pinto (+3857)", value: "3857" },
  { label: "Santiago del Estero - Selva (+3857)", value: "3857" },
  { label: "Santiago del Estero - Chauchillas (+3858)", value: "3858" },
  { label: "Santiago del Estero - Colonia Tinco (+3858)", value: "3858" },
  { label: "Santiago del Estero - El Charco (+3858)", value: "3858" },
  { label: "Santiago del Estero - Gramilla (+3858)", value: "3858" },
  { label: "Santiago del Estero - Pozo Hondo (+3858)", value: "3858" },
  { label: "Santiago del Estero - Pozuelos (+3858)", value: "3858" },
  { label: "Santiago del Estero - Termas de Río Hondo (+3858)", value: "3858" },
  { label: "Santiago del Estero - Villa Río Hondo (+3858)", value: "3858" },
  { label: "Santiago del Estero - Vinará (+3858)", value: "3858" },
  { label: "Santiago del Estero - El Mojón (+3861)", value: "3861" },
  { label: "Santiago del Estero - Las Delicias (+3861)", value: "3861" },
  { label: "Santiago del Estero - Nueva Esperanza (+3861)", value: "3861" },
  { label: "Santiago del Estero - Pozo Betbeder (+3861)", value: "3861" },
  { label: "Santiago del Estero - Rapelli (+3861)", value: "3861" },
  { label: "Tierra del Fuego - Lago Escondido (+2901)", value: "2901" },
  { label: "Tierra del Fuego - Tolhuin (+2901)", value: "2901" },
  { label: "Tierra del Fuego - Ushuaia (+2901)", value: "2901" },
  { label: "Tierra del Fuego - Río Grande (+2964)", value: "2964" },
  { label: "Tucumán - Alderetes (+381)", value: "381" },
  { label: "Tucumán - Barrio Aeropuerto (+381)", value: "381" },
  { label: "Tucumán - Bella Vista (+381)", value: "381" },
  { label: "Tucumán - Cebil Redondo (+381)", value: "381" },
  { label: "Tucumán - Colombres (+381)", value: "381" },
  { label: "Tucumán - Delfín Gallo (+381)", value: "381" },
  { label: "Tucumán - El Bracho (+381)", value: "381" },
  { label: "Tucumán - El Cadillal (+381)", value: "381" },
  { label: "Tucumán - El Chañar (+381)", value: "381" },
  { label: "Tucumán - El Corte (+381)", value: "381" },
  { label: "Tucumán - El Manantial (+381)", value: "381" },
  { label: "Tucumán - El Paraíso (+381)", value: "381" },
  { label: "Tucumán - Estación Aráoz (+381)", value: "381" },
  { label: "Tucumán - Ingenio San Pablo (+381)", value: "381" },
  { label: "Tucumán - La Florida (+381)", value: "381" },
  { label: "Tucumán - La Ramada (+381)", value: "381" },
  { label: "Tucumán - Lastenia (+381)", value: "381" },
  { label: "Tucumán - Los Gutiérrez (+381)", value: "381" },
  { label: "Tucumán - Lules (+381)", value: "381" },
  { label: "Tucumán - Manuel García Fernández (+381)", value: "381" },
  { label: "Tucumán - Pacará (+381)", value: "381" },
  { label: "Tucumán - Quilmes y Los Sueldos (+381)", value: "381" },
  { label: "Tucumán - San Andrés (+381)", value: "381" },
  { label: "Tucumán - San Miguel de Tucumán (+381)", value: "381" },
  { label: "Tucumán - Tafí Viejo (+381)", value: "381" },
  { label: "Tucumán - Villa Fiad (+381)", value: "381" },
  { label: "Tucumán - Villa Nougués (+381)", value: "381" },
  { label: "Tucumán - Yerba Buena (+381)", value: "381" },
  { label: "Tucumán - Choromoro (+3862)", value: "3862" },
  { label: "Tucumán - San Pedro de Colalao (+3862)", value: "3862" },
  { label: "Tucumán - Trancas (+3862)", value: "3862" },
  { label: "Tucumán - Acheral (+3863)", value: "3863" },
  { label: "Tucumán - Atahona (+3863)", value: "3863" },
  { label: "Tucumán - Barrio Casa Rosada (+3863)", value: "3863" },
  { label: "Tucumán - Campo de Herrera (+3863)", value: "3863" },
  { label: "Tucumán - Capitán Cáceres (+3863)", value: "3863" },
  { label: "Tucumán - Famaillá (+3863)", value: "3863" },
  { label: "Tucumán - Ingenio Fronterita (+3863)", value: "3863" },
  { label: "Tucumán - La Reducción (+3863)", value: "3863" },
  { label: "Tucumán - Los Puestos (+3863)", value: "3863" },
  { label: "Tucumán - Monteagudo (+3863)", value: "3863" },
  { label: "Tucumán - Monteros (+3863)", value: "3863" },
  { label: "Tucumán - Nueva Baviera (+3863)", value: "3863" },
  { label: "Tucumán - Río Colorado (+3863)", value: "3863" },
  { label: "Tucumán - Río Seco (+3863)", value: "3863" },
  { label: "Tucumán - Santa Lucía (+3863)", value: "3863" },
  { label: "Tucumán - Santa Rosa de Leales (+3863)", value: "3863" },
  { label: "Tucumán - Santa Rosa y Los Rojo (+3863)", value: "3863" },
  { label: "Tucumán - Sargento Moya (+3863)", value: "3863" },
  { label: "Tucumán - Simoca (+3863)", value: "3863" },
  { label: "Tucumán - Soldado Maldonado (+3863)", value: "3863" },
  { label: "Tucumán - Teniente Berdina (+3863)", value: "3863" },
  { label: "Tucumán - Villa Chicligasta (+3863)", value: "3863" },
  { label: "Tucumán - Villa de Leales (+3863)", value: "3863" },
  { label: "Tucumán - Villa Quinteros (+3863)", value: "3863" },
  { label: "Tucumán - Yerba Buena (Simoca) (+3863)", value: "3863" },
  { label: "Tucumán - Aguilares (+3865)", value: "3865" },
  { label: "Tucumán - Alpachiri (+3865)", value: "3865" },
  { label: "Tucumán - Alto Verde (+3865)", value: "3865" },
  { label: "Tucumán - Arcadia (+3865)", value: "3865" },
  { label: "Tucumán - Concepción (+3865)", value: "3865" },
  { label: "Tucumán - Ingenio La Trinidad (+3865)", value: "3865" },
  { label: "Tucumán - Juan Bautista Alberdi (+3865)", value: "3865" },
  { label: "Tucumán - La Cocha (+3865)", value: "3865" },
  { label: "Tucumán - Los Sarmientos (+3865)", value: "3865" },
  { label: "Tucumán - Medinas (+3865)", value: "3865" },
  { label: "Tucumán - Rumi Punco (+3865)", value: "3865" },
  { label: "Tucumán - San José de la Cocha (+3865)", value: "3865" },
  { label: "Tucumán - Santa Ana (+3865)", value: "3865" },
  { label: "Tucumán - Villa Belgrano (+3865)", value: "3865" },
  { label: "Tucumán - El Mollar (+3867)", value: "3867" },
  { label: "Tucumán - Tafí del Valle (+3867)", value: "3867" },
  { label: "Tucumán - Colonia Mayo (+3869)", value: "3869" },
  { label: "Tucumán - Las Cejas (+3869)", value: "3869" },
  { label: "Tucumán - Los Ralos (+3869)", value: "3869" },
  { label: "Tucumán - Ranchillos y San Miguel (+3869)", value: "3869" },
  { label: "Tucumán - Villa Rescate (+3869)", value: "3869" },
  { label: "Tucumán - Villa Tercera (+3869)", value: "3869" },
  { label: "Tucumán - Graneros (+3891)", value: "3891" },
  { label: "Tucumán - Lamadrid (+3891)", value: "3891" },
  { label: "Tucumán - Taco Ralo (+3891)", value: "3891" },
  { label: "Tucumán - Amaicha del Valle (+3892)", value: "3892" },
  { label: "Tucumán - Anca Juli (+3892)", value: "3892" },
  { label: "Tucumán - Colalao del Valle (+3892)", value: "3892" },
  { label: "Tucumán - Barrio San Jorge (+3894)", value: "3894" },
  { label: "Tucumán - Burruyacú (+3894)", value: "3894" },
  { label: "Tucumán - El Naranjo (+3894)", value: "3894" },
  { label: "Tucumán - Gobernador Garmendia (+3894)", value: "3894" },
  { label: "Tucumán - Piedrabuena (+3894)", value: "3894" },
  { label: "Tucumán - San José de Macomitas (+3894)", value: "3894" },
  { label: "Tucumán - Siete de Abril (+3894)", value: "3894" },
  { label: "Tucumán - Villa Benjamín Aráoz (+3894)", value: "3894" },
  { label: "Tucumán - Villa Padre Monti (+3894)", value: "3894" },
  { label: "Buenos Aires - Atalaya (+2221)", value: "2221" },
  { label: "Buenos Aires - JOSE FERRARI (+2221)", value: "2221" },
  { label: "Buenos Aires - MAGDALENA (+2221)", value: "2221" },
  { label: "Buenos Aires - PIPINAS (+2221)", value: "2221" },
  { label: "Buenos Aires - PUNTA INDIO (+2221)", value: "2221" },
  { label: "Buenos Aires - VERONICA (+2221)", value: "2221" },
  { label: "Buenos Aires - VIEYTES (+2221)", value: "2221" },
  { label: "Buenos Aires - CAMPOS SALLES (+336)", value: "336" },
  { label: "Buenos Aires - CONESA (+336)", value: "336" },
  { label: "Buenos Aires - GENERAL ROJO (+336)", value: "336" },
  { label: "Buenos Aires - SAN NICOLAS (+336)", value: "336" },
  { label: "Santa Fe - AERODROMO SAUCE VIEJO (+342)", value: "342" },
  { label: "Santa Fe - ARROYO AGUIAR (+342)", value: "342" },
  { label: "Santa Fe - COLASTINE (+342)", value: "342" },
  { label: "Santa Fe - COLONIA LOS ZAPALLOS (+342)", value: "342" },
  { label: "Santa Fe - COLONIA SAN JOSE (+342)", value: "342" },
  { label: "Santa Fe - CORONDA (+342)", value: "342" },
  { label: "Santa Fe - DESVIO ARIJON (+342)", value: "342" },
  { label: "Santa Fe - EMPALME SAN CARLOS (+342)", value: "342" },
  { label: "Santa Fe - FRANCK (+342)", value: "342" },
  { label: "Santa Fe - GOBERNADOR CANDIOTI (+342)", value: "342" },
  { label: "Santa Fe - LAGUNA PAIVA (+342)", value: "342" },
  { label: "Santa Fe - LAS TUNAS (+342)", value: "342" },
  { label: "Santa Fe - MANUCHO (+342)", value: "342" },
  { label: "Santa Fe - MATILDE (+342)", value: "342" },
  { label: "Santa Fe - MONTE VERA (+342)", value: "342" },
  { label: "Santa Fe - NELSON (+342)", value: "342" },
  { label: "Santa Fe - RECREO (PROV. SANTA FE) (+342)", value: "342" },
  { label: "Santa Fe - SAN AGUSTIN (PROV. SANTA FE) (+342)", value: "342" },
  { label: "Santa Fe - SAN JOSE DEL RINCON (+342)", value: "342" },
  { label: "Santa Fe - SANTA FE (+342)", value: "342" },
  { label: "Santa Fe - SANTA ROSA (PROV. SANTA FE) (+342)", value: "342" },
  { label: "Santa Fe - SAUCE VIEJO (+342)", value: "342" }
];
